import _Checkbox from 'antd/es/checkbox';
import _ConfigProvider, { globalConfig } from 'antd/es/config-provider';
import styled, { css, createGlobalStyle, keyframes, useTheme } from 'styled-components';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { ChevronDown, Checkmark, MagnifyingGlass, Calendar, Error as Error$1, Document, Cross, Loading, ExternalLink, Info, Warning, SmallChevronUp, SmallChevronDown, ArrowCircle, ChevronLeft, CircleCross, CheckmarkCircle, CalendarNew, ChevronRight } from '@helloworld1812/ws-icons';
import { Avatar as Avatar$1, getColor, FlexBox, Typography, colors, Text, ButtonNew, Dropdown, message, Tooltip, Button, theme, Modal, Checkbox as Checkbox$1, Radio as Radio$1 } from '@helloworld1812/ws-components';
import _Select from 'antd/es/select';
import React, { forwardRef, useState, useMemo, useCallback, useImperativeHandle, useRef, useEffect, cloneElement, useLayoutEffect, createContext, memo, useReducer, useContext } from 'react';
import _Input from 'antd/es/input';
import { colors as colors$1, getColor as getColor$1 } from '@helloworld1812/ws-theme';
import 'react-intl-tel-input/dist/main.css';
import country from 'country-list-js';
import classNames from 'classnames';
import ReactIntlTelInput from 'react-intl-tel-input';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import generatePicker from 'antd/es/date-picker/generatePicker';
import 'antd/es/date-picker/style/index';
import { noop as noop$2, isFunction, capitalize, debounce, toArray, isEmpty } from 'lodash';
import { CheckOutlined } from '@ant-design/icons';
import _Col from 'antd/es/col';
import _Row from 'antd/es/row';
import _Drawer from 'antd/es/drawer';
import _Space from 'antd/es/space';
import _InputNumber from 'antd/es/input-number';
import _Upload from 'antd/es/upload';
import _Table from 'antd/es/table';
import _Menu from 'antd/es/menu';
import _Alert from 'antd/es/alert';
import { serialize } from 'object-to-formdata';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import _Radio from 'antd/es/radio';
import _Switch from 'antd/es/switch';
import _Spin from 'antd/es/spin';
import _Pagination from 'antd/es/pagination';
import _Dropdown from 'antd/es/dropdown';
import _Divider from 'antd/es/divider';
import ReactInfiniteScrollComponent from 'react-infinite-scroll-component';
import { useClickOutside } from '@helloworld1812/ws-hooks';
import useUrlState from '@ahooksjs/use-url-state';
import { useDebounce, usePrevious as usePrevious$1 } from 'ahooks';
import _Popover from 'antd/es/popover';
import _Collapse from 'antd/es/collapse';
import _Tag from 'antd/es/tag';
import _TreeSelect, { TreeNode } from 'antd/es/tree-select';
import _notification from 'antd/es/notification';
import { useFeatureIsOn } from '@helloworld1812/ws-growthbook';
import { unstable_batchedUpdates, createPortal } from 'react-dom';

const Checkbox = /*#__PURE__*/styled(_Checkbox).withConfig({
  displayName: "checkbox__Checkbox",
  componentId: "sc-1eaerrq-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["font-weight:normal;font-size:14px;font-family:'Plus Jakarta Sans',sans-serif;display:flex;align-items:center;& .", "-checkbox{top:unset;}& .", "-checkbox-inner{width:18px;height:18px;border-radius:4px;&:after{left:4px;top:7px;width:5px;height:9px;}}& .", "-checkbox-indeterminate .", "-checkbox-inner:after{left:8px;top:8px;width:10px;height:2px;background-color:", ";}& .", "-checkbox-checked .", "-checkbox-inner,& .", "-checkbox-indeterminate .", "-checkbox-inner{background-color:", ";border-color:", ";}&.", "-checkbox-wrapper:hover .", "-checkbox-inner,& .", "-checkbox:hover .", "-checkbox-inner,& .", "-checkbox-input:focus + .", "-checkbox-inner{border-color:", ";}& .", "-checkbox-checked::after{border:unset;}& .", "-checkbox-disabled .", "-checkbox-inner,& .", "-checkbox-indeterminate .", "-checkbox-inner{background-color:", ";border-color:", ";}& .", "-checkbox-disabled.", "-checkbox-checked .", "-checkbox-inner::after{border-color:white;}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.white, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray400, props.theme.colors.gray400, antdCssPrefix, antdCssPrefix, antdCssPrefix);
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$n =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$o = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$n = fails$o;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$n(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$m = fails$o;

var functionBindNative = !fails$m(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$l = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$l.bind(call$l) : function () {
  return call$l.apply(call$l, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$3(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$3 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$k = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$k, call$k);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$k.apply(fn, arguments);
  };
};

var uncurryThis$m = functionUncurryThis;

var toString$b = uncurryThis$m({}.toString);
var stringSlice$6 = uncurryThis$m(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$6(toString$b(it), 8, -1);
};

var uncurryThis$l = functionUncurryThis;
var fails$l = fails$o;
var classof$8 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$l(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$l(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$8(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$7 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$6 = isNullOrUndefined$7;

var $TypeError$h = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$8 = function (it) {
  if (isNullOrUndefined$6(it)) throw new $TypeError$h("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$2 = indexedObject;
var requireObjectCoercible$7 = requireObjectCoercible$8;

var toIndexedObject$5 = function (it) {
  return IndexedObject$2(requireObjectCoercible$7(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$o = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$n = isCallable$o;

var isObject$d = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$n(it);
};

var global$m = global$n;
var isCallable$m = isCallable$o;

var aFunction = function (argument) {
  return isCallable$m(argument) ? argument : undefined;
};

var getBuiltIn$8 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global$m[namespace]) : global$m[namespace] && global$m[namespace][method];
};

var uncurryThis$k = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$k({}.isPrototypeOf);

var engineUserAgent = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

var global$l = global$n;
var userAgent$3 = engineUserAgent;

var process$3 = global$l.process;
var Deno$1 = global$l.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$3) {
  match = userAgent$3.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$3.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var engineV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = engineV8Version;
var fails$k = fails$o;
var global$k = global$n;

var $String$5 = global$k.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$k(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$5(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$2 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var getBuiltIn$7 = getBuiltIn$8;
var isCallable$l = isCallable$o;
var isPrototypeOf$4 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$2 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$7('Symbol');
  return isCallable$l($Symbol) && isPrototypeOf$4($Symbol.prototype, $Object$3(it));
};

var $String$4 = String;

var tryToString$4 = function (argument) {
  try {
    return $String$4(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$k = isCallable$o;
var tryToString$3 = tryToString$4;

var $TypeError$g = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$b = function (argument) {
  if (isCallable$k(argument)) return argument;
  throw new $TypeError$g(tryToString$3(argument) + ' is not a function');
};

var aCallable$a = aCallable$b;
var isNullOrUndefined$5 = isNullOrUndefined$7;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$5 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$5(func) ? undefined : aCallable$a(func);
};

var call$j = functionCall;
var isCallable$j = isCallable$o;
var isObject$c = isObject$d;

var $TypeError$f = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$j(fn = input.toString) && !isObject$c(val = call$j(fn, input))) return val;
  if (isCallable$j(fn = input.valueOf) && !isObject$c(val = call$j(fn, input))) return val;
  if (pref !== 'string' && isCallable$j(fn = input.toString) && !isObject$c(val = call$j(fn, input))) return val;
  throw new $TypeError$f("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var global$j = global$n;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$6(global$j, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global$j[key] = value;
  } return value;
};

var globalThis$1 = global$n;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$1[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.36.1',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var store$2 = sharedStore.exports;

var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$6 = requireObjectCoercible$8;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$7 = function (argument) {
  return $Object$2(requireObjectCoercible$6(argument));
};

var uncurryThis$j = functionUncurryThis;
var toObject$6 = toObject$7;

var hasOwnProperty = uncurryThis$j({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$6(it), key);
};

var uncurryThis$i = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$a = uncurryThis$i(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$a(++id + postfix, 36);
};

var global$i = global$n;
var shared$3 = shared$4;
var hasOwn$b = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$2 = global$i.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$j = function (name) {
  if (!hasOwn$b(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$1 && hasOwn$b(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$i = functionCall;
var isObject$b = isObject$d;
var isSymbol$1 = isSymbol$2;
var getMethod$4 = getMethod$5;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$i = wellKnownSymbol$j;

var $TypeError$e = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$i('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$b(input) || isSymbol$1(input)) return input;
  var exoticToPrim = getMethod$4(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$i(exoticToPrim, input, pref);
    if (!isObject$b(result) || isSymbol$1(result)) return result;
    throw new $TypeError$e("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol = isSymbol$2;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};

var global$h = global$n;
var isObject$a = isObject$d;

var document$3 = global$h.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$a(document$3) && isObject$a(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$d = descriptors;
var fails$j = fails$o;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$d && !fails$j(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$c = descriptors;
var call$h = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$2 = createPropertyDescriptor$3;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$a = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$c ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$a(O, P)) return createPropertyDescriptor$2(!call$h(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$b = descriptors;
var fails$i = fails$o;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$b && fails$i(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$9 = isObject$d;

var $String$3 = String;
var $TypeError$d = TypeError;

// `Assert: Type(argument) is Object`
var anObject$f = function (argument) {
  if (isObject$9(argument)) return argument;
  throw new $TypeError$d($String$3(argument) + ' is not an object');
};

var DESCRIPTORS$a = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$e = anObject$f;
var toPropertyKey = toPropertyKey$2;

var $TypeError$c = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$a ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$e(O);
  P = toPropertyKey(P);
  anObject$e(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$e(O);
  P = toPropertyKey(P);
  anObject$e(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$c('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$9 = descriptors;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$1 = createPropertyDescriptor$3;

var createNonEnumerableProperty$5 = DESCRIPTORS$9 ? function (object, key, value) {
  return definePropertyModule$3.f(object, key, createPropertyDescriptor$1(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$8 = descriptors;
var hasOwn$9 = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$8 && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$9(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$8 || (DESCRIPTORS$8 && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$h = functionUncurryThis;
var isCallable$i = isCallable$o;
var store$1 = sharedStore.exports;

var functionToString = uncurryThis$h(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$i(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var global$g = global$n;
var isCallable$h = isCallable$o;

var WeakMap$1 = global$g.WeakMap;

var weakMapBasicDetection = isCallable$h(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var global$f = global$n;
var isObject$8 = isObject$d;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$5;
var hasOwn$8 = hasOwnProperty_1;
var shared$1 = sharedStore.exports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = global$f.TypeError;
var WeakMap = global$f.WeakMap;
var set$2, get$1, has;

var enforce = function (it) {
  return has(it) ? get$1(it) : set$2(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$8(it) || (state = get$1(it)).type !== TYPE) {
      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$2 = function (it, metadata) {
    if (store.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$2 = function (it, metadata) {
    if (hasOwn$8(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$4(it, STATE, metadata);
    return metadata;
  };
  get$1 = function (it) {
    return hasOwn$8(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$8(it, STATE);
  };
}

var internalState = {
  set: set$2,
  get: get$1,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$g = functionUncurryThis;
var fails$h = fails$o;
var isCallable$g = isCallable$o;
var hasOwn$7 = hasOwnProperty_1;
var DESCRIPTORS$7 = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$2 = internalState;

var enforceInternalState = InternalStateModule$2.enforce;
var getInternalState$2 = InternalStateModule$2.get;
var $String$2 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$5 = Object.defineProperty;
var stringSlice$5 = uncurryThis$g(''.slice);
var replace$4 = uncurryThis$g(''.replace);
var join = uncurryThis$g([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$7 && !fails$h(function () {
  return defineProperty$5(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$5($String$2(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$4($String$2(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$7(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$7) defineProperty$5(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$7(options, 'arity') && value.length !== options.arity) {
    defineProperty$5(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$7(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$7) defineProperty$5(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$7(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$g(this) && getInternalState$2(this).source || inspectSource$2(this);
}, 'toString');

var isCallable$f = isCallable$o;
var definePropertyModule$2 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltIn$3.exports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$8 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$f(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$2.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$4 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;

var max$1 = Math.max;
var min$2 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$3(index);
  return integer < 0 ? max$1(integer + length, 0) : min$2(integer, length);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;

var min$1 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  var len = toIntegerOrInfinity$2(argument);
  return len > 0 ? min$1(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$2 = toLength$3;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$6 = function (obj) {
  return toLength$2(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$5 = lengthOfArrayLike$6;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$3 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$5(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$3(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$3(false)
};

var uncurryThis$f = functionUncurryThis;
var hasOwn$6 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$1 = uncurryThis$f([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$6(hiddenKeys$2, key) && hasOwn$6(O, key) && push$1(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$6(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$1(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$6 = getBuiltIn$8;
var uncurryThis$e = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$d = anObject$f;

var concat$2 = uncurryThis$e([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$6('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$d(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$5 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$1 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$1.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$5(target, key) && !(exceptions && hasOwn$5(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$g = fails$o;
var isCallable$e = isCallable$o;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$e(detection) ? fails$g(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var global$e = global$n;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$5;
var defineBuiltIn$7 = defineBuiltIn$8;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$e;
  } else if (STATIC) {
    target = global$e[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = global$e[TARGET] && global$e[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$2(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$3(sourceProperty, 'sham', true);
    }
    defineBuiltIn$7(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$6 = descriptors;
var uncurryThis$d = functionUncurryThis;
var call$g = functionCall;
var fails$f = fails$o;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$5 = toObject$7;
var IndexedObject$1 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$4 = Object.defineProperty;
var concat$1 = uncurryThis$d([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$f(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$6 && $assign({ b: 1 }, $assign(defineProperty$4({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$4(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys$1($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$5(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject$1(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$6 || call$g(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$i = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$i({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const UnshadowedContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "card__UnshadowedContainer",
  componentId: "sc-1tkweqd-0"
})(["display:flex;flex-direction:column;border-radius:12px;background-color:white;"]);
function UnshadowedCard(_a) {
  var {
      className,
      children
    } = _a,
    otherProps = __rest(_a, ["className", "children"]);
  return jsx(UnshadowedContainer, Object.assign({
    className: className
  }, otherProps, {
    children: children
  }));
}

const Card = _a => {
  var {
      shadowed = false,
      className
    } = _a,
    otherProps = __rest(_a, ["shadowed", "className"]);
  return jsx(UnshadowedCard, Object.assign({
    className: className
  }, otherProps));
};
const StyledCard = /*#__PURE__*/styled(Card).withConfig({
  displayName: "card-v2__StyledCard",
  componentId: "sc-rfuu2j-0"
})(["", ";padding:20px;"], props => props.shadowed && 'box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.06), 0px 1px 3px rgba(0, 0, 0, 0.1)');
const CardV2 = props => {
  return jsx(StyledCard, Object.assign({}, props));
};

/** @deprecated, prefer to use Avatar from ws-components */
const Avatar = props => {
  const {
    src,
    alt
  } = props;
  if (src && !alt) {
    console.warn('[Avatar(hr-ui)] must have alt prop defined if src is defined! Now src is used as alt.');
  }
  return jsx(Avatar$1, Object.assign({
    "$bgColor": "blue500",
    "$size": "large",
    alt: src
  }, props));
};

var wellKnownSymbol$h = wellKnownSymbol$j;

var TO_STRING_TAG$2 = wellKnownSymbol$h('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$d = isCallable$o;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$g = wellKnownSymbol$j;

var TO_STRING_TAG$1 = wellKnownSymbol$g('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$7 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$d(O.callee) ? 'Arguments' : result;
};

var classof$6 = classof$7;

var $String$1 = String;

var toString$9 = function (argument) {
  if (classof$6(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

var makeBuiltIn = makeBuiltIn$3.exports;
var defineProperty$3 = objectDefineProperty;

var defineBuiltInAccessor$2 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$3.f(target, name, descriptor);
};

var $$h = _export;
var DESCRIPTORS$5 = descriptors;
var global$d = global$n;
var uncurryThis$c = functionUncurryThis;
var hasOwn$4 = hasOwnProperty_1;
var isCallable$c = isCallable$o;
var isPrototypeOf$3 = objectIsPrototypeOf;
var toString$8 = toString$9;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$2;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$d.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$5 && isCallable$c(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString$8(arguments[0]);
    var result = isPrototypeOf$3(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis$c(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis$c(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace$3 = uncurryThis$c(''.replace);
  var stringSlice$4 = uncurryThis$c(''.slice);

  defineBuiltInAccessor$1(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn$4(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice$4(string, 7, -1) : replace$3(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$h({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var objectDefineProperties = {};

var DESCRIPTORS$4 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule = objectDefineProperty;
var anObject$c = anObject$f;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$4 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$c(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};

var getBuiltIn$5 = getBuiltIn$8;

var html$2 = getBuiltIn$5('document', 'documentElement');

/* global ActiveXObject -- old IE, WSH */
var anObject$b = anObject$f;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html$1 = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html$1.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$b(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$f = wellKnownSymbol$j;
var create$2 = objectCreate;
var defineProperty$2 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$f('unscopables');
var ArrayPrototype$1 = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype$1[UNSCOPABLES] === undefined) {
  defineProperty$2(ArrayPrototype$1, UNSCOPABLES, {
    configurable: true,
    value: create$2(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype$1[UNSCOPABLES][key] = true;
};

var iterators = {};

var fails$e = fails$o;

var correctPrototypeGetter = !fails$e(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$3 = hasOwnProperty_1;
var isCallable$b = isCallable$o;
var toObject$4 = toObject$7;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$4(O);
  if (hasOwn$3(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$b(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails$d = fails$o;
var isCallable$a = isCallable$o;
var isObject$7 = isObject$d;
var getPrototypeOf$1 = objectGetPrototypeOf;
var defineBuiltIn$6 = defineBuiltIn$8;
var wellKnownSymbol$e = wellKnownSymbol$j;

var ITERATOR$6 = wellKnownSymbol$e('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$1(getPrototypeOf$1(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$7(IteratorPrototype$2) || fails$d(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$6].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$a(IteratorPrototype$2[ITERATOR$6])) {
  defineBuiltIn$6(IteratorPrototype$2, ITERATOR$6, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var defineProperty$1 = objectDefineProperty.f;
var hasOwn$2 = hasOwnProperty_1;
var wellKnownSymbol$d = wellKnownSymbol$j;

var TO_STRING_TAG = wellKnownSymbol$d('toStringTag');

var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$2(target, TO_STRING_TAG)) {
    defineProperty$1(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$1 = objectCreate;
var createPropertyDescriptor = createPropertyDescriptor$3;
var setToStringTag$3 = setToStringTag$4;
var Iterators$4 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$1(IteratorPrototype$1, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag$3(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$4[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var uncurryThis$b = functionUncurryThis;
var aCallable$9 = aCallable$b;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$b(aCallable$9(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$6 = isObject$d;

var isPossiblePrototype$1 = function (argument) {
  return isObject$6(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String = String;
var $TypeError$b = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$b("Can't set " + $String(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject$5 = isObject$d;
var requireObjectCoercible$5 = requireObjectCoercible$8;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$5(O);
    aPossiblePrototype(proto);
    if (!isObject$5(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var $$g = _export;
var call$f = functionCall;
var FunctionName = functionName;
var isCallable$9 = isCallable$o;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf = objectGetPrototypeOf;
var setPrototypeOf$1 = objectSetPrototypeOf;
var setToStringTag$2 = setToStringTag$4;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$5;
var defineBuiltIn$5 = defineBuiltIn$8;
var wellKnownSymbol$c = wellKnownSymbol$j;
var Iterators$3 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$5 = wellKnownSymbol$c('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$5]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf$1) {
          setPrototypeOf$1(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable$9(CurrentIteratorPrototype[ITERATOR$5])) {
          defineBuiltIn$5(CurrentIteratorPrototype, ITERATOR$5, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$2(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$2(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$f(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$5(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$g({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$5] !== defaultIterator) {
    defineBuiltIn$5(IterablePrototype, ITERATOR$5, defaultIterator, { name: DEFAULT });
  }
  Iterators$3[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$1 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators$2 = iterators;
var InternalStateModule$1 = internalState;
var defineProperty = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject = createIterResultObject$1;
var DESCRIPTORS$3 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators$2.Arguments = Iterators$2.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$3 && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var global$c = global$n;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$5;
var setToStringTag$1 = setToStringTag$4;
var wellKnownSymbol$b = wellKnownSymbol$j;

var ITERATOR$4 = wellKnownSymbol$b('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$4] !== ArrayValues) try {
      createNonEnumerableProperty$1(CollectionPrototype, ITERATOR$4, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$4] = ArrayValues;
    }
    setToStringTag$1(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global$c[COLLECTION_NAME] && global$c[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

const GlobalStyle$3 = /*#__PURE__*/createGlobalStyle(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css([".new-select-antd.", "-select-dropdown{box-shadow:0px 2px 2px rgb(0 0 0 / 8%),0px 4px 8px rgb(0 0 0 / 12%);border-radius:8px;padding:8px 0;}.new-select-antd .", "-select-item-option{padding:12px 16px;line-height:24px;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;&:hover{background-color:", ";}&.", "-select-item-option-selected,&.", "-select-item-option-active{background-color:transparent;&:hover{background-color:", ";}}p{display:inline;}&.", "-select-item-option-selected p{font-weight:600 !important;}&.", "-select-item-option-selected:hover{background-color:", ";}}.", "-select-item-option-disabled{background-color:", ";&:hover{background-color:", " !important;cursor:not-allowed;}p{color:", " !important;}}"], antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray100'), antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray100'), antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray100'), antdCssPrefix, ({
    theme
  }) => theme.getColor('gray200'), ({
    theme
  }) => theme.getColor('gray200'), getColor('gray400'));
});
const StyledSelect = /*#__PURE__*/styled(_Select).withConfig({
  displayName: "select-v2__StyledSelect",
  componentId: "sc-xd5lrk-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  const {
    hidedescriptiononselecteditem,
    showSelectedItemDuringDropDown,
    hasError,
    theme
  } = props;
  return css(["&.", "-select{&:not( .", "-select-customize-input ).", "-select-focused:not(.", "-select-disabled){& > .", "-select-selector{box-shadow:none;border:1px solid ", ";}}&.", "-select-open{& > .", "-select-selector{display:flex;box-shadow:none;border:1px solid ", ";.arrow-up-icon{display:initial;color:", ";}.arrow-down-icon{display:none;}}}.", "-select-selection-item{color:", ";}&.", "-select-open{& > .", "-select-selector{box-shadow:none;.", "-select-selection-item{.value{opacity:", ";}}}.", "-select-selection-search{display:flex;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;.", "-select-selection-search-input{height:auto;}}}&.", "-select-lg{.", "-select-selector{height:40px;}}& .", "-select-selector{border:1px solid ", ";border-radius:8px;padding:7px 16px;height:42px;display:flex;justify-content:center;align-items:center;p{display:inline;}.", "-select-selector__placeholder{height:24px;color:", ";font-size:14px;width:100%;}.", "-select-selection-search{display:flex;.", "-select-selection-search-input{height:auto;}}}.", "-select-selector__rendered{line-height:20px;margin:0;display:flex;align-items:center;}& .", "-select-selection-item{display:flex;flex-grow:1;padding-right:0;opacity:1 !important;.description{display:", ";}.check-icon{display:none;}.arrow-up-icon{display:none;}}& .", "-select-arrow{color:", ";right:16px;}.", "-select-dropdown-menu-item-disabled{background-color:red;}.", "-select-selection__clear{right:14px;font-size:20px;width:20px;height:20px;line-height:20px;top:15px;color:", ";}&:not(.", "-select-disabled):hover .", "-select-selector{border-color:", ";background:", ";}}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray900'), antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray900'), ({
    theme
  }) => theme.getColor('gray900'), antdCssPrefix, ({
    theme
  }) => theme.getColor('textPrimary'), antdCssPrefix, antdCssPrefix, antdCssPrefix, showSelectedItemDuringDropDown ? 1 : 0, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, hasError ? theme.getColor('red500') : theme.getColor('gray400'), antdCssPrefix, ({
    theme
  }) => theme.getColor('gray900'), antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, hidedescriptiononselecteditem ? 'none' : 'inherit', antdCssPrefix, ({
    theme
  }) => theme.getColor('iconDefault'), antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray600'), antdCssPrefix, antdCssPrefix, ({
    theme
  }) => theme.getColor('gray300'), ({
    theme
  }) => theme.getColor('gray100'));
});
const Select$1 = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      options = [],
      value,
      suffixIcon = jsx(ChevronDown, {
        size: 24
      }),
      onChange,
      onSearch,
      footer,
      selectItemDataTestIdPrefix,
      hasError,
      showCheckIcon = true
    } = props,
    restProps = __rest(props, ["options", "value", "suffixIcon", "onChange", "onSearch", "footer", "selectItemDataTestIdPrefix", "hasError", "showCheckIcon"]);
  const [ts] = useState(Date.now());
  // NOTE: hasError is not a valid prop for AntdSelect, so we need to remove it from the rest of the props
  // Otherwise we will see a warning in the console like:
  // "Warning: React does not recognize the `hasError` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `haserror` instead. If you accidentally passed it from a parent component, remove it from the DOM element."
  return jsxs(Fragment, {
    children: [jsx(GlobalStyle$3, {}), jsxs(StyledSelect, Object.assign({
      ref: ref
    }, value != null ? {
      value
    } : {
      value: undefined
    }, {
      onSearch: onSearch,
      popupClassName: "new-select-antd",
      onChange: onChange,
      suffixIcon: suffixIcon
    }, restProps, {
      children: [options === null || options === void 0 ? void 0 : options.map(opt => {
        if (opt.label && opt.options) {
          // groupped options
          return jsx(_Select.OptGroup, {
            label: opt.label,
            title: opt.title,
            children: opt.options.map(o => {
              // normal options
              const {
                render
              } = o;
              const hasTopDivider = o.divider;
              const rowStyle = {
                borderTop: `1px solid ${getColor('gray300')}`
              };
              return jsx(_Select.Option, {
                value: o.value,
                title: o.title,
                disabled: !!o.disabled,
                style: hasTopDivider ? rowStyle : {},
                "data-testid": `${selectItemDataTestIdPrefix}-${opt.value}`,
                children: jsxs("div", {
                  style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    height: 'auto'
                  },
                  children: [jsx("span", {
                    style: {
                      minWidth: 0,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    },
                    children: render ? render(o) : jsxs(FlexBox, {
                      align: "center",
                      children: [o.prefixIcon && jsx("span", {
                        style: {
                          marginRight: '16px'
                        },
                        children: o.prefixIcon
                      }), jsxs(FlexBox, {
                        column: true,
                        children: [jsx(Typography, {
                          className: "value",
                          children: o.title
                        }), jsx(Typography, {
                          className: "value description",
                          color: o.disabled ? 'gray400' : 'gray600',
                          children: o.description
                        }), o.descriptionNode]
                      })]
                    })
                  }), showCheckIcon && jsx("span", {
                    className: "check-icon",
                    style: {
                      height: 24,
                      flex: 0,
                      flexBasis: 24
                    },
                    children: value === o.value ? jsx(Checkmark, {}) : null
                  })]
                })
              }, o.key || o.value);
            })
          }, opt.key || opt.label);
        } else {
          // normal options
          const {
            render
          } = opt;
          const hasTopDivider = opt.divider;
          const rowStyle = {
            borderTop: `1px solid ${getColor('gray300')}`
          };
          return jsx(_Select.Option, {
            value: opt.value,
            title: opt.title,
            disabled: !!opt.disabled,
            style: hasTopDivider ? rowStyle : {},
            "data-testid": `${selectItemDataTestIdPrefix}-${opt.value}`,
            children: jsxs("div", {
              style: {
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                height: 'auto'
              },
              children: [jsx("span", {
                style: {
                  minWidth: 0,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                },
                children: render ? render(opt) : jsxs(FlexBox, {
                  align: "center",
                  children: [opt.prefixIcon && jsx("span", {
                    style: {
                      marginRight: '16px'
                    },
                    children: opt.prefixIcon
                  }), jsxs(FlexBox, {
                    column: true,
                    children: [jsx(Typography, {
                      className: "value",
                      variant: "default",
                      children: opt.title
                    }), jsx(Typography, {
                      fontWeight: 400,
                      className: "value description",
                      color: opt.disabled ? 'gray400' : 'gray600',
                      children: opt.description
                    }), opt.descriptionNode]
                  })]
                })
              }), showCheckIcon && jsx("span", {
                className: "check-icon",
                style: {
                  height: 24,
                  flex: 0,
                  flexBasis: 24
                },
                children: value === opt.value ? jsx(Checkmark, {
                  color: colors.iconDefault
                }) : null
              })]
            })
          }, opt.key || opt.value);
        }
      }), footer && jsx("div", {
        style: {
          borderTop: `1px solid ${getColor('gray300')}`
        },
        children: footer
      })]
    }), ts)]
  });
});

const Row = /*#__PURE__*/styled.div.withConfig({
  displayName: "container__Row",
  componentId: "sc-pfgca8-0"
})([""]);
const Container$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "container__Container",
  componentId: "sc-pfgca8-1"
})(["display:flex;flex-direction:column;& > ", "{display:flex;& ~ ", "{margin-top:20px;}}"], Row, Row);

const Examples = props => {
  const [value, setValue] = useState('value1');
  const [gouppedExampleValue, setGouppedExampleValue] = useState('');
  return jsxs(Container$2, {
    children: [jsx(Row, {
      children: jsx(Typography, {
        variant: "h3",
        children: "Select v2 examples"
      })
    }), jsx(Row, {
      children: jsx(Select$1, {
        value: value,
        onChange: val => setValue(val),
        options: [{
          value: 'value1',
          title: 'value1'
        }, {
          value: 'value2',
          title: 'value2'
        }, {
          value: 'value3',
          title: 'value3'
        }, {
          value: 'value4',
          title: 'value4'
        }],
        style: {
          width: '200px'
        }
      })
    }), jsx(Row, {
      children: jsx(Typography, {
        variant: "h3",
        children: "With descriptions in options, but hide the desc in selected item"
      })
    }), jsx(Row, {
      children: jsx(Select$1, {
        value: value,
        allowClear: true,
        showSearch: true,
        hidedescriptiononselecteditem: true,
        onChange: val => setValue(val),
        options: [{
          value: 'value1',
          title: 'value1',
          description: 'description1'
        }, {
          value: 'value2',
          title: 'value2',
          description: 'description2'
        }, {
          value: 'value3',
          title: 'value3',
          description: 'description3'
        }, {
          value: 'value4',
          title: 'value4'
        }],
        style: {
          width: '200px'
        }
      })
    }), jsx(Row, {
      children: jsx(Typography, {
        variant: "h3",
        children: "With descriptions in options, and show the desc in selected item"
      })
    }), jsx(Row, {
      children: jsx(Select$1, {
        value: value,
        allowClear: true,
        showSearch: true,
        onChange: val => setValue(val),
        options: [{
          value: 'value1',
          title: 'value1',
          description: 'description1'
        }, {
          value: 'value2',
          title: 'value2',
          description: 'description2'
        }, {
          value: 'value3',
          title: 'value3',
          description: 'description3'
        }, {
          value: 'value4',
          title: 'value4'
        }],
        style: {
          width: '200px'
        }
      })
    }), jsx(Row, {
      children: jsx(Typography, {
        variant: "h3",
        children: "Option group example"
      })
    }), jsx(Row, {
      children: jsx(Select$1, {
        value: gouppedExampleValue,
        onChange: val => setGouppedExampleValue(val),
        showSearch: true,
        options: [{
          label: 'Designer',
          options: [{
            value: 'phil',
            title: 'Phil'
          }, {
            value: 'nash',
            title: 'Nash'
          }],
          value: ''
        }, {
          label: 'Engineer',
          options: [{
            value: 'demo',
            title: 'Demo'
          }, {
            value: 'david',
            title: 'David'
          }],
          value: ''
        }],
        style: {
          width: '200px'
        }
      })
    }), jsx(Row, {
      children: jsx(Typography, {
        variant: "h3",
        children: "With footer"
      })
    }), jsx(Row, {
      children: jsx(Select$1, {
        value: gouppedExampleValue,
        onChange: val => setGouppedExampleValue(val),
        footer: jsx("div", {
          children: "Footer content"
        }),
        options: [{
          label: 'Designer',
          options: [{
            value: 'phil',
            title: 'Phil'
          }, {
            value: 'nash',
            title: 'Nash'
          }],
          value: ''
        }, {
          label: 'Engineer',
          options: [{
            value: 'demo',
            title: 'Demo'
          }, {
            value: 'david',
            title: 'David'
          }],
          value: ''
        }],
        style: {
          width: '200px'
        }
      })
    })]
  });
};

const IndicatorWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "indicator__IndicatorWrapper",
  componentId: "sc-dtg5s3-0"
})(["border-radius:50%;height:8px;width:8px;background-color:", ";"], ({
  variant,
  theme
}) => variant === 'warning' ? theme.getColor('gold600') : variant === 'success' ? theme.getColor('green500') : theme.getColor('gray400'));
const Indicator = props => {
  const {
    style
  } = props;
  return jsx(IndicatorWrapper, Object.assign({}, props, {
    style: style
  }));
};

const antdInputStyles$2 = /*#__PURE__*/css(props => {
  const {
    theme,
    $hasError
  } = props;
  return css(["border-radius:8px;padding:10px 16px 10px 16px !important;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;", " &:hover,&:focus{box-shadow:none;border-color:", ";}&::placeholder{color:", ";}&:-ms-input-placeholder{color:", ";}&::-ms-input-placeholder{color:", ";}"], $hasError && `border-color: ${theme.getColor('textError')};`, theme.getColor($hasError ? 'textError' : 'gray800'), theme.colors.gray600, theme.colors.gray600, theme.colors.gray600);
});
const Input$3 = /*#__PURE__*/styled(_Input).withConfig({
  displayName: "input__Input",
  componentId: "sc-18y16x2-0"
})(() => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["&.", "-input{height:40px;", "}"], antdCssPrefix, antdInputStyles$2);
});
const SearchInput = /*#__PURE__*/styled(Input$3.Search).attrs(props => ({
  suffix: jsx(MagnifyingGlass, {
    style: {
      color: colors$1.gray800,
      width: '16px',
      height: '16px',
      cursor: 'pointer'
    },
    "data-testid": "search-icon"
  })
})).withConfig({
  displayName: "input__SearchInput",
  componentId: "sc-18y16x2-1"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["width:240px;height:40px;& .", "-input-affix-wrapper{padding:0 11px 0 0;border-radius:8px !important;height:40px;}& .", "-input-affix-wrapper + .", "-input-group-addon{display:none;}.", "-input-suffix{right:18px;}& .", "-input-affix-wrapper:not(.", "-input-affix-wrapper-disabled):hover{border-color:", ";}& .", "-input-affix-wrapper:focus,.", "-input-affix-wrapper-focused{box-shadow:none;border-color:", ";}& .", "-input{", "}& .", "icon-close-circle > svg{color:", ";height:16px;width:16px;margin:0 4px;}& .", "icon-close-circle:hover{background-color:", ";border-radius:50%;width:24px;height:24px;display:flex;align-items:center;justify-content:center;}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray800, antdCssPrefix, antdCssPrefix, props.theme.colors.gray800, antdCssPrefix, antdInputStyles$2, antdCssPrefix, props.theme.colors.gray500, antdCssPrefix, props.theme.colors.gray200);
});

var anObject$a = anObject$f;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$a(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$c = fails$o;
var global$b = global$n;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = global$b.RegExp;

var UNSUPPORTED_Y$1 = fails$c(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$c(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$c(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var fails$b = fails$o;
var global$a = global$n;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = global$a.RegExp;

var regexpUnsupportedDotAll = fails$b(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$a = fails$o;
var global$9 = global$n;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global$9.RegExp;

var regexpUnsupportedNcg = fails$a(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$e = functionCall;
var uncurryThis$a = functionUncurryThis;
var toString$7 = toString$9;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$a(''.charAt);
var indexOf = uncurryThis$a(''.indexOf);
var replace$2 = uncurryThis$a(''.replace);
var stringSlice$3 = uncurryThis$a(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$e(nativeExec, re1, 'a');
  call$e(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$7(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$e(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$e(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$2(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$3(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$e(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$3(match.input, charsAdded);
        match[0] = stringSlice$3(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$e(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$f = _export;
var exec$2 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$f({ target: 'RegExp', proto: true, forced: /./.exec !== exec$2 }, {
  exec: exec$2
});

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$2 = FunctionPrototype.apply;
var call$d = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$d.bind(apply$2) : function () {
  return call$d.apply(apply$2, arguments);
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$c = functionCall;
var defineBuiltIn$4 = defineBuiltIn$8;
var regexpExec$1 = regexpExec$2;
var fails$9 = fails$o;
var wellKnownSymbol$a = wellKnownSymbol$j;
var createNonEnumerableProperty = createNonEnumerableProperty$5;

var SPECIES$4 = wellKnownSymbol$a('species');
var RegExpPrototype$2 = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$a(KEY);

  var DELEGATES_TO_SYMBOL = !fails$9(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$9(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$4] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype$2.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$c(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$c(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn$4(String.prototype, KEY, methods[0]);
    defineBuiltIn$4(RegExpPrototype$2, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype$2[SYMBOL], 'sham', true);
};

var uncurryThis$9 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
var toString$6 = toString$9;
var requireObjectCoercible$4 = requireObjectCoercible$8;

var charAt$2 = uncurryThis$9(''.charAt);
var charCodeAt = uncurryThis$9(''.charCodeAt);
var stringSlice$2 = uncurryThis$9(''.slice);

var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$6(requireObjectCoercible$4($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$2(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$2 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$8 = functionUncurryThis;
var toObject$3 = toObject$7;

var floor = Math.floor;
var charAt = uncurryThis$8(''.charAt);
var replace$1 = uncurryThis$8(''.replace);
var stringSlice$1 = uncurryThis$8(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$3(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$1(str, 0, position);
      case "'": return stringSlice$1(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$1(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$b = functionCall;
var anObject$9 = anObject$f;
var isCallable$8 = isCallable$o;
var classof$5 = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$a = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$8(exec)) {
    var result = call$b(exec, R, S);
    if (result !== null) anObject$9(result);
    return result;
  }
  if (classof$5(R) === 'RegExp') return call$b(regexpExec, R, S);
  throw new $TypeError$a('RegExp#exec called on incompatible receiver');
};

var apply$1 = functionApply;
var call$a = functionCall;
var uncurryThis$7 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var fails$8 = fails$o;
var anObject$8 = anObject$f;
var isCallable$7 = isCallable$o;
var isNullOrUndefined$4 = isNullOrUndefined$7;
var toIntegerOrInfinity = toIntegerOrInfinity$4;
var toLength$1 = toLength$3;
var toString$5 = toString$9;
var requireObjectCoercible$3 = requireObjectCoercible$8;
var advanceStringIndex$1 = advanceStringIndex$2;
var getMethod$3 = getMethod$5;
var getSubstitution = getSubstitution$1;
var regExpExec$1 = regexpExecAbstract;
var wellKnownSymbol$9 = wellKnownSymbol$j;

var REPLACE = wellKnownSymbol$9('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis$7([].concat);
var push = uncurryThis$7([].push);
var stringIndexOf$1 = uncurryThis$7(''.indexOf);
var stringSlice = uncurryThis$7(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$8(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$1('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$3(this);
      var replacer = isNullOrUndefined$4(searchValue) ? undefined : getMethod$3(searchValue, REPLACE);
      return replacer
        ? call$a(replacer, searchValue, O, replaceValue)
        : call$a(nativeReplace, toString$5(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$8(this);
      var S = toString$5(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf$1(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf$1(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$7(replaceValue);
      if (!functionalReplace) replaceValue = toString$5(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec$1(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString$5(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$1(S, toLength$1(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$5(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString$5(apply$1(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

const StyledIntlTelInput = _a => {
  var {
      className,
      containerClassName,
      inputClassName
    } = _a,
    props = __rest(_a, ["className", "containerClassName", "inputClassName"]);
  return jsx(ReactIntlTelInput, Object.assign({}, props, {
    containerClassName: classNames('intl-tel-input', className, containerClassName),
    inputClassName: classNames('ant-input', inputClassName)
  }));
};
const S$3 = {
  IntlTelInput: StyledIntlTelInput
};

// TODO: Remove from `core-js@4` since it's moved to entry points

var $$e = _export;
var call$9 = functionCall;
var isCallable$6 = isCallable$o;
var anObject$7 = anObject$f;
var toString$4 = toString$9;

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$$e({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject$7(this);
    var string = toString$4(S);
    var exec = R.exec;
    if (!isCallable$6(exec)) return call$9(nativeTest, R, string);
    var result = call$9(exec, R, string);
    if (result === null) return false;
    anObject$7(result);
    return true;
  }
});

const newSgNumberRegex = /[8|9]\d{7}|\+65[8|9]\d{7}|\+65\s[8|9]\d{7}/;
const recalculateValueValidAndFormat = intlTelValue => {
  return Object.assign(Object.assign({}, intlTelValue), {
    value: intlTelValue.value.replace(/[^0-9]/g, ''),
    isValid: intlTelValue.isValid || newSgNumberRegex.test(intlTelValue.value)
  });
};

/**
 * IntlTelInput
 */
const IntlTelInput = _a => {
  var _b, _c;
  var {
      className,
      value,
      onChange,
      onPhoneNumberChange,
      onPhoneNumberBlur,
      defaultValue
    } = _a,
    otherProps = __rest(_a, ["className", "value", "onChange", "onPhoneNumberChange", "onPhoneNumberBlur", "defaultValue"]);
  const found = country.findByPhoneNbr(`${defaultValue}`);
  return jsx(S$3.IntlTelInput, Object.assign({
    format: false,
    defaultValue: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.replace(`+${found === null || found === void 0 ? void 0 : found.dialing_code}`, ''),
    defaultCountry: ((_b = found === null || found === void 0 ? void 0 : found.code) === null || _b === void 0 ? void 0 : _b.iso2.toLowerCase()) || ((_c = value === null || value === void 0 ? void 0 : value.countryData) === null || _c === void 0 ? void 0 : _c.iso2) || 'us',
    preferredCountries: ['us', 'sg', 'ca']
  }, otherProps, {
    value: value === null || value === void 0 ? void 0 : value.value,
    onPhoneNumberChange: (isValid, value, countryData, fullNumber, extension) => {
      const newValue = recalculateValueValidAndFormat({
        isValid,
        value,
        countryData,
        fullNumber,
        extension
      });
      onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
      onPhoneNumberChange === null || onPhoneNumberChange === void 0 ? void 0 : onPhoneNumberChange(newValue.isValid, newValue.value, countryData, fullNumber, extension);
    },
    onPhoneNumberBlur: (isValid, value, countryData, fullNumber, extension, event) => {
      const newValue = recalculateValueValidAndFormat({
        isValid,
        value,
        countryData,
        fullNumber,
        extension
      });
      onChange === null || onChange === void 0 ? void 0 : onChange(newValue);
      onPhoneNumberBlur === null || onPhoneNumberBlur === void 0 ? void 0 : onPhoneNumberBlur(newValue.isValid, newValue.value, countryData, fullNumber, extension, event);
    }
  }));
};

const clsPrefix = 'er-tel-input';
const GlobalStyle$2 = /*#__PURE__*/createGlobalStyle(props => {
  return css([".", " .ant-input:focus,.", " .ant-input-focused{box-shadow:none;}.", " .intl-tel-input{width:100%;input,input[type='text'],input[type='tel']{&:hover,&:focus{border-color:", " !important;}border:1px solid ", " !important;outline:none;border-radius:8px !important;padding:10px 16px 10px 52px !important;width:100%;}}"], clsPrefix, clsPrefix, clsPrefix, props.hasError ? getColor('red500') : getColor('gray800'), props.hasError ? getColor('red500') : getColor('gray400'));
});
const StyleWrapper$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "tel-input__StyleWrapper",
  componentId: "sc-mwtdcv-0"
})(["display:flex;width:100%;"]);
const TelInput = props => {
  const {
    hasError
  } = props;
  return jsxs(StyleWrapper$2, {
    className: clsPrefix,
    children: [jsx(GlobalStyle$2, {
      hasError: hasError
    }), jsx(IntlTelInput, Object.assign({
      style: {
        borderColor: hasError ? getColor('red500') : ''
      }
    }, props))]
  });
};

const DatePickerDayJs = generatePicker(dayjsGenerateConfig);
const {
  RangePicker: RangePickerAntd4
} = DatePickerDayJs;
const prefix = 'ant4';
const RangePicker = /*#__PURE__*/styled(RangePickerAntd4).withConfig({
  displayName: "date-picker__RangePicker",
  componentId: "sc-hfgyji-0"
})(["&.", "-picker{padding:", ";border:1px solid ", "!important;border-radius:8px;&:hover,&.", "-picker-focused{border:1px solid ", " !important;box-shadow:none;}.", "-picker-input,.", "-picker,.", "-select-single .", "-select-selector{height:32px;font-size:14px;border-radius:8px;width:100%;}}"], prefix, props => props.compact ? '1px 11px 1px' : 'init', ({
  hasError,
  theme
}) => hasError ? theme.getColor('red500') : theme.getColor('gray400'), prefix, ({
  hasError,
  theme
}) => hasError ? theme.getColor('red500') : theme.getColor('gray800'), prefix, prefix, prefix, prefix);
const DatePicker = /*#__PURE__*/styled(DatePickerDayJs).withConfig({
  displayName: "date-picker__DatePicker",
  componentId: "sc-hfgyji-1"
})(["&.", "-picker{border:1px solid ", "!important;border-radius:8px;&:hover,&.", "-picker-focused{border:1px solid ", " !important;box-shadow:none;}.", "-picker-input,.", "-picker,.", "-select-single .", "-select-selector{height:32px;font-size:14px;border-radius:8px;width:100%;}}"], prefix, ({
  theme,
  hasError
}) => hasError ? theme.getColor('red500') : theme.getColor('gray400'), prefix, ({
  theme,
  hasError
}) => hasError ? theme.getColor('red500') : theme.getColor('gray800'), prefix, prefix, prefix, prefix);
DatePicker.defaultProps = {
  suffixIcon: jsx(Calendar, {})
};

const StyleWrapper$1 = /*#__PURE__*/styled(Input$3.TextArea).withConfig({
  displayName: "text-area__StyleWrapper",
  componentId: "sc-qg20zu-0"
})(({
  theme,
  disabled
}) => css(["&.ant4-input{border-radius:8px;", "}"], !disabled && `&:hover,
    &:focus {
      border-color: ${theme.colors.gray800};
      box-shadow: none;
    }`));
const TextArea$1 = StyleWrapper$1;

const SSNInput = /*#__PURE__*/forwardRef((props, ref) => {
  return jsx(Input$3, Object.assign({}, props, {
    ref: ref
  }));
});

const blue = colors.blue500;
const green = colors.green500;
const sizeSelector = ({
  size
}) => size;
const Style$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "elevator-icon__Style",
  componentId: "sc-1eyyod9-0"
})(["height:", ";width:", ";border-radius:50%;display:inline-flex;flex-shrink:0;justify-content:center;align-items:center;border:1px solid ", ";background-color:white;color:", ";p{color:", ";}&.active{background-color:", ";color:white;p{color:white;}}&.completed{border:none;background-color:", ";color:white;}"], sizeSelector, sizeSelector, blue, blue, blue, blue, green);
const ElevatorIcon = ({
  active: _active = false,
  completed: _completed = false,
  children,
  className,
  size: _size = '30px'
}) => {
  return jsx(Style$1, {
    className: classNames(className, {
      active: _active,
      completed: _completed
    }),
    size: _size,
    children: children
  });
};

const Style = /*#__PURE__*/styled.div.withConfig({
  displayName: "elevator-item__Style",
  componentId: "sc-1j2xcw2-0"
})(["display:flex;gap:10px;align-items:center;padding:10px 16px;border-radius:8px;&.active{background-color:", ";}&.clickable{cursor:pointer;}&.disabled{cursor:not-allowed;}&:hover{background-color:", ";}"], colors.gray100, colors.gray100);
function ElevatorStep({
  initialStepIndex,
  title,
  subtitle,
  currentStepIndex,
  onClick,
  clickable = false,
  disabled = false,
  completed = currentStepIndex > initialStepIndex,
  active = currentStepIndex === initialStepIndex,
  className,
  icon
}) {
  const defaultIcon = jsx(ElevatorIcon, {
    className: classNames({
      active,
      completed
    }),
    children: completed ? jsx(CheckOutlined, {}) : jsx(Text, {
      variant: "bodyDefault",
      children: initialStepIndex + 1
    })
  });
  const handleOnClick = () => {
    if (clickable) {
      onClick === null || onClick === void 0 ? void 0 : onClick(initialStepIndex);
    }
  };
  return jsxs(Style, {
    className: classNames(className, {
      active,
      clickable,
      disabled
    }),
    onClick: handleOnClick,
    children: [icon || defaultIcon, jsxs("div", {
      style: {
        display: 'flex',
        flexDirection: 'column'
      },
      children: [jsx(Text, {
        variant: "bodyDefault",
        fontWeight: active ? 'semibold' : 'normal',
        className: "title",
        children: title
      }), subtitle && jsx(Text, {
        variant: "bodyDefault",
        fontSize: "12px",
        className: "description",
        color: active ? 'blue500' : 'gray600',
        children: subtitle
      })]
    })]
  });
}

function Elevator({
  className,
  steps = [],
  currentStepIndex = 0,
  onClick = noop$2
}) {
  return jsx("div", {
    className: className,
    children: steps.map((_a, i) => {
      var {
          key
        } = _a,
        rest = __rest(_a, ["key"]);
      return jsx(ElevatorStep, Object.assign({}, rest, {
        initialStepIndex: i,
        currentStepIndex: currentStepIndex,
        onClick: onClick
      }), key);
    })
  });
}

function ElevatorLayout({
  mainContent,
  sideContent,
  style,
  className
}) {
  if (!mainContent) {
    return null;
  }
  return jsx("div", {
    style: style,
    className: className,
    children: sideContent ? jsxs(_Row, {
      justify: "center",
      children: [jsx(_Col, {
        span: 24,
        md: 6,
        children: sideContent
      }), jsx(_Col, {
        span: 24,
        md: {
          span: 17,
          offset: 1
        },
        children: mainContent
      })]
    }) : mainContent
  });
}

/**
 * Breakpoints are referenced from:
 * https://tailwindcss.com/docs/responsive-design
 */
const maxWidthMixin = /*#__PURE__*/css(["@media (min-width:640px){max-width:640px;}@media (min-width:768px){max-width:768px;}@media (min-width:1024px){max-width:1024px;}@media (min-width:1280px){max-width:1280px;}@media (min-width:1536px){max-width:1536px;}"]);
const Container$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "container__Container",
  componentId: "sc-7ytqya-0"
})(({
  centered
}) => {
  return css(["width:100%;height:100%;", " ", ""], centered && css(["margin-left:auto;margin-right:auto;"]), maxWidthMixin);
});

const OverrideStyles = /*#__PURE__*/createGlobalStyle([".ws-sliding-pane{.ant4-drawer-content{border-radius:20px 20px 0 0;}.ant4-drawer-title{font-size:20px;font-weight:700;}.ant4-drawer-header{display:", ";}}"], props => props.showHeader ? 'flex' : 'none');
const SlidingPane = props => {
  const {
      title,
      actions = [],
      isOpen,
      onClose,
      children,
      okText,
      onOk,
      okStyle = {},
      cancelText,
      onCancel,
      okDisabled,
      cancelDisabled,
      okLoading,
      headerStyle,
      headerContainerStyle,
      bodyStyle,
      containerStyle = {},
      extraActions,
      cancelStyle = {},
      okDropdownItems = []
    } = props,
    otherProps = __rest(props, ["title", "actions", "isOpen", "onClose", "children", "okText", "onOk", "okStyle", "cancelText", "onCancel", "okDisabled", "cancelDisabled", "okLoading", "headerStyle", "headerContainerStyle", "bodyStyle", "containerStyle", "extraActions", "cancelStyle", "okDropdownItems"]);
  const renderOkButton = () => {
    if (okDropdownItems.length > 0) {
      return jsxs(ButtonNew.Group, {
        children: [jsx(ButtonNew, {
          type: "primary",
          onClick: onOk,
          disabled: okDisabled,
          loading: okLoading,
          style: okStyle,
          children: okText || 'Continue'
        }), jsx(Dropdown, {
          placement: "bottomRight",
          trigger: ['click'],
          menu: {
            items: okDropdownItems
          },
          children: jsx(ButtonNew, {
            type: "primary",
            loading: okLoading,
            icon: "ChevronDown",
            paddingLeft: "8px",
            paddingRight: "8px"
          })
        })]
      });
    }
    return jsx(ButtonNew, {
      type: "primary",
      onClick: onOk,
      disabled: okDisabled,
      loading: okLoading,
      style: okStyle,
      children: okText || 'Continue'
    });
  };
  const renderExtra = () => {
    return actions.length > 0 ? jsxs(_Space, {
      size: 12,
      children: [extraActions ? jsx(ButtonNew, {
        type: "secondary",
        onClick: onCancel,
        disabled: cancelDisabled,
        style: cancelStyle,
        children: cancelText || 'Cancel'
      }) : null, actions.map(action => {
        const {
            type
          } = action,
          rest = __rest(action, ["type"]);
        const isWarningBtn = type === 'danger';
        return isWarningBtn ? jsx(ButtonNew, Object.assign({
          backgroundColor: "red500",
          hoverBgColor: "red600",
          color: "white"
        }, rest, {
          children: action.label
        }), action.label) : jsx(ButtonNew, Object.assign({}, rest, {
          children: action.label
        }), action.label);
      }), extraActions ? renderOkButton() : null]
    }) : jsxs(_Space, {
      size: 12,
      children: [jsx(ButtonNew, {
        type: "secondary",
        onClick: onCancel,
        disabled: cancelDisabled,
        children: cancelText || 'Cancel'
      }), renderOkButton()]
    });
  };
  const header = jsx(Container$1, {
    centered: true,
    style: headerContainerStyle,
    children: jsxs(_Space, {
      style: {
        display: 'flex',
        justifyContent: 'space-between'
      },
      size: 20,
      children: [title, renderExtra()]
    })
  });
  const contentPadding = {
    padding: '20px 40px'
  };
  return jsxs(Fragment, {
    children: [jsx(OverrideStyles, Object.assign({
      showHeader: true
    }, props, {
      children: undefined
    })), jsx(_Drawer, Object.assign({
      className: "ws-sliding-pane",
      title: header,
      placement: "bottom",
      width: "100vw",
      height: "98%",
      onClose: onClose,
      visible: isOpen,
      closable: false,
      destroyOnClose: true,
      headerStyle: Object.assign(Object.assign(Object.assign({}, contentPadding), {
        gap: 20
      }), headerStyle),
      bodyStyle: Object.assign(Object.assign({
        background: getColor('#F3F5F9')
      }, contentPadding), bodyStyle)
    }, otherProps, {
      children: jsx(Container$1, {
        centered: true,
        style: containerStyle,
        children: children
      })
    }))]
  });
};

const GlobalStyle$1 = /*#__PURE__*/createGlobalStyle(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css([".", "-select-dropdown{border-radius:8px;}.", "-select-item-option-selected{background-color:", " !important;}"], antdCssPrefix, antdCssPrefix, getColor('gray100'));
});
const antdInputStyles$1 = /*#__PURE__*/css(["border-radius:8px;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;border-color:", " !important;box-shadow:none;&:hover,&:focus{box-shadow:none;border-color:", " !important;}&::placeholder{color:", ";}&:-ms-input-number-placeholder{color:", ";}&::-ms-input-number-placeholder{color:", ";}"], props => props.hasError ? getColor('red500') : getColor('gray400'), props => props.hasError ? getColor('red500') : getColor('gray800'), getColor('gray600'), getColor('gray600'), getColor('gray600'));
const NumInput = /*#__PURE__*/styled(_InputNumber).withConfig({
  displayName: "number-input__NumInput",
  componentId: "sc-dwxkit-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["&.", "-input-number{", "}.", "-input-number-input{height:40px;padding:10px 16px 10px 16px !important;box-shadow:none;}.", "-input-number-group-addon{border-radius:8px 0 0 8px;border-color:", " !important;}.", "-input-number-handler-wrap{border-radius:8px;svg{fill:", ";}}.", "-select-selector{border:0 !important;height:100%;width:100px;box-shadow:none !important;}.", "-select-selection-item{color:", ";}"], antdCssPrefix, antdInputStyles$1, antdCssPrefix, antdCssPrefix, props.hasError ? getColor('red500') : getColor('gray400'), antdCssPrefix, getColor('gray600'), antdCssPrefix, antdCssPrefix, getColor('gray600'));
});
const NumberInput = props => {
  return jsxs(Fragment, {
    children: [jsx(GlobalStyle$1, {}), jsx(NumInput, Object.assign({}, props))]
  });
};

const {
  Dragger
} = _Upload;
const UploadWrapper = /*#__PURE__*/styled('div').withConfig({
  displayName: "upload__UploadWrapper",
  componentId: "sc-h6pbpw-0"
})(() => {
  const antdPrefix = globalConfig().getPrefixCls();
  return css(["width:100%;.", "-upload.ant4-upload-drag{background:white;height:120px;border:1px dashed ", ";&:hover{border:1px dashed ", ";}}"], antdPrefix, ({
    theme
  }) => theme.getColor('gray400'), ({
    theme
  }) => theme.getColor('gray600'));
});
const Upload = props => {
  const {
      draggable,
      onUpload,
      onSuccess,
      onError,
      title,
      description,
      content
    } = props,
    otherProps = __rest(props, ["draggable", "onUpload", "onSuccess", "onError", "title", "description", "content"]);
  const defaultProps = {
    multiple: true,
    onChange(info) {
      const {
        status
      } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
        onUpload && onUpload(info);
      }
      if (status === 'done') {
        message.success(`${info.file.name} upload success.`);
        onSuccess && onSuccess(info);
      } else if (status === 'error') {
        message.error(`${info.file.name} upload failed.`);
        onError && onError(info);
      }
    }
  };
  return jsx(UploadWrapper, {
    children: draggable ? jsx(Dragger, Object.assign({}, defaultProps, otherProps, props, {
      children: content || jsxs(Fragment, {
        children: [jsx(Typography, {
          color: "gray800",
          fontWeight: 600,
          children: title || 'Select file'
        }), jsx(Typography, {
          children: description || 'or drop your files here'
        })]
      })
    })) : jsx(_Upload, Object.assign({}, defaultProps, otherProps, props, {
      children: jsx(ButtonNew, {
        children: "Upload"
      })
    }))
  });
};

var SizeEnum;
(function (SizeEnum) {
  SizeEnum["h1"] = "36px";
  SizeEnum["h2"] = "30px";
  SizeEnum["h3"] = "24px";
  SizeEnum["h4"] = "18px";
  SizeEnum["h5"] = "16px";
  SizeEnum["h6"] = "14px";
  SizeEnum["h7"] = "12px";
})(SizeEnum || (SizeEnum = {}));
const sizeMap = {
  h1: SizeEnum.h1,
  h2: SizeEnum.h2,
  h3: SizeEnum.h3,
  h4: SizeEnum.h4,
  h5: SizeEnum.h5,
  h6: SizeEnum.h6,
  h7: SizeEnum.h7
};
const HeadingWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "heading__HeadingWrapper",
  componentId: "sc-1y0rtpl-0"
})(["font-size:", ";font-weight:", ";color:", ";"], props => props.size, props => props.isMedium ? 600 : 700, props => props.color);
const Heading = props => {
  const {
    type,
    children,
    style = {},
    weight = 'bold'
  } = props;
  return jsx(HeadingWrapper, {
    style: style,
    size: sizeMap[type || 'h5'],
    isMedium: weight === 'medium',
    color: props.type === 'h7' ? getColor('gray600') : getColor('gray800'),
    children: children
  });
};

var $$d = _export;
var $includes = arrayIncludes.includes;
var fails$7 = fails$o;
var addToUnscopables$1 = addToUnscopables$3;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$7(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$d({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');

var isObject$4 = isObject$d;
var classof$4 = classofRaw$2;
var wellKnownSymbol$8 = wellKnownSymbol$j;

var MATCH$1 = wellKnownSymbol$8('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$4(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$4(it) === 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError$9 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError$9("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$7 = wellKnownSymbol$j;

var MATCH = wellKnownSymbol$7('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$c = _export;
var uncurryThis$6 = functionUncurryThis;
var notARegExp = notARegexp;
var requireObjectCoercible$2 = requireObjectCoercible$8;
var toString$3 = toString$9;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringIndexOf = uncurryThis$6(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$c({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString$3(requireObjectCoercible$2(this)),
      toString$3(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const styledTable$1 = () => styled(_a => {
  var {
      className,
      rowBorder = true
    } = _a,
    otherProps = __rest(_a, ["className", "rowBorder"]);
  const isWindows = navigator.userAgent.includes('Win');
  return jsx(_Table, Object.assign({
    className: classNames(className, {
      'os-win': isWindows
    })
  }, otherProps));
}).withConfig({
  displayName: "table__styledTable",
  componentId: "sc-1gt3wr1-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  const {
    rowBorder = true,
    cellBgColor
  } = props;
  return css(["font-family:'Plus Jakarta Sans',sans-serif;& .", "-checkbox-wrapper{justify-content:flex-start;align-items:center;}& .", "-checkbox{top:unset;}& .", "-checkbox-inner{width:18px;height:18px;border-radius:4px;&:after{left:4px;top:7px;width:5px;height:9px;}}& .", "-checkbox-indeterminate .", "-checkbox-inner:after{left:8px;top:8px;width:10px;height:2px;background-color:", ";}& .", "-checkbox-checked .", "-checkbox-inner,& .", "-checkbox-indeterminate .", "-checkbox-inner{background-color:", ";border-color:", ";}.", "-checkbox-wrapper:hover .", "-checkbox-inner,& .", "-checkbox:hover .", "-checkbox-inner,& .", "-checkbox-input:focus + .", "-checkbox-inner{border-color:", ";}& .", "-checkbox-checked::after{border:unset;}&.os-win{.", "-table-fixed-header .", "-table-scroll .", "-table-header{padding-bottom:4px;background:#fff;}.", "-table-fixed-header .", "-table-scroll .", "-table-header::-webkit-scrollbar{background-color:transparent;}}& .", "-table-row-expand-icon{border:none;&.", "-table-row-collapsed:after{content:url('data:image/svg+xml; utf8, %3Csvg%20width%3D%2212%22%20height%3D%228%22%20viewBox%3D%220%200%2012%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M10.9999%201.17C10.8126%200.983753%2010.5591%200.879211%2010.2949%200.879211C10.0308%200.879211%209.77731%200.983753%209.58995%201.17L5.99995%204.71L2.45995%201.17C2.27259%200.983753%202.01913%200.879211%201.75495%200.879211C1.49076%200.879211%201.23731%200.983753%201.04995%201.17C0.95622%201.26297%200.881826%201.37357%200.831057%201.49543C0.780288%201.61729%200.75415%201.74799%200.75415%201.88C0.75415%202.01202%200.780288%202.14272%200.831057%202.26458C0.881826%202.38644%200.95622%202.49704%201.04995%202.59L5.28995%206.83C5.38291%206.92373%205.49351%206.99813%205.61537%207.04889C5.73723%207.09966%205.86794%207.1258%205.99995%207.1258C6.13196%207.1258%206.26267%207.09966%206.38453%207.04889C6.50638%206.99813%206.61699%206.92373%206.70995%206.83L10.9999%202.59C11.0937%202.49704%2011.1681%202.38644%2011.2188%202.26458C11.2696%202.14272%2011.2957%202.01202%2011.2957%201.88C11.2957%201.74799%2011.2696%201.61729%2011.2188%201.49543C11.1681%201.37357%2011.0937%201.26297%2010.9999%201.17Z%22%20fill%3D%22%2371717A%22%2F%3E%0A%20%20%20%20%3C%2Fsvg%3E');transform:rotate(270deg);display:inline-block;height:16px;width:16px;}&.", "-table-row-expanded:after{content:url('data:image/svg+xml; utf8, %3Csvg%20width%3D%2212%22%20height%3D%228%22%20viewBox%3D%220%200%2012%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%20%20%20%20%3Cpath%20d%3D%22M10.9999%201.17C10.8126%200.983753%2010.5591%200.879211%2010.2949%200.879211C10.0308%200.879211%209.77731%200.983753%209.58995%201.17L5.99995%204.71L2.45995%201.17C2.27259%200.983753%202.01913%200.879211%201.75495%200.879211C1.49076%200.879211%201.23731%200.983753%201.04995%201.17C0.95622%201.26297%200.881826%201.37357%200.831057%201.49543C0.780288%201.61729%200.75415%201.74799%200.75415%201.88C0.75415%202.01202%200.780288%202.14272%200.831057%202.26458C0.881826%202.38644%200.95622%202.49704%201.04995%202.59L5.28995%206.83C5.38291%206.92373%205.49351%206.99813%205.61537%207.04889C5.73723%207.09966%205.86794%207.1258%205.99995%207.1258C6.13196%207.1258%206.26267%207.09966%206.38453%207.04889C6.50638%206.99813%206.61699%206.92373%206.70995%206.83L10.9999%202.59C11.0937%202.49704%2011.1681%202.38644%2011.2188%202.26458C11.2696%202.14272%2011.2957%202.01202%2011.2957%201.88C11.2957%201.74799%2011.2696%201.61729%2011.2188%201.49543C11.1681%201.37357%2011.0937%201.26297%2010.9999%201.17Z%22%20fill%3D%22%2371717A%22%2F%3E%0A%20%20%20%20%3C%2Fsvg%3E');display:inline-block;height:16px;width:16px;}}& .", "-table-thead{& > tr > th{font-weight:600;font-size:12px;line-height:17px;color:", ";", ";&::before{display:none;}}th{padding:8px 10px;background:#fff;", ";", ";}.col-hidden{padding:8px 2px 8px 10px;> span{display:flex;align-items:center;}}}& tbody.", "-table-tbody{font-weight:400;font-size:14px;line-height:20px;& .", "-table-row{&:hover{td{background-color:", ";}}td{padding:20px 10px;", ";color:", ";", ";}&.", "-table-row-level-0{.placeholder{width:12px;flex-shrink:0;}}&.", "-table-row-level-1,&.", "-table-row-level-2{.placeholder{width:58px;flex-shrink:0;}}.col-hidden{visibility:hidden;width:0;padding:0;.", "-table-row-expand-icon{display:none;}.", "-table-row-indent{display:none;}}}}& .", "-table-placeholder{border-bottom:none;}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.white, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, !rowBorder && 'border-bottom: unset', rowBorder && 'border-bottom: 1px solid #eceef0', rowBorder && 'border-top: 1px solid #eceef0', antdCssPrefix, antdCssPrefix, props.theme.colors.gray100, rowBorder ? 'border-bottom: 1px solid #eceef0' : 'border-bottom: unset', props.theme.colors.gray800, cellBgColor ? `background-color: ${cellBgColor}` : '', antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix);
});
const Table$1 = styledTable$1();
const FullWidthTable = /*#__PURE__*/styled(Table$1).withConfig({
  displayName: "table__FullWidthTable",
  componentId: "sc-1gt3wr1-1"
})(["width:100%;"]);
function createTable() {
  return styledTable$1();
}
function createFullWidthTable() {
  const TableComp = styledTable$1();
  return styled(TableComp).withConfig({
    displayName: "table",
    componentId: "sc-1gt3wr1-2"
  })(["width:100%;"]);
}

const CheckboxGroup = /*#__PURE__*/styled(Checkbox.Group).withConfig({
  displayName: "checkbox-group__CheckboxGroup",
  componentId: "sc-r89ma9-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  const {
    checkboxWrapperMargin
  } = props;
  return css(["& .", "-checkbox-wrapper{justify-content:flex-start;align-items:center;margin:", ";}& .", "-checkbox{top:unset;}& .", "-checkbox-inner{width:18px;height:18px;border-radius:4px;&:after{left:4px;top:7px;width:5px;height:9px;}}& .", "-checkbox-indeterminate .", "-checkbox-inner:after{left:8px;top:8px;width:10px;height:2px;background-color:", ";}& .", "-checkbox-checked .", "-checkbox-inner,& .", "-checkbox-indeterminate .", "-checkbox-inner{background-color:", ";border-color:", ";}.", "-checkbox-wrapper:hover .", "-checkbox-inner,& .", "-checkbox:hover .", "-checkbox-inner,& .", "-checkbox-input:focus + .", "-checkbox-inner{border-color:", ";}& .", "-checkbox-checked::after{border:unset;}"], antdCssPrefix, checkboxWrapperMargin, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.white, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, antdCssPrefix);
});

const Menu = /*#__PURE__*/styled(_Menu).withConfig({
  displayName: "menu__Menu",
  componentId: "sc-zir1c8-0"
})(() => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["&.", "-dropdown-menu{box-shadow:0px 4px 20px rgba(0,0,0,0.08);border-radius:8px;}.", "-dropdown-menu-item,.", "-dropdown-menu-submenu-title{padding:12px 16px;color:", ";&:hover{background:", ";}}.", "-dropdown-menu-item.ant4-dropdown-menu-item-danger{color:", ";}.", "-dropdown-menu-item-disabled{filter:opacity(0.3);&:hover{background:none;}}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, props => props.theme.colors.gray800, props => props.theme.colors.gray100, antdCssPrefix, props => props.theme.colors.red500, antdCssPrefix);
});
Menu.Divider = _Menu.Divider;
Menu.SubMenu = _Menu.SubMenu;
Menu.Item = _Menu.Item;
Menu.ItemGroup = _Menu.ItemGroup;

const StyleWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ellipsis__StyleWrapper",
  componentId: "sc-761bg4-0"
})(["display:inline-block;width:", ";max-width:", ";overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"], props => props.width || 'auto', props => props.maxWidth || 'none');
const StyleWrapperMultiLine = /*#__PURE__*/styled.span.withConfig({
  displayName: "ellipsis__StyleWrapperMultiLine",
  componentId: "sc-761bg4-1"
})(["width:", ";max-width:", ";overflow:hidden;display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;"], props => props.width || 'auto', props => props.maxWidth || 'none', props => props.line || 1);
const Ellipsis = props => {
  const {
    children,
    line = 1,
    showTip = true,
    tipPlacement = 'bottom'
  } = props;
  return line === 1 ? showTip ? jsx(Tooltip, {
    placement: tipPlacement,
    title: children,
    children: jsx(StyleWrapper, Object.assign({}, props, {
      children: children
    }))
  }) : jsx(StyleWrapper, Object.assign({}, props, {
    children: children
  })) : showTip ? jsx(Tooltip, {
    placement: tipPlacement,
    title: children,
    children: jsx(StyleWrapperMultiLine, Object.assign({}, props, {
      children: children
    }))
  }) : jsx(StyleWrapperMultiLine, Object.assign({}, props, {
    children: children
  }));
};

const Notification = /*#__PURE__*/styled(_Alert).withConfig({
  displayName: "notification__Notification",
  componentId: "sc-1y0hs8d-0"
})(props => {
  return css(["background:", ";border:none;border-radius:8px;width:100%;&.ant4-alert-info .ant4-alert-icon{color:", ";}"], ({
    theme
  }) => theme.getColor('blue100'), ({
    theme
  }) => theme.getColor('gray800'));
});

var global$8 = global$n;
var classof$3 = classofRaw$2;

var engineIsNode = classof$3(global$8.process) === 'process';

var getBuiltIn$4 = getBuiltIn$8;
var defineBuiltInAccessor = defineBuiltInAccessor$2;
var wellKnownSymbol$6 = wellKnownSymbol$j;
var DESCRIPTORS$2 = descriptors;

var SPECIES$3 = wellKnownSymbol$6('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$4(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$2 && Constructor && !Constructor[SPECIES$3]) {
    defineBuiltInAccessor(Constructor, SPECIES$3, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$2 = objectIsPrototypeOf;

var $TypeError$8 = TypeError;

var anInstance$1 = function (it, Prototype) {
  if (isPrototypeOf$2(Prototype, it)) return it;
  throw new $TypeError$8('Incorrect invocation');
};

var uncurryThis$5 = functionUncurryThis;
var fails$6 = fails$o;
var isCallable$5 = isCallable$o;
var classof$2 = classof$7;
var getBuiltIn$3 = getBuiltIn$8;
var inspectSource$1 = inspectSource$3;

var noop$1 = function () { /* empty */ };
var construct = getBuiltIn$3('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$1 = uncurryThis$5(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop$1);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  try {
    construct(noop$1, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$5(argument)) return false;
  switch (classof$2(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$1(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$2 = !construct || fails$6(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor$1 = isConstructor$2;
var tryToString$2 = tryToString$4;

var $TypeError$7 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor$1(argument)) return argument;
  throw new $TypeError$7(tryToString$2(argument) + ' is not a constructor');
};

var anObject$6 = anObject$f;
var aConstructor = aConstructor$1;
var isNullOrUndefined$3 = isNullOrUndefined$7;
var wellKnownSymbol$5 = wellKnownSymbol$j;

var SPECIES$2 = wellKnownSymbol$5('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$2 = function (O, defaultConstructor) {
  var C = anObject$6(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$3(S = anObject$6(C)[SPECIES$2]) ? defaultConstructor : aConstructor(S);
};

var classofRaw = classofRaw$2;
var uncurryThis$4 = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$4(fn);
};

var uncurryThis$3 = functionUncurryThisClause;
var aCallable$8 = aCallable$b;
var NATIVE_BIND = functionBindNative;

var bind$5 = uncurryThis$3(uncurryThis$3.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$8(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$5(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var uncurryThis$2 = functionUncurryThis;

var arraySlice$1 = uncurryThis$2([].slice);

var $TypeError$6 = TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw new $TypeError$6('Not enough arguments');
  return passed;
};

var userAgent$2 = engineUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var global$7 = global$n;
var apply = functionApply;
var bind$4 = functionBindContext;
var isCallable$4 = isCallable$o;
var hasOwn$1 = hasOwnProperty_1;
var fails$5 = fails$o;
var html = html$2;
var arraySlice = arraySlice$1;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$4 = engineIsNode;

var set$1 = global$7.setImmediate;
var clear = global$7.clearImmediate;
var process$2 = global$7.process;
var Dispatch = global$7.Dispatch;
var Function$1 = global$7.Function;
var MessageChannel = global$7.MessageChannel;
var String$1 = global$7.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$5(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global$7.location;
});

var run = function (id) {
  if (hasOwn$1(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global$7.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$4(handler) ? handler : Function$1(handler);
    var args = arraySlice(arguments, 1);
    queue$2[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$4) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$4(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$7.addEventListener &&
    isCallable$4(global$7.postMessage) &&
    !global$7.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$5(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global$7.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set$1,
  clear: clear
};

var global$6 = global$n;
var DESCRIPTORS$1 = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$1 = function (name) {
  if (!DESCRIPTORS$1) return global$6[name];
  var descriptor = getOwnPropertyDescriptor$1(global$6, name);
  return descriptor && descriptor.value;
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$1 = engineUserAgent;

var engineIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && typeof Pebble != 'undefined';

var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var global$5 = global$n;
var safeGetBuiltIn = safeGetBuiltIn$1;
var bind$3 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = engineIsIos;
var IS_IOS_PEBBLE = engineIsIosPebble;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$3 = engineIsNode;

var MutationObserver = global$5.MutationObserver || global$5.WebKitMutationObserver;
var document$2 = global$5.document;
var process$1 = global$5.process;
var Promise$1 = global$5.Promise;
var microtask$1 = safeGetBuiltIn('queueMicrotask');
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$3 && (parent = process$1.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$3 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$3(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$3) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$3(macrotask, global$5);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$4 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var global$4 = global$n;

var promiseNativeConstructor = global$4.Promise;

/* global Deno -- Deno case */
var engineIsDeno = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

var IS_DENO$1 = engineIsDeno;
var IS_NODE$2 = engineIsNode;

var engineIsBrowser = !IS_DENO$1 && !IS_NODE$2
  && typeof window == 'object'
  && typeof document == 'object';

var global$3 = global$n;
var NativePromiseConstructor$4 = promiseNativeConstructor;
var isCallable$3 = isCallable$o;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$4 = wellKnownSymbol$j;
var IS_BROWSER = engineIsBrowser;
var IS_DENO = engineIsDeno;
var V8_VERSION = engineV8Version;

NativePromiseConstructor$4 && NativePromiseConstructor$4.prototype;
var SPECIES$1 = wellKnownSymbol$4('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$3(global$3.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$4);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$4);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$4(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$1] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$7 = aCallable$b;

var $TypeError$5 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError$5('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$7(resolve);
  this.reject = aCallable$7(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$b = _export;
var IS_NODE$1 = engineIsNode;
var global$2 = global$n;
var call$8 = functionCall;
var defineBuiltIn$3 = defineBuiltIn$8;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag = setToStringTag$4;
var setSpecies = setSpecies$1;
var aCallable$6 = aCallable$b;
var isCallable$2 = isCallable$o;
var isObject$3 = isObject$d;
var anInstance = anInstance$1;
var speciesConstructor$1 = speciesConstructor$2;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$3 = perform$4;
var Queue = queue$1;
var InternalStateModule = internalState;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$4 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype$2 = NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var PromiseConstructor = NativePromiseConstructor$3;
var PromisePrototype = NativePromisePrototype$2;
var TypeError$1 = global$2.TypeError;
var document$1 = global$2.document;
var process = global$2.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$4.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && global$2.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$3(it) && isCallable$2(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$8(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$2.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global$2['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$8(task, global$2, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$3(function () {
        if (IS_NODE$1) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$8(task, global$2, function () {
    var promise = state.facade;
    if (IS_NODE$1) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$2 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$8(then, value,
            bind$2(internalResolve, wrapper, state),
            bind$2(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable$6(executor);
    call$8(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$2(internalResolve, state), bind$2(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$3(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor$1(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$2(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$2(onRejected) && onRejected;
    reaction.domain = IS_NODE$1 ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$2(internalResolve, state);
    this.reject = bind$2(internalReject, state);
  };

  newPromiseCapabilityModule$4.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$2(NativePromiseConstructor$3) && NativePromisePrototype$2 !== Object.prototype) {
    nativeThen = NativePromisePrototype$2.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$3(NativePromisePrototype$2, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$8(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$2.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype$2, PromisePrototype);
    }
  }
}

$$b({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var wellKnownSymbol$3 = wellKnownSymbol$j;
var Iterators$1 = iterators;

var ITERATOR$3 = wellKnownSymbol$3('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$1.Array === it || ArrayPrototype[ITERATOR$3] === it);
};

var classof$1 = classof$7;
var getMethod$2 = getMethod$5;
var isNullOrUndefined$2 = isNullOrUndefined$7;
var Iterators = iterators;
var wellKnownSymbol$2 = wellKnownSymbol$j;

var ITERATOR$2 = wellKnownSymbol$2('iterator');

var getIteratorMethod$2 = function (it) {
  if (!isNullOrUndefined$2(it)) return getMethod$2(it, ITERATOR$2)
    || getMethod$2(it, '@@iterator')
    || Iterators[classof$1(it)];
};

var call$7 = functionCall;
var aCallable$5 = aCallable$b;
var anObject$5 = anObject$f;
var tryToString$1 = tryToString$4;
var getIteratorMethod$1 = getIteratorMethod$2;

var $TypeError$4 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$1(argument) : usingIterator;
  if (aCallable$5(iteratorMethod)) return anObject$5(call$7(iteratorMethod, argument));
  throw new $TypeError$4(tryToString$1(argument) + ' is not iterable');
};

var call$6 = functionCall;
var anObject$4 = anObject$f;
var getMethod$1 = getMethod$5;

var iteratorClose$1 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$4(iterator);
  try {
    innerResult = getMethod$1(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$6(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$4(innerResult);
  return value;
};

var bind$1 = functionBindContext;
var call$5 = functionCall;
var anObject$3 = anObject$f;
var tryToString = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$4 = lengthOfArrayLike$6;
var isPrototypeOf$1 = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod = getIteratorMethod$2;
var iteratorClose = iteratorClose$1;

var $TypeError$3 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$3 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$1(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$3(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw new $TypeError$3(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$4(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$1(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$5(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$1(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$1 = wellKnownSymbol$j;

var ITERATOR$1 = wellKnownSymbol$1('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$1] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$1] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$2 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$2.all(iterable).then(undefined, function () { /* empty */ });
});

var $$a = _export;
var call$4 = functionCall;
var aCallable$4 = aCallable$b;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;
var perform$2 = perform$4;
var iterate$2 = iterate$3;
var PROMISE_STATICS_INCORRECT_ITERATION$2 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$a({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$2 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$3.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$2(function () {
      var $promiseResolve = aCallable$4(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$2(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$4($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$9 = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor$1 = promiseNativeConstructor;
var getBuiltIn$2 = getBuiltIn$8;
var isCallable$1 = isCallable$o;
var defineBuiltIn$2 = defineBuiltIn$8;

var NativePromisePrototype$1 = NativePromiseConstructor$1 && NativePromiseConstructor$1.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$9({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$1(NativePromiseConstructor$1)) {
  var method$1 = getBuiltIn$2('Promise').prototype['catch'];
  if (NativePromisePrototype$1['catch'] !== method$1) {
    defineBuiltIn$2(NativePromisePrototype$1, 'catch', method$1, { unsafe: true });
  }
}

var $$8 = _export;
var call$3 = functionCall;
var aCallable$3 = aCallable$b;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$4;
var iterate$1 = iterate$3;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$8({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$3(C.resolve);
      iterate$1(iterable, function (promise) {
        call$3($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$7 = _export;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$7({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule$1.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});

var anObject$2 = anObject$f;
var isObject$2 = isObject$d;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$2 = function (C, x) {
  anObject$2(C);
  if (isObject$2(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$6 = _export;
var getBuiltIn$1 = getBuiltIn$8;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve$1 = promiseResolve$2;

getBuiltIn$1('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$6({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve$1(this, x);
  }
});

var $$5 = _export;
var call$2 = functionCall;
var aCallable$2 = aCallable$b;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$4;
var iterate = iterate$3;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$$5({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  allSettled: function allSettled(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var promiseResolve = aCallable$2(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$2(promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'fulfilled', value: value };
          --remaining || resolve(values);
        }, function (error) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = { status: 'rejected', reason: error };
          --remaining || resolve(values);
        });
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

function getFileNameWithoutExtension(fileName) {
  return fileName.split('.').slice(0, -1).join('.');
}

const spinAnimation$1 = /*#__PURE__*/keyframes(["100%{transform:rotate(360deg);}"]);
const AnimatedLoading$1 = /*#__PURE__*/styled(Loading).withConfig({
  displayName: "manual-upload__AnimatedLoading",
  componentId: "sc-1k30qk6-0"
})(["color:", ";animation:", " 2s linear infinite;"], ({
  theme
}) => theme.getColor('gray600'), spinAnimation$1);
const ManualUpload = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      url,
      style,
      fetcher,
      onUploaded,
      onFileListChange,
      payloadMapper,
      hideDocName,
      multiple = false
    } = props,
    otherProps = __rest(props, ["url", "style", "fetcher", "onUploaded", "onFileListChange", "payloadMapper", "hideDocName", "multiple"]);
  const [fileList, setFileList] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const filePayloadList = useMemo(() => fileList.map(file => {
    const payload = {
      [(payloadMapper === null || payloadMapper === void 0 ? void 0 : payloadMapper.fileField) || 'file']: file.originFileObj,
      [(payloadMapper === null || payloadMapper === void 0 ? void 0 : payloadMapper.fileNameField) || 'file_name']: file.name
    };
    return {
      payload: serialize(payload),
      fileObj: file
    };
  }), [fileList, payloadMapper === null || payloadMapper === void 0 ? void 0 : payloadMapper.fileField, payloadMapper === null || payloadMapper === void 0 ? void 0 : payloadMapper.fileNameField]);
  const mergeUploadResWithFileList = useCallback(resultList => {
    const mergedList = fileList.map((fileObj, index) => {
      const currentResult = resultList[index];
      let status = '';
      switch (currentResult === null || currentResult === void 0 ? void 0 : currentResult.status) {
        case 'fulfilled':
          status = 'success';
          break;
        case 'rejected':
          status = 'error';
          break;
      }
      return Object.assign(Object.assign({}, fileObj), {
        status: status,
        value: currentResult === null || currentResult === void 0 ? void 0 : currentResult.value,
        reason: currentResult === null || currentResult === void 0 ? void 0 : currentResult.reason,
        response: currentResult === null || currentResult === void 0 ? void 0 : currentResult.value
      });
    });
    return mergedList;
  }, [fileList]);
  useImperativeHandle(ref, () => ({
    upload: () => {
      setIsUploading(true);
      Promise.allSettled(filePayloadList.map((filePayload, index) => {
        var _a, _b;
        if (filePayload.fileObj.status === 'success') {
          return Promise.resolve(filePayload.fileObj.value);
        }
        if (((_b = getFileNameWithoutExtension((_a = filePayload === null || filePayload === void 0 ? void 0 : filePayload.fileObj) === null || _a === void 0 ? void 0 : _a.name)) === null || _b === void 0 ? void 0 : _b.length) > 100) {
          return Promise.reject('file name can not be longer than 100 characters');
        }
        return fetcher.post(url, filePayload.payload, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      })).then(values => {
        const mergedList = mergeUploadResWithFileList(values);
        setFileList(mergedList);
        if (isFunction(onFileListChange)) {
          onFileListChange(mergedList);
        }
        const hasAllFileUploaded = mergedList.every(file => file.status === 'success');
        if (hasAllFileUploaded) {
          setFileList([]);
          if (isFunction(onFileListChange)) {
            onFileListChange([]);
          }
          message.success('All files uploaded successfully');
        } else {
          message.warning('Some files failed to upload');
        }
        setIsUploading(false);
        if (isFunction(onUploaded)) {
          onUploaded(values, hasAllFileUploaded);
        }
      });
    },
    getIsLoading: () => isUploading,
    getFileList: () => fileList
  }), [fetcher, fileList, filePayloadList, isUploading, mergeUploadResWithFileList, onFileListChange, onUploaded, url]);
  const fileColumns = [{
    title: 'Document name  (100 character limit)',
    dataIndex: 'name',
    key: 'name',
    render: (fileName, record) => {
      var _a, _b, _c;
      const fileExt = fileName.split('.').pop();
      const isSuccess = (record === null || record === void 0 ? void 0 : record.status) === 'success';
      const isError = (record === null || record === void 0 ? void 0 : record.status) === 'error';
      // const isUploading = record?.status === 'uploading';
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const errorMessage = (_c = (_b = (_a = record === null || record === void 0 ? void 0 : record.reason) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message;
      const statusMsg = isSuccess ? 'File upload success' : isError ? `Upload error: ${errorMessage ? errorMessage : record.reason}` : '';
      return jsxs(_Space, {
        direction: "vertical",
        style: {
          width: '100%'
        },
        size: 8,
        children: [jsx(Tooltip, {
          placement: "top",
          title: statusMsg,
          children: jsxs("div", {
            style: {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            },
            children: [isUploading && !isSuccess && jsx(AnimatedLoading$1, {
              style: {
                marginRight: 8
              }
            }), isError && jsx(Error$1, {
              color: "red500",
              style: {
                marginRight: 8
              }
            }), isSuccess && jsx(Checkmark, {
              color: "green500",
              style: {
                marginRight: 8
              }
            }), !isError && !isSuccess && !isUploading && jsx(Document, {
              color: "gray600",
              style: {
                marginRight: 8
              }
            }), jsx(Input$3, {
              "data-testid": `manual-upload-file-name-input-${record.uid}`,
              minLength: 1,
              maxLength: 100,
              disabled: isSuccess,
              style: {
                flex: 1,
                borderColor: isError ? getColor('red500') : getColor('gray400')
              },
              value: getFileNameWithoutExtension(fileName),
              onChange: e => {
                const fList = fileList.map(file => {
                  if (file.uid === record.uid) {
                    return Object.assign(Object.assign({}, file), {
                      name: `${e.target.value}.${fileExt}`
                    });
                  }
                  return file;
                });
                setFileList(fList);
                if (isFunction(onFileListChange)) {
                  onFileListChange(fList);
                }
              }
            }), jsxs("span", {
              style: {
                marginRight: 30,
                color: getColor('gray600')
              },
              children: [".", fileExt]
            }), jsx(Cross, {
              color: "gray600",
              style: {
                visibility: !isSuccess ? 'visible' : 'hidden'
              },
              onClick: () => {
                const fList = fileList.filter(file => file.uid !== record.uid);
                setFileList(fList);
                if (isFunction(onFileListChange)) {
                  onFileListChange(fList);
                }
              }
            })]
          })
        }), isError && jsx("div", {
          style: {
            marginLeft: 32
          },
          children: statusMsg
        })]
      });
    }
  }];
  return jsxs(_Space, {
    direction: "vertical",
    style: Object.assign({
      width: '100%'
    }, style),
    size: 0,
    children: [jsx(Upload, Object.assign({
      content: jsxs(Fragment, {
        children: [jsx(Typography, {
          color: "gray600",
          fontWeight: 600,
          children: "Select files"
        }), jsx(Typography, {
          children: "or drop your files here"
        }), jsx(Typography, {
          color: "gray400",
          children: "Max file size: 10mb"
        })]
      }),
      action: url,
      fileList: fileList,
      showUploadList: false,
      beforeUpload: () => false,
      multiple: multiple
    }, otherProps, {
      onChange: uploadInfo => {
        if (multiple) {
          setFileList(uploadInfo.fileList);
        } else {
          setFileList([uploadInfo.file]);
        }
        if (isFunction(onFileListChange)) {
          onFileListChange(uploadInfo.fileList);
        }
      }
    })), !hideDocName && fileList.length > 0 && jsx(FullWidthTable, {
      sticky: true,
      scroll: {
        y: 300
      },
      style: {
        marginTop: '20px'
      },
      dataSource: fileList,
      columns: fileColumns,
      pagination: false
    })]
  });
});

const IconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "country-region-selector__IconWrapper",
  componentId: "sc-n2zgw4-0"
})([""]);
const Wrapper$2 = /*#__PURE__*/styled.div.withConfig({
  displayName: "country-region-selector__Wrapper",
  componentId: "sc-n2zgw4-1"
})(["position:relative;&::after{content:'';font-size:1rem;top:6px;right:16px;position:absolute;color:", ";}& select{height:42px;border-radius:8px;cursor:pointer;outline:none;padding:10px 16px;width:100%;-webkit-appearance:none;appearance:none;transition:all 0.2s ease-in-out;border:1px solid ", ";}select:hover{border:1px solid ", ";}select{color:", ";}select option{color:", ";}select:has(option:checked:not([value])),select:has(option:checked:not([value=''])){color:", ";}select:has(option:checked:not([value])) option,select:has(option:checked:not([value=''])) option{color:", ";}& ", "{position:absolute;top:50%;right:16px;transform:translateY(-50%);pointer-events:none;}"], ({
  theme
}) => theme.getColor('gray600'), ({
  theme,
  hasError
}) => hasError ? theme.getColor('red500') : theme.getColor('gray400'), props => props.theme.getColor('borderActive'), props => props.theme.getColor('textSecondary'), props => props.theme.getColor('textPrimary'), props => props.theme.getColor('textPrimary'), props => props.theme.getColor('textPrimary'), IconWrapper);
const CountrySelector = props => {
  const {
      hasError
    } = props,
    otherProps = __rest(props, ["hasError"]);
  return jsx(Wrapper$2, {
    hasError: hasError,
    children: jsx(CountryDropdown, Object.assign({}, otherProps))
  });
};
const RegionSelector = props => {
  const {
      hasError
    } = props,
    otherProps = __rest(props, ["hasError"]);
  return jsxs(Wrapper$2, {
    hasError: hasError,
    children: [jsx(IconWrapper, {
      children: jsx(ChevronDown, {
        color: "textPrimary"
      })
    }), jsx(RegionDropdown, Object.assign({}, otherProps))]
  });
};

const Radio = /*#__PURE__*/styled(_Radio).withConfig({
  displayName: "radio__Radio",
  componentId: "sc-12hgnq3-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["font-weight:normal;font-size:14px;font-family:'Plus Jakarta Sans',sans-serif;align-items:center;& .", "-radio{top:unset;}& .", "-radio-input:focus + .", "-radio-inner{box-shadow:unset;}&.", "-radio-wrapper:hover .", "-radio,&.", "-radio-wrapper:hover .", "-radio-inner,& .", "-radio:hover .", "-radio-inner,& .", "-radio-input:focus + .", "-radio-inner{border-color:", ";}& .", "-radio-checked .", "-radio-inner{border-color:", ";}& .", "-radio-inner{width:20px;height:20px;}& .", "-radio-inner::after{width:20px;height:20px;margin-top:-10px;margin-left:-10px;background-color:", ";}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600, antdCssPrefix, antdCssPrefix, props.theme.colors.gray600);
});
Radio.Group = _Radio.Group;

const Switch = /*#__PURE__*/styled(_Switch).withConfig({
  displayName: "switch__Switch",
  componentId: "sc-1cy9kru-0"
})(["margin:0;min-width:40px;height:24px;.ant4-switch-handle{left:5px;width:14px;height:14px;top:5px;}&.ant4-switch-checked .ant4-switch-handle{left:calc(100% - 18px - 1px);}"]);
Switch.displayName = 'Switch';

var $$4 = _export;
var NativePromiseConstructor = promiseNativeConstructor;
var fails$4 = fails$o;
var getBuiltIn = getBuiltIn$8;
var isCallable = isCallable$o;
var speciesConstructor = speciesConstructor$2;
var promiseResolve = promiseResolve$2;
var defineBuiltIn$1 = defineBuiltIn$8;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// Safari bug https://bugs.webkit.org/show_bug.cgi?id=200829
var NON_GENERIC = !!NativePromiseConstructor && fails$4(function () {
  // eslint-disable-next-line unicorn/no-thenable -- required for testing
  NativePromisePrototype['finally'].call({ then: function () { /* empty */ } }, function () { /* empty */ });
});

// `Promise.prototype.finally` method
// https://tc39.es/ecma262/#sec-promise.prototype.finally
$$4({ target: 'Promise', proto: true, real: true, forced: NON_GENERIC }, {
  'finally': function (onFinally) {
    var C = speciesConstructor(this, getBuiltIn('Promise'));
    var isFunction = isCallable(onFinally);
    return this.then(
      isFunction ? function (x) {
        return promiseResolve(C, onFinally()).then(function () { return x; });
      } : onFinally,
      isFunction ? function (e) {
        return promiseResolve(C, onFinally()).then(function () { throw e; });
      } : onFinally
    );
  }
});

// makes sure that native promise-based APIs `Promise#finally` properly works with patched `Promise#then`
if (isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['finally'];
  if (NativePromisePrototype['finally'] !== method) {
    defineBuiltIn$1(NativePromisePrototype, 'finally', method, { unsafe: true });
  }
}

const spinAnimation = /*#__PURE__*/keyframes(["100%{transform:rotate(360deg);}"]);
const AnimatedLoading = /*#__PURE__*/styled(Loading).withConfig({
  displayName: "direct-upload__AnimatedLoading",
  componentId: "sc-1veoscz-0"
})(["color:", ";animation:", " 2s linear infinite;"], ({
  theme
}) => theme.getColor('gray600'), spinAnimation);
function DirectUpload(props) {
  const {
      style,
      fetcher,
      multiple,
      onSettled,
      payloadMapper
    } = props,
    otherProps = __rest(props, ["style", "fetcher", "multiple", "onSettled", "payloadMapper"]);
  const [fileList, setFileList] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const renderErrorMsg = (fileName, error) => {
    var _a;
    const errMsgTitle = jsxs(Text, {
      variant: "bodyDefault",
      color: "gray800",
      fontWeight: 600,
      children: ["Error: ", fileName, " has ", error === null || error === void 0 ? void 0 : error.message]
    });
    const sourceFileErrs = (_a = error === null || error === void 0 ? void 0 : error.errors) === null || _a === void 0 ? void 0 : _a.source_file;
    if (sourceFileErrs && (sourceFileErrs === null || sourceFileErrs === void 0 ? void 0 : sourceFileErrs.length) > 0) {
      const errMsgs = sourceFileErrs.map(err => {
        const errMsg = jsx("li", {
          style: {
            listStyle: 'outside',
            marginLeft: 20
          },
          children: jsxs(Text, {
            variant: "bodyDefault",
            color: "gray600",
            children: [err.error && jsxs("span", {
              children: [jsx("span", {
                style: {
                  fontWeight: 600
                },
                children: capitalize((err.error || '').replace(/_/g, ' '))
              }), jsx("span", {
                children: `: `
              })]
            }), jsx("span", {
              children: err.message
            }), err.missing_columns && jsx("span", {
              children: ` ( ${err.missing_columns.join(', ')} )`
            }), err.unrecognized_columns && jsx("span", {
              children: ` ( ${err.unrecognized_columns.join(', ')} )`
            })]
          })
        }, err.error);
        return errMsg;
      });
      return jsxs(_Space, {
        direction: "vertical",
        size: 4,
        children: [errMsgTitle, jsx("ul", {
          style: {
            display: 'flex',
            flexDirection: 'column'
          },
          children: errMsgs
        }), jsxs(Text, {
          variant: "bodyDefault",
          children: ["Please ensure the first row of your file uses only the columns within the provided template. You can also", ' ', jsx("a", {
            href: "https://docs.google.com/spreadsheets/d/1qVQvrFRIG9b5QXY-CJo4iZ-IntH17fTlKqvry0LvYV8/edit#gid=0",
            target: "_blank",
            rel: "noreferrer",
            children: jsxs(Text, {
              variant: "bodyDefault",
              color: "blue500",
              children: ["view the instructions.", jsx(ExternalLink, {
                style: {
                  display: 'inline'
                },
                size: 15
              })]
            })
          })]
        })]
      });
    }
    return null;
  };
  const fileColumns = [{
    title: 'File',
    dataIndex: 'name',
    key: 'name',
    render: (fileName, record) => {
      var _a;
      const isSuccess = (record === null || record === void 0 ? void 0 : record.status) === 'success';
      const isError = (record === null || record === void 0 ? void 0 : record.status) === 'error';
      // const isUploading = record?.status === 'uploading';
      const statusMsg = isSuccess ? 'file upload success' : isError ? (_a = record.error) === null || _a === void 0 ? void 0 : _a.message : '';
      return jsxs(_Space, {
        direction: "vertical",
        style: {
          width: '100%'
        },
        size: 0,
        children: [jsx(Tooltip, {
          placement: "top",
          title: statusMsg,
          children: jsxs("div", {
            style: {
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            },
            children: [jsxs(_Space, {
              size: 4,
              children: [isUploading && jsx(AnimatedLoading, {
                style: {
                  marginRight: 8
                }
              }), isError && jsx(Error$1, {
                color: "red500"
              }), isSuccess && jsx(Document, {
                color: "gray600"
              }), jsx("div", {
                children: jsx(Ellipsis, {
                  maxWidth: "560px",
                  children: fileName
                })
              })]
            }), jsx(Cross, {
              color: "gray400",
              onClick: () => {
                const fList = fileList.filter(file => file.uid !== record.uid);
                setFileList(fList);
                if (isFunction(onSettled)) {
                  onSettled(fList);
                }
              }
            })]
          })
        }), isError && jsx(FlexBox, {
          color: "gray600",
          marginRight: 28,
          children: renderErrorMsg(fileName, record.error)
        })]
      });
    }
  }];
  return jsxs(_Space, {
    direction: "vertical",
    style: Object.assign({
      width: '100%'
    }, style),
    size: 0,
    children: [jsx(Upload, Object.assign({
      content: jsxs(Fragment, {
        children: [jsx(Typography, {
          color: "gray600",
          fontWeight: 600,
          children: "Select files"
        }), jsx(Typography, {
          children: "or drop your files here"
        }), jsx(Typography, {
          color: "gray400",
          children: "Max file size: 10mb"
        })]
      }),
      multiple: multiple,
      fileList: fileList,
      showUploadList: false,
      customRequest: options => {
        var _a, _b, _c;
        const data = new FormData();
        data.append((payloadMapper === null || payloadMapper === void 0 ? void 0 : payloadMapper.fileField) || 'source_file', options.file);
        const config = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        };
        setIsUploading(true);
        const fileObj = Object.assign(Object.assign({}, options.file), {
          name: (_a = options === null || options === void 0 ? void 0 : options.file) === null || _a === void 0 ? void 0 : _a.name,
          uid: (_b = options === null || options === void 0 ? void 0 : options.file) === null || _b === void 0 ? void 0 : _b.uid,
          fileName: (_c = options === null || options === void 0 ? void 0 : options.file) === null || _c === void 0 ? void 0 : _c.name,
          status: 'loading'
        });
        fetcher.post(options.action, data, config).then(res => {
          // throw 'wrong format';
          fileObj.status = 'success';
          setFileList(curList => {
            const newFileObj = Object.assign(Object.assign({}, fileObj), {
              response: res
            });
            const newList = multiple ? [...curList, newFileObj] : [newFileObj];
            if (isFunction(onSettled)) {
              onSettled(newList);
            }
            return newList;
          });
        }).catch(err => {
          var _a;
          message.error(`upload failed: ${err.message}`);
          fileObj.status = 'error';
          fileObj.error = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data;
          setFileList(curList => {
            const newList = multiple ? [...curList, fileObj] : [fileObj];
            if (isFunction(onSettled)) {
              onSettled(newList);
            }
            return newList;
          });
        }).finally(() => {
          setIsUploading(false);
        });
      }
    }, otherProps)), jsx(_Spin, {
      spinning: isUploading,
      style: {
        minHeight: 80
      },
      children: fileList.length > 0 && jsx(FullWidthTable, {
        sticky: true,
        scroll: {
          y: 300
        },
        style: {
          marginTop: '20px'
        },
        dataSource: fileList,
        columns: fileColumns,
        pagination: false
      })
    })]
  });
}

const COLOR_MAPPER = {
  info: getColor('blue100'),
  warning: getColor('gold100'),
  error: getColor('red100')
};
const ICON_MAPPER = {
  info: jsx(Info, {
    color: "blue500"
  }),
  warning: jsx(Warning, {
    color: "gold500"
  }),
  error: jsx(Error$1, {
    color: "red500"
  })
};
const Wrapper$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "inline-note__Wrapper",
  componentId: "sc-1wjgedg-0"
})(["display:flex;width:100%;padding:16px;border-radius:8px;background-color:", ";box-shadow:0px 1px 2px rgba(0,0,0,0.06),0px 1px 3px rgba(0,0,0,0.1);"], props => COLOR_MAPPER[props.variant || 'info']);
const InlineNote = props => {
  const {
    children,
    className,
    style = {},
    variant = 'info',
    icon
  } = props;
  return jsxs(Wrapper$1, {
    className: className,
    variant: variant,
    style: style,
    children: [jsx("div", {
      style: {
        marginRight: 10
      },
      children: icon || ICON_MAPPER[variant]
    }), children]
  });
};

const Pagination$1 = /*#__PURE__*/styled(_Pagination).withConfig({
  displayName: "pagination__Pagination",
  componentId: "sc-1fei578-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css([".", "-pagination-prev,.", "-pagination-next{& button{border-radius:4px;display:flex;align-items:center;justify-content:center;}}.", "-select:not(.", "-select-customize-input) .", "-select-selector{border-radius:4px;}.", "-pagination-prev,.", "-pagination-next{display:inline-flex;justify-content:center;align-items:center;}.", "-pagination-item-link{flex:1;display:inline-flex;height:100%;width:100%;}.", "-pagination-jump-prev,.", "-pagination-jump-next{display:inline-flex;justify-content:center;align-items:center;}.", "-pagination-item-container{flex:1;display:flex;align-items:center;justify-content:center;}.", "-pagination-item{border-radius:4px;}.", "-pagination-item-active{background-color:", ";& a{color:", ";}}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.blue500, props.theme.colors.white);
});

var classof = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$3 = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};

var DESCRIPTORS = descriptors;
var isArray$2 = isArray$3;

var $TypeError$2 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray$2(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError$2('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError$1 = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$2 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError$1('Maximum allowed index exceeded');
  return it;
};

var $$3 = _export;
var toObject$2 = toObject$7;
var lengthOfArrayLike$3 = lengthOfArrayLike$6;
var setArrayLength = arraySetLength;
var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$2;
var fails$3 = fails$o;

var INCORRECT_TO_LENGTH = fails$3(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED$2 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$$3({ target: 'Array', proto: true, arity: 1, forced: FORCED$2 }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject$2(this);
    var len = lengthOfArrayLike$3(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger$1(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});

const StyledTrigger = /*#__PURE__*/styled.div.withConfig({
  displayName: "dropdown-select__StyledTrigger",
  componentId: "sc-15u8gl2-0"
})(["&:hover{button{background:", ";}}&.active{button{border-color:", ";}}button{.icon-down{display:initial;}.icon-up{display:none;}}&.pressed{button{border-color:", ";background:", ";.icon-down{display:none;}.icon-up{display:initial;}}}"], ({
  theme
}) => theme.getColor('gray100'), ({
  theme
}) => theme.getColor('gray800'), ({
  theme
}) => theme.getColor('gray800'), ({
  theme
}) => theme.getColor('gray200'));
const StyledCheckboxWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "dropdown-select__StyledCheckboxWrapper",
  componentId: "sc-15u8gl2-1"
})([".ant-checkbox-wrapper{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:100%;}"]);
const StyledButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "dropdown-select__StyledButton",
  componentId: "sc-15u8gl2-2"
})(["border-radius:8px;width:100%;...props?.style;"]);
const Overlay = /*#__PURE__*/styled.div.withConfig({
  displayName: "dropdown-select__Overlay",
  componentId: "sc-15u8gl2-3"
})(["background:#fff;width:300px;border-radius:8px;box-shadow:0px 4px 20px rgba(0,0,0,0.08);overflow:hidden;&.width-auto{width:auto;}"]);
const StyledFooter = /*#__PURE__*/styled.div.withConfig({
  displayName: "dropdown-select__StyledFooter",
  componentId: "sc-15u8gl2-4"
})(["padding:12px 20px;display:flex;align-items:center;justify-content:space-between;border-top:1px solid ", ";"], ({
  theme
}) => theme.getColor('borderLight'));
const StyledTriggerContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "dropdown-select__StyledTriggerContent",
  componentId: "sc-15u8gl2-5"
})(["display:flex;align-items:center;line-height:34px;font-weight:400;width:100%;justify-content:space-between;gap:8px;.title{overflow:hidden;text-overflow:ellipsis;}"]);
const DropdownSelectItem = props => {
  const {
    checked,
    indeterminate = false,
    children,
    onChange,
    checkboxDataTestId,
    hasDivider
  } = props;
  return jsxs(Fragment, {
    children: [jsx(StyledCheckboxWrapper, {
      children: jsx(Checkbox, {
        "data-testid": checkboxDataTestId,
        checked: checked,
        indeterminate: indeterminate,
        onChange: e => {
          onChange === null || onChange === void 0 ? void 0 : onChange(e.target.checked);
        },
        children: jsx(Typography, {
          color: "gray800",
          children: children
        })
      })
    }), hasDivider && jsx(_Divider, {
      style: {
        margin: '12px -20px',
        width: '120%',
        backgroundColor: getColor('gray200')
      }
    })]
  });
};
const DropdownSelect = props => {
  const {
    options,
    multiple = true,
    title,
    value,
    showSelectAll = false,
    overlayClassName,
    infinite = false,
    infiniteProps = {
      next: () => null,
      hasMore: false,
      loader: undefined,
      dataLength: 0
    },
    showManageButton = false,
    manageButtonLabel = 'Manage',
    onManageClick = noop$2,
    buttonStyle,
    wrapperStyle = {},
    contentValue,
    dataTestId,
    checkboxDataTestIdPrefix
  } = props;
  const propsRef = useRef(props);
  propsRef.current = props;
  const [innerValue, setInnerValue] = useState(value && Array.isArray(value) ? value : []);
  const [visible, setVisible] = useState(false);
  const domRef = useRef(null);
  const triggerRef = useRef(null);
  const handleClickOutOfContainer = useCallback(e => {
    var _a, _b;
    if (visible && triggerRef.current && !((_b = (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.contains) === null || _b === void 0 ? void 0 : _b.call(_a, e.target))) {
      setTimeout(() => {
        setVisible(false);
      }, 10);
    }
  }, [visible]);
  const onCheckChange = useCallback(val => {
    const {
      onChange
    } = propsRef.current;
    setInnerValue(val);
    setTimeout(() => {
      onChange === null || onChange === void 0 ? void 0 : onChange(val);
    }, 10);
  }, []);
  const onCheckAll = useCallback(checked => {
    const newVal = checked ? [...(options || []).map(ele => ele.value)] : [];
    onCheckChange(newVal);
  }, [options, onCheckChange]);
  const onCheckItem = useCallback((checked, item) => {
    let newVal = [...innerValue];
    if (multiple) {
      if (checked) {
        newVal.push(item.value);
      } else {
        newVal = newVal.filter(v => v !== item.value);
      }
    } else {
      newVal = [item.value];
    }
    onCheckChange(newVal);
  }, [innerValue, multiple, onCheckChange]);
  useClickOutside(domRef, handleClickOutOfContainer);
  const overlay = useMemo(() => {
    const content = jsxs(Fragment, {
      children: [showSelectAll && multiple ? jsx(DropdownSelectItem, {
        checked: (innerValue === null || innerValue === void 0 ? void 0 : innerValue.length) === (options === null || options === void 0 ? void 0 : options.length),
        indeterminate: !!(innerValue.length && options.length && innerValue.length < options.length),
        onChange: onCheckAll,
        checkboxDataTestId: `${checkboxDataTestIdPrefix}-all`,
        children: jsx(Typography, {
          fontWeight: 600,
          color: "gray800",
          children: "All"
        })
      }) : null, options === null || options === void 0 ? void 0 : options.map((ele, index) => {
        return jsx("div", {
          style: {
            marginTop: !index && !showSelectAll ? 0 : 20
          },
          children: jsxs(DropdownSelectItem, {
            hasDivider: ele.hasDivider,
            checkboxDataTestId: `${checkboxDataTestIdPrefix}-${ele.value}`,
            checked: innerValue === null || innerValue === void 0 ? void 0 : innerValue.includes(ele.value),
            onChange: checked => onCheckItem(checked, ele),
            children: [jsx(Typography, {
              color: "gray800",
              children: ele.label
            }), (ele === null || ele === void 0 ? void 0 : ele.caption) && jsx(Typography, {
              variant: "caption",
              color: "gray600",
              children: ele.caption
            })]
          })
        }, ele.value);
      })]
    });
    return jsxs(Overlay, {
      ref: domRef,
      className: classNames([overlayClassName, infinite ? 'infinite-scroll' : '']),
      children: [infinite ? jsx("div", {
        style: {
          maxHeight: 200,
          padding: '30px 20px',
          overflow: visible ? 'auto' : 'hidden'
        },
        id: "dropdown-select-infinite-scroll-wrapper",
        children: jsx(ReactInfiniteScrollComponent, Object.assign({
          scrollableTarget: "dropdown-select-infinite-scroll-wrapper"
        }, infiniteProps, {
          children: content
        }))
      }) : jsx("div", {
        style: {
          padding: '30px 20px',
          maxHeight: 300,
          overflowY: visible ? 'auto' : 'hidden'
        },
        children: content
      }), jsxs(StyledFooter, {
        children: [jsx("button", {
          onClick: () => {
            onCheckAll(false);
          },
          "data-testid": "dropdown_select_clear",
          "aria-hidden": "true",
          children: jsx(Typography, {
            color: "blue600",
            children: "Clear"
          })
        }), showManageButton && jsx("div", {
          onClick: () => {
            onManageClick();
            setVisible(false);
          },
          children: jsx(Typography, {
            variant: "link",
            color: "blue600",
            children: manageButtonLabel
          })
        })]
      })]
    });
  }, [checkboxDataTestIdPrefix, infinite, infiniteProps, innerValue, manageButtonLabel, multiple, onCheckAll, onCheckItem, onManageClick, options, overlayClassName, showManageButton, showSelectAll, visible]);
  useEffect(() => {
    if (value && Array.isArray(value)) {
      setInnerValue(value);
    }
  }, [value]);
  return jsx("div", {
    ref: triggerRef,
    style: wrapperStyle,
    children: jsx(_Dropdown, {
      overlay: overlay,
      visible: visible,
      children: jsx(StyledTrigger, {
        className: visible ? 'pressed' : (value === null || value === void 0 ? void 0 : value.length) ? 'active' : '',
        children: jsxs(StyledButton, {
          "data-testid": dataTestId,
          style: buttonStyle,
          size: "compact",
          onClick: () => {
            setVisible(!visible);
          },
          children: [contentValue, jsxs(StyledTriggerContent, {
            children: [jsx("div", {
              className: "title",
              children: title
            }), jsx(SmallChevronUp, {
              className: "icon-up",
              size: 18
            }), jsx(SmallChevronDown, {
              className: "icon-down",
              size: 18
            })]
          })]
        })
      })
    })
  });
};

const WarnButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "warn-button__WarnButton",
  componentId: "sc-13uq3g7-0"
})(["color:#ffffff;background:", ";border:", ";&:hover{background:", ";}&.disabled{color:#ffffff;background:", ";}&.loading{background:", ";}"], props => props.theme.colors.red500, props => props.theme.colors.red500, props => props.theme.colors.red300, props => props.theme.colors.red200, props => props.theme.colors.red300);

var aCallable$1 = aCallable$b;
var toObject$1 = toObject$7;
var IndexedObject = indexedObject;
var lengthOfArrayLike$2 = lengthOfArrayLike$6;

var $TypeError = TypeError;

var REDUCE_EMPTY = 'Reduce of empty array with no initial value';

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    var O = toObject$1(that);
    var self = IndexedObject(O);
    var length = lengthOfArrayLike$2(O);
    aCallable$1(callbackfn);
    if (length === 0 && argumentsLength < 2) throw new $TypeError(REDUCE_EMPTY);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw new $TypeError(REDUCE_EMPTY);
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};

var fails$2 = fails$o;

var arrayMethodIsStrict$1 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$2(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};

var $$2 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict = arrayMethodIsStrict$1;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED$1 = CHROME_BUG || !arrayMethodIsStrict('reduce');

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$2({ target: 'Array', proto: true, forced: FORCED$1 }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
  }
});

// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$1 = functionUncurryThis;
var requireObjectCoercible$1 = requireObjectCoercible$8;
var toString$2 = toString$9;
var whitespaces$1 = whitespaces$2;

var replace = uncurryThis$1(''.replace);
var ltrim = RegExp('^[' + whitespaces$1 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$1 + '])[' + whitespaces$1 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString$2(requireObjectCoercible$1($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};

var global$1 = global$n;
var fails$1 = fails$o;
var uncurryThis = functionUncurryThis;
var toString$1 = toString$9;
var trim = stringTrim.trim;
var whitespaces = whitespaces$2;

var $parseInt$1 = global$1.parseInt;
var Symbol$1 = global$1.Symbol;
var ITERATOR = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis(hex.exec);
var FORCED = $parseInt$1(whitespaces + '08') !== 8 || $parseInt$1(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR && !fails$1(function () { $parseInt$1(Object(ITERATOR)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED ? function parseInt(string, radix) {
  var S = trim(toString$1(string));
  return $parseInt$1(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt$1;

var $$1 = _export;
var $parseInt = numberParseInt;

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$$1({ global: true, forced: parseInt !== $parseInt }, {
  parseInt: $parseInt
});

const defaultAvatarBgColors = ['blue500', 'green500', 'gold500', 'red500', 'gray900', 'gray700', 'green700', 'green800', 'gold800', 'red700', 'red800', 'blue700', 'blue800'];
function getColorsBySeed(seed) {
  if (!seed) {
    return {
      bgColor: 'blue500',
      color: 'white'
    };
  }
  const numberArg = parseInt(seed.split('').reduce((a, b) => a + b.charCodeAt(0), ''));
  const index = numberArg % defaultAvatarBgColors.length;
  return {
    bgColor: defaultAvatarBgColors[index],
    color: 'white'
  };
}

/**
 *
 * @param props
 * @returns
 *
 */
const UserAvatar = props => {
  const {
      firstName = '',
      lastName = '',
      src = '',
      size = 'default',
      id,
      showFullName = false,
      alt
    } = props,
    restProps = __rest(props, ["firstName", "lastName", "src", "size", "id", "showFullName", "alt"]);
  const name = useMemo(() => {
    return showFullName ? `${firstName}${lastName}` : (((firstName === null || firstName === void 0 ? void 0 : firstName.charAt(0)) || '') + ((lastName === null || lastName === void 0 ? void 0 : lastName.charAt(0)) || '')).toUpperCase();
  }, [firstName, lastName, showFullName]);
  if (src && !alt) {
    console.warn('[Avatar(hr-ui)] must have alt prop defined if src is defined! Now src is used as alt.');
  }
  return jsx(Avatar$1, Object.assign({
    "$size": size === 'default' ? 'medium' : size,
    src: src,
    alt: alt || src,
    seed: String(id),
    getColorsBySeed: getColorsBySeed
  }, restProps, {
    children: name
  }));
};

const useAutoSize = (textAreaRef, defaultSet, value, maxHeight) => {
  useEffect(() => {
    if (textAreaRef) {
      textAreaRef.style.height = '0px';
      const scrollHeight = textAreaRef.scrollHeight;
      const newHeight = maxHeight && scrollHeight >= maxHeight ? maxHeight : scrollHeight;
      textAreaRef.style.height = newHeight + 'px';
    }
  }, [textAreaRef, defaultSet, value, maxHeight]);
};

const TextArea = /*#__PURE__*/styled.textarea.withConfig({
  displayName: "text-area-grow__TextArea",
  componentId: "sc-1wpacsh-0"
})(["width:100%;resize:none;border:1px solid ", ";padding:14px 16px;font-family:'Plus Jakarta Sans';font-size:14px;line-height:20px;border-radius:20px;overflow-y:auto;resize:none;scroll-padding:14px;box-sizing:border-box;::-webkit-scrollbar{width:0 !important;}-ms-overflow-style:none;scrollbar-width:none;&::placeholder{color:", ";font-size:14px;line-height:20px;font-family:'Plus Jakarta Sans';}&:focus,&:active{border:1px solid ", ";outline:none;}", ""], colors$1.gray400, colors$1.gray600, colors$1.gray800, props => props.$borderColor && `
    border-color: ${getColor$1(props.$borderColor)};

    // override active color only when it is not special status color
    &:focus,
    &:active {
      border-color: ${getColor$1(props.$borderColor) !== colors$1.gray400 ? getColor$1(props.$borderColor) : colors$1.gray800} !important;
    }
  `);
const TextAreaContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "text-area-grow__TextAreaContainer",
  componentId: "sc-1wpacsh-1"
})(["display:flex;width:100%;flex-direction:column;align-items:flex-end;"]);
const TextAreaGrow = props => {
  const {
    value,
    maxHeight = 108
  } = props;
  const textAreaRef = useRef(null);
  const [defaultSet, setDefaultSet] = useState(false);
  useAutoSize(textAreaRef.current, defaultSet, value, maxHeight);
  /** you're probably wondering why this is needed. its because if there's a default value,
  the textarea will not grow on the first render. this is because the ref is still null
  so this forces the autosize to trigger
  bad hacks 101
  */
  useEffect(() => {
    setDefaultSet(true);
  }, []);
  const renderMessage = () => {
    if (props.message) {
      return jsx(Typography, {
        color: getStatusColor(),
        children: props.message
      });
    }
    return null;
  };
  const getStatusColor = () => {
    let color = 'gray400';
    switch (props.status) {
      case 'error':
        color = 'red500';
        break;
      case 'warning':
        color = 'gold500';
        break;
    }
    return color;
  };
  return jsxs(TextAreaContainer, {
    children: [jsx(TextArea, Object.assign({
      ref: textAreaRef,
      rows: 1
    }, props, {
      "$borderColor": getStatusColor()
    })), renderMessage()]
  });
};

var errorImage = "data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%3F%3E%3Csvg%20width%3D%22113px%22%20height%3D%22164px%22%20viewBox%3D%220%200%20113%20164%22%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%20%20%20%20%20%20%20%20%3Ctitle%3Eghost%3C%2Ftitle%3E%20%20%20%20%3Cdesc%3ECreated%20with%20Sketch.%3C%2Fdesc%3E%20%20%20%20%3Cdefs%3E%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M84.5165882%2C10.3461071%20C100.09547%2C21.8146249%20103.5%2C30%20105.516588%2C41.8461071%20C106.86098%2C49.7435119%20106.86098%2C73.7435119%20105.516588%2C113.846107%20L95.5%2C102.5%20L85%2C114.5%20L75%2C102.5%20L64%2C114.5%20L54%2C102.5%20L43.5%2C114.672187%20L33.5%2C102.5%20L23%2C114.672187%20L13.5%2C102.5%20L1.01658823%2C114.672187%20C-0.305686288%2C75.0188717%20-0.305686288%2C50.7435119%201.01658823%2C41.8461071%20C3%2C28.5%207.39649968%2C22.7471669%2022.5%2C11%20C45%2C-6.5%2072.5%2C1.5%2084.5165882%2C10.3461071%20Z%22%20id%3D%22path-1%22%3E%3C%2Fpath%3E%20%20%20%20%3C%2Fdefs%3E%20%20%20%20%3Cg%20id%3D%22Test%22%20stroke%3D%22none%22%20stroke-width%3D%221%22%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%20%20%20%20%20%20%20%20%3Cg%20id%3D%22404%22%20transform%3D%22translate%28-409.000000%2C%20-275.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-3%22%20transform%3D%22translate%28412.000000%2C%20278.000000%29%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Group-2%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22ghost%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cellipse%20id%3D%22Oval-5%22%20fill%3D%22%23EFF1EF%22%20cx%3D%2254%22%20cy%3D%22156%22%20rx%3D%2252%22%20ry%3D%225%22%3E%3C%2Fellipse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M16.5%2C123.5%20C20%2C135%2096.5450773%2C127.950773%2097%2C132.5%20C97.5%2C137.5%2010.5%2C138.5%2011.5%2C144.5%20C12.2798379%2C149.179027%2026.2798379%2C151.512361%2053.5%2C151.5%22%20id%3D%22Line-2%22%20stroke%3D%22%23D1D1D1%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22square%22%20stroke-dasharray%3D%221%2C6%2C1%2C1%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpolygon%20id%3D%22Star%22%20stroke%3D%22%23979797%22%20stroke-width%3D%222%22%20fill%3D%22%23F5F6FA%22%20transform%3D%22translate%2870.159180%2C%20144.883476%29%20rotate%28-46.000000%29%20translate%28-70.159180%2C%20-144.883476%29%20%22%20points%3D%2270.1591796%20149.215728%2064.0324506%20151.010205%2065.826928%20144.883476%2064.0324506%20138.756747%2070.1591796%20140.551224%2076.2859086%20138.756747%2074.4914312%20144.883476%2076.2859086%20151.010205%22%3E%3C%2Fpolygon%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-3%22%20stroke%3D%22%23979797%22%20stroke-width%3D%222%22%20fill%3D%22%23F5F6FA%22%20cx%3D%2244.5%22%20cy%3D%22138.5%22%20r%3D%224.5%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-2%22%20stroke%3D%22%23979797%22%20fill%3D%22%23F5F6FA%22%20cx%3D%2227%22%20cy%3D%22122%22%20r%3D%222%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval-2%22%20stroke%3D%22%23979797%22%20fill%3D%22%23F5F6FA%22%20cx%3D%2288.5%22%20cy%3D%22141.5%22%20r%3D%221.5%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M73.368724%2C122.457376%20L71.9185078%2C120.58816%20L70.4316699%2C122.457376%20C70.216822%2C122.718596%2070.0349364%2C122.904874%2069.8860077%2C123.016214%20C69.7370791%2C123.127554%2069.5478692%2C123.183223%2069.3183726%2C123.183223%20C69.0644614%2C123.183223%2068.848396%2C123.113636%2068.6701699%2C122.974462%20C68.4919438%2C122.835287%2068.402832%2C122.675773%2068.402832%2C122.495916%20C68.402832%2C122.311777%2068.5395514%2C122.04842%2068.8129942%2C121.705835%20L70.6221023%2C119.431943%20L69.0180753%2C117.537033%20C68.7397496%2C117.224425%2068.6005888%2C116.952503%2068.6005888%2C116.721259%20C68.6005888%2C116.541402%2068.683597%2C116.3851%2068.8496158%2C116.252349%20C69.0156347%2C116.119597%2069.2329208%2C116.053223%2069.5014807%2C116.053223%20C69.7358602%2C116.053223%2069.9299529%2C116.111033%2070.0837645%2C116.226655%20C70.2375761%2C116.342277%2070.4170202%2C116.524272%2070.6221023%2C116.772646%20L71.9185078%2C118.327115%20L73.1782916%2C116.772646%20C73.3882566%2C116.515708%2073.5701421%2C116.331572%2073.7239537%2C116.220232%20C73.8777653%2C116.108892%2074.0694165%2C116.053223%2074.2989132%2C116.053223%20C74.5625902%2C116.053223%2074.781097%2C116.118527%2074.9544402%2C116.249137%20C75.1277834%2C116.379747%2075.2144537%2C116.53712%2075.2144537%2C116.721259%20C75.2144537%2C116.85401%2075.1790532%2C116.981407%2075.108251%2C117.103452%20C75.0374489%2C117.225498%2074.9288058%2C117.370024%2074.7823186%2C117.537033%20L73.1782916%2C119.431943%20L74.9873997%2C121.705835%20C75.2706083%2C122.061267%2075.4122105%2C122.328907%2075.4122105%2C122.508763%20C75.4122105%2C122.692902%2075.3243195%2C122.851345%2075.1485348%2C122.984097%20C74.9727502%2C123.116848%2074.755464%2C123.183223%2074.49667%2C123.183223%20C74.2671733%2C123.183223%2074.0730807%2C123.125413%2073.9143862%2C123.00979%20C73.7556917%2C122.894168%2073.5738061%2C122.710032%2073.368724%2C122.457376%20Z%22%20id%3D%22x%22%20fill%3D%22%23949596%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Rectangle-3%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cmask%20id%3D%22mask-2%22%20fill%3D%22white%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fmask%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cg%20id%3D%22Mask%22%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cuse%20fill%3D%22%23F5F6FA%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23path-1%22%3E%3C%2Fuse%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20stroke%3D%22%23949596%22%20stroke-width%3D%223%22%20d%3D%22M95.5050133%2C104.772159%20L84.9721765%2C116.809687%20L74.9462066%2C104.778523%20L63.9462066%2C116.778523%20L53.9802406%2C104.819364%20L43.4720103%2C117.001091%20L33.4720103%2C104.828905%20L22.9420079%2C117.035872%20L13.3480088%2C104.743246%20L-0.36932221%2C118.118588%20L-0.482578507%2C114.722178%20C-1.80854101%2C74.9582647%20-1.80854101%2C50.6518695%20-0.46711672%2C41.6256085%20C1.53739923%2C28.1374943%205.83268151%2C22.0631776%2021.5790891%2C9.81597167%20C32.2223154%2C1.53790675%2044.659302%2C-1.76058178%2057.5622574%2C-0.701711081%20C68.1120865%2C0.164052194%2078.4414708%2C4.0112448%2085.4058511%2C9.13812881%20C99.8098519%2C19.7417487%20104.60182%2C27.5341979%20106.995315%2C41.5943802%20C108.364666%2C49.6384015%20108.364666%2C73.6587002%20107.015746%2C113.896365%20L106.889322%2C117.667527%20L95.5050133%2C104.772159%20Z%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cpath%20d%3D%22M51%2C-5.42101086e-17%20C51.4480077%2C0.00153007755%2051.781341%2C0.00153007755%2052%2C-2.31065167e-15%20C81.0179062%2C-0.203054278%2099.5101585%2C14.3033779%20105.5%2C37.5140137%20C105.996993%2C39.4398598%20106.330326%2C41.2731931%20106.5%2C43.0140137%20L106.5%2C115.5%20L96%2C102.5%20C97.3333333%2C68.5%2096.5%2C47.3333333%2093.5%2C39%20C86.9215687%2C20.7265796%2072.754902%2C7.72657959%2051%2C-5.42101086e-17%20Z%22%20fill%3D%22%23D8D8D8%22%20opacity%3D%220.539175725%22%20mask%3D%22url%28%23mask-2%29%22%3E%3C%2Fpath%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Crect%20id%3D%22Rectangle-2%22%20fill%3D%22%23949596%22%20x%3D%2247%22%20y%3D%2283%22%20width%3D%2215%22%20height%3D%223%22%20rx%3D%221.5%22%3E%3C%2Frect%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%23949596%22%20cx%3D%2281%22%20cy%3D%2256%22%20r%3D%223%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Ccircle%20id%3D%22Oval%22%20fill%3D%22%23949596%22%20cx%3D%2228%22%20cy%3D%2256%22%20r%3D%223%22%3E%3C%2Fcircle%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%20%20%20%20%3C%2Fg%3E%20%20%20%20%3C%2Fg%3E%3C%2Fsvg%3E";

// This is just a temporary page until Paywall goes full GA
const ERErrorPage = props => {
  return jsx("div", {
    className: (props === null || props === void 0 ? void 0 : props.className) || '',
    children: jsxs("div", {
      className: "error-container",
      children: [jsx("div", {
        className: "left",
        children: jsx("img", {
          src: errorImage,
          alt: "error"
        })
      }), jsxs("div", {
        className: "right",
        children: [jsx("div", {
          className: "row title",
          children: jsx("span", {
            className: "top-label",
            children: "Something went wrong!"
          })
        }), jsx("div", {
          className: "row content",
          children: jsx("span", {
            className: "bottom-label",
            children: "Please check your browser console for error details."
          })
        })]
      })]
    })
  });
};
const ErrorPlaceholder = /*#__PURE__*/styled(ERErrorPage).withConfig({
  displayName: "error-placeholder__ErrorPlaceholder",
  componentId: "sc-159zmmz-0"
})(["width:100vw;height:100vh;display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:#f5f6fa;& .error-container{width:30rem;height:20rem;padding:1rem;display:flex;justify-content:center;align-items:center;& .left{display:flex;}& .right{margin-left:4rem;display:flex;flex-direction:column;& .title{font-size:2rem;}& .content{font-size:1rem;}& .row:not(:first-child){margin-top:1rem;}& .top-label{color:#9e9fa0;font-size:20px;font-weight:600;font-style:normal;}& .bottom-label{color:#9e9fa0;font-size:13px;font-style:normal;}}}"]);

const LoadingWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "loading-placeholder__LoadingWrapper",
  componentId: "sc-7fxcik-0"
})(["display:flex;justify-content:center;align-items:center;height:100%;width:100%;position:relative;"]);
const LoadingPlaceholder = () => {
  return jsx(LoadingWrapper, {
    children: jsx(_Spin, {
      size: "large"
    })
  });
};

const ListSearchInputInner = _a => {
  var {
      searchKey = 'query',
      searchOnChange,
      placeholder = 'Search team members',
      autoClearPage = true,
      debounceDelay = 0
    } = _a,
    props = __rest(_a, ["searchKey", "searchOnChange", "placeholder", "autoClearPage", "debounceDelay"]);
  const [urlState, setUrlState] = useUrlState({
    [searchKey]: undefined
  });
  const searchValue = urlState[searchKey];
  const [searchText, setSearchText] = useState(searchValue);
  const debouncedSearchText = useDebounce(searchText, {
    wait: debounceDelay
  });
  const setSearchValue = useCallback(value => {
    setUrlState(s => ({
      [searchKey]: value ? value : undefined,
      page: autoClearPage ? 1 : s['page']
    }));
  }, [searchKey, autoClearPage, setUrlState]);
  useEffect(() => {
    if (searchOnChange) {
      setSearchValue(debouncedSearchText);
    }
  }, [searchOnChange, debouncedSearchText, setSearchValue]);
  useEffect(() => {
    // Update seachText when searchValue from URL is changed by other components
    if (searchValue !== searchText) {
      setSearchText(searchValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);
  return jsx(_Input.Search, Object.assign({
    allowClear: true,
    value: searchText,
    onChange: e => {
      setSearchText(e.target.value);
    },
    onSearch: setSearchValue,
    placeholder: placeholder
  }, props));
};

const antdInputStyles = /*#__PURE__*/css(["border-radius:8px;padding:10px 16px 10px 16px !important;font-family:'Plus Jakarta Sans',sans-serif;font-size:14px;&:hover,&:focus{box-shadow:none;border-color:", ";}&::placeholder{color:", ";}&:-ms-input-placeholder{color:", ";}&::-ms-input-placeholder{color:", ";}"], props => props.theme.colors.gray800, props => props.theme.colors.gray600, props => props.theme.colors.gray600, props => props.theme.colors.gray600);
const ListSearchInput = /*#__PURE__*/styled(ListSearchInputInner).attrs(props => ({
  suffix: jsx(MagnifyingGlass, {
    style: {
      color: props.theme.colors.gray600,
      width: '16px',
      height: '16px',
      cursor: 'pointer'
    }
  })
})).withConfig({
  displayName: "list-search-input__ListSearchInput",
  componentId: "sc-y0e716-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["width:240px;height:40px;& .", "-input-affix-wrapper{padding:0 11px 0 0;border-radius:8px !important;height:40px;}& .", "-input-affix-wrapper + .", "-input-group-addon{display:none;}.", "-input-suffix{right:18px;}& .", "-input-affix-wrapper:not(.", "-input-affix-wrapper-disabled):hover{border-color:", ";}& .", "-input-affix-wrapper:focus,.", "-input-affix-wrapper-focused{box-shadow:none;border-color:", ";}& .", "-input{", "}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, props.theme.colors.gray800, antdCssPrefix, antdCssPrefix, props.theme.colors.gray800, antdCssPrefix, antdInputStyles);
});

const DropDownMenu = /*#__PURE__*/styled(_Menu).withConfig({
  displayName: "dropdown-menu__DropDownMenu",
  componentId: "sc-9dm31y-0"
})(() => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["border-radius:8px;box-shadow:0px 4px 20px rgba(0,0,0,0.08);.", "-dropdown-menu-submenu-title{min-height:44px;display:flex;align-items:center;}"], antdCssPrefix);
});

function RawPopover(_a) {
  var {
      className
    } = _a,
    otherProps = __rest(_a, ["className"]);
  return jsx(_Popover, Object.assign({}, otherProps, {
    overlayClassName: className
  }));
}
/**
 * Restyled antd popover component in the new design
 * language.
 */
const Popover = /*#__PURE__*/styled(RawPopover).withConfig({
  displayName: "popover__Popover",
  componentId: "sc-1ptrn5x-0"
})(() => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["width:257px;font-family:'Plus Jakarta Sans';font-size:14px;line-height:20px;& .", "-popover-arrow{display:none;}& .", "-popover-content{padding:12px 12px 20px 20px;box-shadow:", ";border-radius:8px;background:#ffffff;}& .", "-popover-title{font-weight:600;color:", ";padding:0;border-bottom:none;}& .", "-popover-inner{box-shadow:none;}& .", "-popover-inner-content{padding:0;color:", ";& a{color:", ";}}"], antdCssPrefix, antdCssPrefix, theme.boxShadows.e3, antdCssPrefix, colors.gray800, antdCssPrefix, antdCssPrefix, colors.gray600, colors.textLink);
});

const Collapse = /*#__PURE__*/styled(_Collapse).withConfig({
  displayName: "collapse__Collapse",
  componentId: "sc-t8krjv-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return css(["border-radius:12px;box-shadow:0px 1px 2px rgba(0,0,0,0.06),0px 1px 3px rgba(0,0,0,0.1);border:none;.", "-collapse-item{&:first-child{border-radius:12px 12px 0 0;border-top-left-radius:12px;border-top-right-radius:12px;}&:last-child{border-bottom-left-radius:12px;border-bottom-right-radius:12px;}background:white;.", "-collapse-header{padding:24px 20px;}}.", "-collapse-content-box{padding:20px;}.", "-collapse-item:last-child{.", "-collapse-header{border-radius:12px 12px 0 0;}.", "-collapse-content{border-radius:0 0 12px 12px;}}"], antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix, antdCssPrefix);
});

const {
  Item: Item$1,
  SubMenu
} = DropDownMenu;
const DropdownPicker = props => {
  const {
    options = [],
    onClick = noop$2,
    value,
    children,
    showSelectedStatus,
    disabled = false,
    canClear = false
  } = props;
  const renderOptionItem = useCallback(option => {
    if (isFunction(option.render)) {
      return option.render(option);
    } else {
      return jsxs(FlexBox, {
        direction: "row",
        justify: "space-between",
        style: {
          width: '100%'
        },
        align: "center",
        children: [jsxs(FlexBox, {
          direction: "column",
          children: [jsx(Typography, {
            children: option.title
          }), option.caption && jsx(Typography, {
            variant: "caption",
            color: "gray500",
            children: option.caption
          })]
        }), value === option.value && showSelectedStatus && jsx(Checkmark, {})]
      });
    }
  }, [value, showSelectedStatus]);
  const renderMenu = useCallback(options => {
    return options.map(option => {
      const itemStyle = option.style || {};
      return (option === null || option === void 0 ? void 0 : option.isDivider) ? jsx("hr", {
        style: {
          color: getColor('gray200')
        }
      }, option.value) : (option === null || option === void 0 ? void 0 : option.children) && (option === null || option === void 0 ? void 0 : option.children.length) > 0 ? jsx(SubMenu, {
        title: option === null || option === void 0 ? void 0 : option.title,
        style: {
          minHeight: '40px'
        },
        children: renderMenu(option.children)
      }, `${option === null || option === void 0 ? void 0 : option.title}-submenu`) : jsx(Item$1, {
        onClick: (option === null || option === void 0 ? void 0 : option.onClick) || noop$2,
        disabled: !!(option === null || option === void 0 ? void 0 : option.disabled),
        children: jsx(FlexBox, {
          justify: "space-between",
          style: Object.assign({
            width: '300px',
            minHeight: '40px'
          }, itemStyle),
          children: renderOptionItem(option)
        })
      }, option.value);
    });
  }, [renderOptionItem]);
  const menu = jsxs(DropDownMenu, {
    onClick: onClick,
    children: [renderMenu(options), canClear && jsxs(Fragment, {
      children: [jsx(_Menu.Divider, {
        style: {
          backgroundColor: `${theme.colors.gray300}`
        }
      }), jsx(Item$1, {
        children: jsx(FlexBox, {
          justify: "space-between",
          style: {
            width: '300px',
            minHeight: '40px'
          },
          children: jsx(FlexBox, {
            direction: "row",
            justify: "space-between",
            style: {
              width: '100%'
            },
            align: "center",
            children: jsx(FlexBox, {
              direction: "column",
              children: jsx(Typography, {
                color: "blue500",
                children: "Clear"
              })
            })
          })
        })
      }, 'clear-value')]
    })]
  });
  return jsx(_Dropdown, {
    disabled: disabled,
    overlay: menu,
    trigger: ['click'],
    children: children
  });
};

const PWModal = /*#__PURE__*/styled(Modal).withConfig({
  displayName: "paywall-modalstyles__PWModal",
  componentId: "sc-1px4pjl-0"
})(["width:700px !important;.ant4-modal-body{padding:0 !important;overflow:hidden !important;}.ant4-modal-footer{border-top:none !important;padding:0 !important;height:80px;display:", " !important;}.ant4-modal-close{display:", " !important;}"], ({
  showFooter
}) => showFooter ? 'block' : 'none', ({
  showClose
}) => showClose ? 'block' : 'none');
const Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Container",
  componentId: "sc-1px4pjl-1"
})(["display:flex;flex-direction:column;width:100%;height:100%;overflow:hidden;height:", ";"], ({
  height
}) => height ? `${height}px` : 'auto');
const Banner = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Banner",
  componentId: "sc-1px4pjl-2"
})(["height:298px;width:100%;border-top-right-radius:12px;border-top-left-radius:12px;background:", ";img{pointer-events:none;object-fit:cover;margin-left:auto;margin-right:auto;}overflow:hidden;"], ({
  gradient
}) => gradient || 'linear-gradient(164deg, rgba(123, 128, 183, 0.4), rgba(123, 128, 183, 0.15) 50%, rgba(123, 128, 183, 0.4))');
const Body = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Body",
  componentId: "sc-1px4pjl-3"
})(["position:relative;"]);
const BodyContent = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__BodyContent",
  componentId: "sc-1px4pjl-4"
})(["padding:32px;padding-top:40px;padding-bottom:12px;overflow:auto;position:relative;box-sizing:border-box;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;"]);
const Footer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Footer",
  componentId: "sc-1px4pjl-6"
})(["display:flex;justify-content:space-between;align-items:center;width:100%;height:80px;padding:10px 32px;border-top:", ";"], ({
  hasBorder
}) => hasBorder ? `1px solid ${colors.gray400}` : 'none');
const FooterLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "paywall-modalstyles__FooterLink",
  componentId: "sc-1px4pjl-7"
})(["color:rgba(104,114,138,1);font-size:14px;line-height:20px;font-family:'Plus Jakarta Sans';font-weight:600;display:flex;align-items:center;svg{margin-left:6px;width:16px;height:16px;}&:hover{color:rgba(104,114,138,0.8);}"]);
const FooterButtonContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__FooterButtonContainer",
  componentId: "sc-1px4pjl-8"
})(["display:flex;align-items:center;justify-content:flex-end;gap:8px;button{min-width:100px;}"]);
const ConfirmButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "paywall-modalstyles__ConfirmButton",
  componentId: "sc-1px4pjl-9"
})(["background-color:", ";color:#fff;&:hover{background-color:", ";}&:active{background-color:", ";}svg{width:20px;margin-left:8px;}"], colors.blue500, colors.blue600, colors.blue700);
const PremiumTag = /*#__PURE__*/styled.span.withConfig({
  displayName: "paywall-modalstyles__PremiumTag",
  componentId: "sc-1px4pjl-10"
})(["background-color:", ";color:", ";padding:2px 8px;border-radius:4px;font-size:12px;font-weight:600;max-height:21px;max-width:68px;margin-left:8px;font-family:'Plus Jakarta Sans';"], colors.gold200, colors.gold800);
const BulletPointContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__BulletPointContainer",
  componentId: "sc-1px4pjl-11"
})(["display:flex;flex-direction:column;margin-top:32px;svg{width:16px;height:16px;margin-right:9px;color:", ";}.bulletpoint{margin-bottom:20px;}.bulletpoint:last-child{margin-bottom:0;}"], colors.textPrimary);
const FormHeader = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__FormHeader",
  componentId: "sc-1px4pjl-13"
})(["height:64px;border-bottom:1px solid ", ";display:flex;align-items:center;padding:20px;button{display:grid;place-items:center;margin-top:1px;margin-right:4px;svg{color:#787883;}}"], colors.gray400);
const FormLine = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__FormLine",
  componentId: "sc-1px4pjl-14"
})(["height:1px;background-color:", ";position:absolute;width:100%;top:482px;"], colors.gray400);
const FormBackButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "paywall-modalstyles__FormBackButton",
  componentId: "sc-1px4pjl-15"
})(["position:absolute;top:505px;right:128px;min-width:100px;"]);
const formCSS = `
  * {
    font-family: 'Plus Jakarta Sans';
  }

  form {
    height: 500px;
    margin: 0;
    padding: 20px;
    padding-top: 0px;
    width: 700px;
    box-sizing: border-box;
    position: relative;
  }

  .hub-spot-form-submit-button {
    background-color: ${colors.blue500};
    padding: 10px 0;
    width: 100px;
    border-radius: 8px;
    border: none;
    color: ${colors.blue500};
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
  }

  input[type='submit'] {
    cursor: pointer;
  }

  .hub-spot-form-submit-button:hover {
    background-color: ${colors.blue600};
    color: ${colors.blue600};
  }

  .hub-spot-form-submit-button:active {
    background-color: ${colors.blue700};
    color: ${colors.blue700};
  }

  .hs-submit .actions::before {
    content: 'Submit';
    width: 100px;
    color: black;
    position: absolute;
    font-family: 'Plus Jakarta Sans';
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    pointer-events: none;
    top: 50%;
    transform: translateY(-50%);
  }

  .hs-submit .actions {
    position: absolute;
    right: 20px;
    top: 433px;
    margin: 0;
    padding: 0;
  }

  .hs-form-field input, select {
    background: none !important;
    -moz-appearance:none; /* Firefox */
    -webkit-appearance:none; /* Safari and Chrome */
    appearance:none;
    border-radius: 8px;
    border: 1px solid ${colors.gray400};
  }

  .hs-input select {
    border-radius: 8px;
    border: 1px solid ${colors.gray400};
  }

  .hs-error-msgs {
    display: none;
  }
`;
const Step2Container = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Step2Container",
  componentId: "sc-1px4pjl-16"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;height:546px;width:100%;"]);
const Spinner = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Spinner",
  componentId: "sc-1px4pjl-17"
})(["width:24px;height:24px;border:3.5px solid rgba(43,45,51,0.24);border-bottom-color:transparent;border-radius:50%;display:inline-block;box-sizing:border-box;animation:rotation 1.2s linear infinite;}@keyframes rotation{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
const SpinnerContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__SpinnerContainer",
  componentId: "sc-1px4pjl-18"
})(["display:flex;align-items:center;justify-content:center;margin-top:100px;"]);
const HubspotFormContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__HubspotFormContainer",
  componentId: "sc-1px4pjl-19"
})(["iframe{height:632px !important;overflow:visible !important;}"]);
const LearnMoreButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "paywall-modalstyles__LearnMoreButton",
  componentId: "sc-1px4pjl-20"
})(["svg{width:20px;margin-left:6px;}color:", ";"], colors.gray800);
const Disclaimer = /*#__PURE__*/styled.div.withConfig({
  displayName: "paywall-modalstyles__Disclaimer",
  componentId: "sc-1px4pjl-21"
})(["position:absolute;width:100%;top:420px;padding:20px;"]);

const Step0 = props => {
  const {
    bannerGradient,
    bannerSrc,
    showPremium,
    title,
    bulletPoints = [],
    bannerImgStyle,
    caption
  } = props;
  return jsxs(Fragment, {
    children: [jsx(Banner, {
      gradient: bannerGradient,
      children: bannerSrc && jsx("img", {
        src: bannerSrc,
        alt: "",
        style: bannerImgStyle
      })
    }), jsx(Body, {
      children: jsxs(BodyContent, {
        children: [caption && jsx(Typography, {
          marginBottom: "8px",
          variant: "caption",
          color: "gray600",
          fontWeight: "semibold",
          letterSpacing: '0.7px',
          children: caption
        }), jsxs(FlexBox, {
          alignItems: "center",
          children: [jsx(Typography, {
            variant: "h2",
            color: "textPrimary",
            children: title
          }), showPremium && jsx(PremiumTag, {
            children: "Premium"
          })]
        }), jsx(BulletPointContainer, {
          children: bulletPoints.map((bulletPoint, index) => jsxs(FlexBox, {
            alignItems: "center",
            className: "bulletpoint",
            children: [jsx(ArrowCircle, {}), jsx(Typography, {
              variant: "body",
              color: "textPrimary",
              children: bulletPoint
            })]
          }, index))
        })]
      })
    })]
  });
};

const HubspotForm = props => {
  const {
    portalId,
    formId,
    onSubmit,
    cssClass,
    formElementId,
    companyName,
    customer_id,
    utmSource
  } = props;
  const [isLoaded, setIsLoaded] = React.useState(false);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/shell.js';
    document.body.appendChild(script);
    script.addEventListener('load', () => {
      // @TS-ignore
      if (window.hbspt) {
        // @TS-ignore
        window.hbspt.forms.create({
          region: 'na1',
          portalId: portalId,
          formId: formId,
          target: `#${formElementId}`,
          cssClass: cssClass,
          submitButtonClass: 'hub-spot-form-submit-button'
        });
      }
    });
    const submitHandler = event => {
      var _a, _b, _c, _d, _e, _f, _g;
      if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
        if (event.data.id === formId) {
          onSubmit();
        }
      } else {
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
          setIsLoaded(true);
          const iframe = document.getElementsByClassName('hs-form-iframe')[0];
          const link = document.createElement('style');
          link.textContent = formCSS;
          (_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.head.appendChild(link);
          (_c = (_b = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _b === void 0 ? void 0 : _b.document.querySelector("input[name='company']")) === null || _c === void 0 ? void 0 : _c.setAttribute('value', `${companyName}`);
          (_e = (_d = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _d === void 0 ? void 0 : _d.document.querySelector("input[name='customer_id']")) === null || _e === void 0 ? void 0 : _e.setAttribute('value', `${customer_id}`);
          (_g = (_f = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _f === void 0 ? void 0 : _f.document.querySelector("input[name='utm_source']")) === null || _g === void 0 ? void 0 : _g.setAttribute('value', `${utmSource}`);
        }
      }
    };
    window.addEventListener('message', submitHandler);
    return () => {
      window.removeEventListener('message', submitHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsxs(Fragment, {
    children: [jsx(HubspotFormContainer, {
      children: jsx("div", {
        id: formElementId
      })
    }), !isLoaded && jsx(SpinnerContainer, {
      children: jsx(Spinner, {})
    })]
  });
};

const Step1 = props => {
  const {
    onSubmit,
    onBack,
    portalId,
    formId,
    companyName,
    customerId,
    utmSource
  } = props;
  return jsxs(Fragment, {
    children: [jsxs(FormHeader, {
      children: [jsx("button", {
        onClick: onBack,
        children: jsx(ChevronLeft, {})
      }), jsx(Typography, {
        fontSize: 16,
        fontWeight: "bold",
        variant: "h2",
        children: "Contact us for a demo"
      })]
    }), jsxs("div", {
      style: {
        position: 'relative'
      },
      children: [jsx(Typography, {
        variant: "body",
        color: "gray800",
        style: {
          padding: '24px 20px'
        },
        children: "Interested? Let us know the best way to reach you."
      }), jsx(HubspotForm, {
        portalId: portalId,
        formId: formId,
        onSubmit: onSubmit,
        cssClass: "hub-spot-form",
        formElementId: "hubspotform",
        companyName: companyName,
        customer_id: customerId,
        utmSource: utmSource
      }), jsx(Disclaimer, {
        children: jsxs(Typography, {
          children: ["By requesting a demo, you agree to Workstream\u2019s", ' ', jsx(Typography, {
            color: "textLink",
            component: "a",
            href: "https://www.workstream.us/privacy",
            target: "_blank",
            children: "Privacy Policy"
          }), ' ', "and", ' ', jsx(Typography, {
            color: "textLink",
            component: "a",
            href: "https://www.workstream.us/termsofuse",
            target: "_blank",
            children: "Terms of Use"
          })]
        })
      }), jsx(FormLine, {}), jsx(FormBackButton, {
        onClick: onBack,
        children: "Back"
      })]
    })]
  });
};

var Complete = "data:image/svg+xml,%3Csvg%20width%3D%22154%22%20height%3D%22150%22%20viewBox%3D%220%200%20154%20150%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M71.6498%20144.021C92.1601%20147.323%20111.467%20133.392%20114.773%20112.904C118.08%2092.4161%20104.133%2073.1301%2083.6225%2069.8275C63.1122%2066.5249%2043.8052%2080.4564%2040.499%20100.944C37.1928%20121.432%2051.1395%20140.718%2071.6498%20144.021Z%22%20fill%3D%22%23ECFAF8%22%20stroke%3D%22%23ECFAF8%22%20stroke-width%3D%225%22%2F%3E%3Cpath%20d%3D%22M58.0517%20105.006L71.004%20119.97L85.7051%20107.484L100.406%2094.9985%22%20stroke%3D%22%233AA79A%22%20stroke-width%3D%226%22%2F%3E%3Cpath%20d%3D%22M130.759%2044.8385C133.025%2050.1816%20132.332%2055.0751%20128.705%2059.5069L120.529%2058.4742C124.786%2056.0378%20126.041%2051.3328%20123.302%2043.6237L130.759%2044.8385Z%22%20fill%3D%22%23457CFF%22%2F%3E%3Cpath%20d%3D%22M144.486%2080.5686C141.706%2085.6722%20137.446%2088.1729%20131.713%2088.1206L127.409%2081.1029C131.98%2082.907%20136.45%2080.9581%20140.781%2074.0044L144.486%2080.5686Z%22%20fill%3D%22%23F7B950%22%2F%3E%3Cpath%20d%3D%22M74.0244%2082.5247C77.9688%2078.2337%2082.6913%2076.8273%2088.2414%2078.249L90.7327%2086.0876C86.7285%2083.2435%2081.9211%2084.078%2076.0425%2089.7848L74.0244%2082.5247Z%22%20fill%3D%22%23D88C9A%22%2F%3E%3Cpath%20d%3D%22M92.0875%2037.9669C86.3095%2038.5866%2081.7845%2036.4989%2078.5903%2031.7729L81.9383%2024.2304C83.0496%2028.9972%2087.2291%2031.5625%2095.404%2031.1634L92.0875%2037.9669Z%22%20fill%3D%22%23F7B950%22%2F%3E%3Cpath%20d%3D%22M116.627%2080.4789C113.841%2085.5733%20109.566%2088.0636%20103.834%2088.0034L99.5565%2080.9738C104.127%2082.7858%20108.59%2080.8277%20112.941%2073.9015L116.627%2080.4789Z%22%20fill%3D%22%23457CFF%22%2F%3E%3Cpath%20d%3D%22M71.8213%2055.3339C66.7288%2052.5332%2064.2296%2048.2229%2064.3366%2042.5271L71.4073%2038.2664C69.5831%2042.8122%2071.5248%2047.304%2078.4473%2051.6658L71.8213%2055.3339Z%22%20fill%3D%22%23457CFF%22%2F%3E%3Cpath%20d%3D%22M24.9169%20110.333C24.2584%20116.105%2021.2441%20120.014%2015.9072%20122.105L9.28731%20117.201C14.1557%20117.185%2017.6032%20113.703%2019.0189%20105.627L24.9169%20110.333Z%22%20fill%3D%22%23D88C9A%22%2F%3E%3Cpath%20d%3D%22M95.9858%2057.7915C95.3272%2063.5641%2092.3051%2067.4717%2086.976%2069.5637L80.3562%2064.6598C85.2641%2064.6505%2088.6721%2061.1618%2090.0877%2053.0862L95.9858%2057.7915Z%22%20fill%3D%22%23D88C9A%22%2F%3E%3Cpath%20d%3D%22M148.188%2024.5397C147.53%2030.3044%20144.508%2034.2119%20139.179%2036.304L132.559%2031.4C137.428%2031.3843%20140.875%2027.902%20142.291%2019.8264L148.188%2024.5397Z%22%20fill%3D%22%23D88C9A%22%2F%3E%3Cpath%20d%3D%22M58.359%2067.0077C55.3357%2071.9711%2050.9508%2074.2506%2045.2348%2073.9151L41.2869%2066.6885C45.7455%2068.7379%2050.3047%2067.0002%2054.9829%2060.2639L58.359%2067.0077Z%22%20fill%3D%22%23F7B950%22%2F%3E%3Cpath%20d%3D%22M40.071%20104.945C34.7057%20107.188%2029.8192%20106.468%2025.3876%20102.835L26.4416%2094.6705C28.8314%2098.9074%2033.5594%20100.221%2041.3141%2097.5112L40.071%20104.945Z%22%20fill%3D%22%23457CFF%22%2F%3E%3Cpath%20d%3D%22M6.59388%2078.7583C7.93841%2073.1055%2011.4081%2069.5864%2016.9541%2068.1524L22.9399%2073.8103C18.0589%2073.2579%2014.2531%2076.3017%2011.8786%2084.1403L6.59388%2078.7583Z%22%20fill%3D%22%23F7B950%22%2F%3E%3C%2Fsvg%3E";

const Step2 = props => {
  const {
    confirmationTitle,
    confirmationText,
    onClose,
    footerLink
  } = props;
  const onLearnMore = () => {
    window.open(footerLink === null || footerLink === void 0 ? void 0 : footerLink.src);
  };
  return jsxs(Step2Container, {
    children: [jsx("img", {
      src: Complete,
      alt: "",
      style: {
        marginBottom: '60px'
      }
    }), jsx(Typography, {
      variant: "h1",
      fontSize: 16,
      fontWeight: "bold",
      color: "textPrimary",
      style: {
        marginBottom: '20px'
      },
      children: confirmationTitle
    }), jsx(Typography, {
      variant: "body",
      style: {
        marginBottom: '60px'
      },
      children: confirmationText
    }), jsxs(FooterButtonContainer, {
      children: [jsx(Button, {
        onClick: onClose,
        children: "Done"
      }), (footerLink === null || footerLink === void 0 ? void 0 : footerLink.src) && jsxs(ConfirmButton, {
        onClick: onLearnMore,
        children: [footerLink.text, " ", jsx(ExternalLink, {})]
      })]
    })]
  });
};

const PaywallModal = props => {
  const {
    onClose,
    isOpen,
    maskClosable = true,
    footerLink,
    portalId,
    formId,
    companyName,
    customerId,
    centered = true,
    closeIcon = true,
    // default 1k from antd
    zIndex = 1000,
    onStepChange,
    initialStep = 0,
    utmSource,
    isCFA,
    isLoading,
    onSubmit
  } = props;
  const [step, setStep] = React.useState(initialStep);
  useEffect(() => {
    onStepChange && onStepChange(step);
  }, [step, onStepChange]);
  const footer = () => {
    let content = null;
    if (step === 0) {
      content = jsxs(Fragment, {
        children: [jsx("div", {
          children: (footerLink === null || footerLink === void 0 ? void 0 : footerLink.src) && (footerLink === null || footerLink === void 0 ? void 0 : footerLink.type) === 'link' && jsxs(FooterLink, {
            href: footerLink.src,
            target: "_blank",
            children: [footerLink.text, " ", jsx(ExternalLink, {})]
          })
        }), jsxs(FooterButtonContainer, {
          children: [(footerLink === null || footerLink === void 0 ? void 0 : footerLink.type) !== 'button' ? jsx(ButtonNew, {
            onClick: onClose,
            children: "Close"
          }) : jsxs(LearnMoreButton, {
            onClick: () => window.open(footerLink === null || footerLink === void 0 ? void 0 : footerLink.src, '_blank'),
            children: [footerLink === null || footerLink === void 0 ? void 0 : footerLink.text, " ", jsx(ExternalLink, {})]
          }), isCFA ? jsx(ConfirmButton, {
            loading: isLoading,
            onClick: () => {
              window.open('https://www.workstream.us/cfa-documents', '_blank');
            },
            type: "primary",
            children: "Ready to sign up? Click here"
          }) : jsx(ConfirmButton, {
            loading: isLoading,
            onClick: () => setStep(1),
            type: "primary",
            children: "Contact us for a demo"
          })]
        })]
      });
    }
    return jsx(Footer, {
      hasBorder: step === 1,
      children: content
    });
  };
  return jsx(PWModal, {
    visible: isOpen,
    maskClosable: maskClosable,
    onCancel: onClose,
    footer: footer(),
    showFooter: step === 0,
    centered: centered,
    closeIcon: closeIcon,
    zIndex: zIndex,
    showClose: closeIcon,
    children: jsxs(Container, Object.assign({}, step === 1 && {
      height: 632
    }, {
      children: [step === 0 && jsx(Step0, Object.assign({}, props)), step === 1 && jsx(Step1, {
        onSubmit: () => {
          onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit();
          setStep(2);
        },
        onBack: () => setStep(0),
        portalId: portalId,
        formId: formId,
        companyName: companyName,
        customerId: customerId,
        utmSource: utmSource
      }), step === 2 && jsx(Step2, Object.assign({}, props))]
    }))
  });
};

/**
 * A higher order component that wraps a multi-select to give a consistent server side
 * searching UX throughout the HR website.
 * Features:
 *  - Stores the option state of the previously selected values.
 *  - Clears the form input when the form is no longer focused.
 */
const withServerSideSearching = WrappedComponent => {
  return props => {
    const {
        serverSearch,
        options,
        loading
      } = props,
      others = __rest(props, ["serverSearch", "options", "loading"]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [showSelected, setShowSelected] = useState(false);
    const doSearch = debounce(input => {
      setShowSelected(!input);
      serverSearch(input);
    }, 250);
    const onSelect = value => {
      if (selectedOptions.filter(so => so.value === value).length) {
        setSelectedOptions(selectedOptions.filter(sr => sr.value !== value));
      } else {
        setSelectedOptions([...selectedOptions, ...(options || []).filter(o => o.value === value)]);
      }
    };
    const onBlur = () => {
      setShowSelected(true);
    };
    return jsx(WrappedComponent, Object.assign({
      loading: loading,
      onSearch: value => doSearch(value),
      onBlur: onBlur,
      onSelect: onSelect,
      options: showSelected ? selectedOptions : options
    }, others));
  };
};

var isArray$1 = isArray$3;
var lengthOfArrayLike$1 = lengthOfArrayLike$6;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$2;
var bind = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$1(element)) {
        elementLen = lengthOfArrayLike$1(element);
        targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$1;

var isArray = isArray$3;
var isConstructor = isConstructor$2;
var isObject$1 = isObject$d;
var wellKnownSymbol = wellKnownSymbol$j;

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject$1(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var $ = _export;
var flattenIntoArray = flattenIntoArray_1;
var aCallable = aCallable$b;
var toObject = toObject$7;
var lengthOfArrayLike = lengthOfArrayLike$6;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = addToUnscopables$3;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');

const OPTION_ALL_VALUE = 'all';

const GlobalStyle = /*#__PURE__*/createGlobalStyle([".ant4-select-dropdown .ant4-select-item-option{padding:8px 16px;font-size:14px;color:#000000;}.ant4-select-dropdown .ant4-select-item-option-selected:not(.ant4-select-item-option-disabled){background:transparent;}.ant4-select-dropdown .ant4-select-item-option-state{display:none;}.ant4-select-dropdown .ant4-select-item-option{padding:12px 16px;&:hover{background-color:", ";}}.ant4-select-item-option-active:not(.ant4-select-item-option-disabled){background-color:", ";}.ant4-select-multiple.ant4-select-focused .ant4-select-selection-placeholder > span{color:", " !important;}.ant4-select-multiple .ant4-select-selection-placeholder{font-size:14px;font-family:'Plus Jakarta Sans';width:85%;line-height:20px;}.ant4-select-dropdown{border-radius:12px;padding-top:8px;padding-bottom:8px;}.ant4-select-focused:not(.ant4-select-disabled).ant4-select:not(.an4-select-customize-input) .ant4-select-selector,.ant4-select:not(.ant4-select-disabled):hover .ant4-select-selector{border:1px solid ", ";box-shadow:none;}.ant4-select-dropdown .ant4-select-tree-switcher{display:none;}.ant4-select-dropdown .ant4-select-tree-checkbox{display:none;}.ant4-select-dropdown  .ant4-select-tree-treenode{padding-left:4px;padding-right:4px;transition:all 0.3s;&:hover{background-color:", ";}}.ant4-select-dropdown  .ant4-select-tree-node-content-wrapper{&:hover{background-color:", ";}}.ant4-tree-select-dropdown{padding-left:0px;padding-right:0px;}"], ({
  theme
}) => theme.colors.gray100, ({
  theme
}) => theme.colors.gray100, ({
  theme
}) => theme.colors.gray400, ({
  theme
}) => theme.colors.gray800, ({
  theme
}) => theme.colors.gray100, ({
  theme
}) => theme.colors.gray100);
const StyledBulkSelect = /*#__PURE__*/styled(_Select).withConfig({
  displayName: "styledmulti-select__StyledBulkSelect",
  componentId: "sc-dde6m5-0"
})([".ant4-select-multiple{border:1px solid ", ";border-radius:8px;padding:7px 16px;height:36px;}.ant4-select-selector{border-radius:8px !important;border:1px solid ", ";}.ant4-select-arrow{width:24px;height:24px;top:35%;cursor:pointer;}"], ({
  theme
}) => theme.colors.gray400, ({
  theme
}) => theme.colors.gray400);
const StyledTreeSelect = /*#__PURE__*/styled(_TreeSelect).withConfig({
  displayName: "styledmulti-select__StyledTreeSelect",
  componentId: "sc-dde6m5-1"
})([".ant4-select-multiple{border:1px solid ", ";border-radius:8px;padding:7px 16px;height:36px;}.ant4-select-selector{border-radius:8px !important;border:1px solid ", ";padding-left:12px;}.ant4-select-selection-item{display:none;}.ant4-select-arrow{width:24px;height:24px;top:35%;cursor:pointer;}.ant4-select-clear{display:none;}.ant4-select-selection-search{margin-left:0;}"], ({
  theme
}) => theme.colors.gray400, ({
  theme
}) => theme.colors.gray400);
const Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledmulti-select__Wrapper",
  componentId: "sc-dde6m5-2"
})(["display:flex;align-items:center;position:relative;"]);
const SpinWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledmulti-select__SpinWrapper",
  componentId: "sc-dde6m5-3"
})(["display:flex;align-items:center;justify-content:center;margin-top:4px;"]);
const NoDataWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledmulti-select__NoDataWrapper",
  componentId: "sc-dde6m5-4"
})(["display:flex;justify-content:center;color:", ";"], ({
  theme
}) => theme.colors.gray800);
const TreeNodeWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "styledmulti-select__TreeNodeWrapper",
  componentId: "sc-dde6m5-5"
})(["display:inline-flex;height:32px;gap:10px;align-items:center;padding:19px 7px;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%;"]);

const getDefaultPlaceholder = (open, selectedPlaceholder, allOption) => values => {
  if (allOption && values[0] === allOption.value) {
    return jsx(Text, {
      color: "gray800",
      children: allOption.title
    });
  }
  if (values.length >= 1) {
    return jsx(Text, {
      color: "gray800",
      children: `${selectedPlaceholder} (${values.length})`
    });
  }
  return '';
};
const spinner = loading => () => {
  return jsx(SpinWrapper, {
    children: jsx(_Spin, {
      spinning: loading
    })
  });
};
const noData = () => {
  return jsx(NoDataWrapper, {
    style: {
      display: 'flex'
    },
    children: "please refine your search"
  });
};
const clearMenu = onChange => menu => {
  return jsxs(Fragment, {
    children: [menu, jsx(_Divider, {
      style: {
        margin: 0
      }
    }), jsx("button", {
      style: {
        padding: '10px 16px',
        cursor: 'pointer'
      },
      onMouseDown: e => e.preventDefault(),
      onClick: () => onChange([], []),
      children: jsx(Text, {
        color: "blue500",
        children: "Clear"
      })
    })]
  });
};
const dropdownRender = (loading, options, allowClear, onChange) => loading && spinner(loading) || !loading && options.length === 0 && noData || allowClear && clearMenu(onChange);

const MultiSelect = props => {
  const {
      options = [],
      mode = 'multiple',
      value,
      onChange,
      getPlaceholder,
      placeholder,
      selectedPlaceholder,
      useAll = {
        title: 'All',
        value: OPTION_ALL_VALUE
      },
      loading = false,
      allowClear,
      onDropdownVisibleChange,
      passAllData = false,
      useMoreOptionsTip = false,
      numberOfMoreOptions,
      moreOptionsTip
    } = props,
    rest = __rest(props, ["options", "mode", "value", "onChange", "getPlaceholder", "placeholder", "selectedPlaceholder", "useAll", "loading", "allowClear", "onDropdownVisibleChange", "passAllData", "useMoreOptionsTip", "numberOfMoreOptions", "moreOptionsTip"]);
  const theme = /*#__PURE__*/useTheme();
  const _useAll = useAll && typeof useAll === 'boolean' ? {
    title: 'All',
    value: OPTION_ALL_VALUE
  } : useAll;
  const _options = useAll && options.length > 1 ? [{
    title: _useAll.title,
    value: _useAll.value
  }, ...options] : options;
  const [open, setOpen] = useState(false);
  const valueSet = options.flatMap(o => o.options ? o.options.map(oo => oo.value) : o.value);
  const valueRef = useRef(value);
  const _values = value || [];
  const _getPlaceholder = getPlaceholder || (_values.length ? getDefaultPlaceholder(open, selectedPlaceholder, _useAll) : () => placeholder);
  /**
   * Compose a custom onChange since we need to handle 'All' option
   */
  const handleChange = (v, options) => {
    var _a;
    let newValues = [..._values, ...v];
    if (value && value.indexOf(v[0]) !== -1) {
      newValues = [..._values.filter(val => val !== v[0])];
    }
    if (newValues !== valueRef.current && newValues !== value) {
      const newValueHasAll = useAll && newValues.includes(_useAll.value);
      const refHasAll = useAll && ((_a = valueRef.current) === null || _a === void 0 ? void 0 : _a.includes(_useAll.value));
      // 'All' is checked previously, now check an option other than 'All'
      if (refHasAll && newValues.length > 1) {
        onChange(valueSet.filter(vs => vs !== newValues[1]), options);
      }
      // 'All' is checked previously, now uncheck 'All'
      else if (newValueHasAll && refHasAll || newValueHasAll && passAllData && newValues.length > valueSet.length) {
        onChange([], []);
      }
      // 'All' is unchecked previously, now check 'All'
      else if (newValueHasAll && !refHasAll || useAll && newValues.length === valueSet.length && options.length > 1) {
        onChange(passAllData ? valueSet : [_useAll.value], options);
      } else {
        onChange(newValues, options);
      }
    }
    valueRef.current = newValues;
  };
  useEffect(() => {
    valueRef.current = value;
  }, [value]);
  const filterOption = (inputValue, option) => {
    var _a;
    return (_a = typeof (option === null || option === void 0 ? void 0 : option.title) === 'string' && option.title.toLowerCase().includes(inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase())) !== null && _a !== void 0 ? _a : false;
  };
  const dropdownVisible = _open => {
    setOpen(_open);
    onDropdownVisibleChange && onDropdownVisibleChange(_open);
  };
  function renderMoreOptionsTip() {
    if (!useMoreOptionsTip) {
      return null;
    }
    if (moreOptionsTip != null) {
      return moreOptionsTip;
    }
    return jsxs(_Select.Option, {
      disabled: true,
      value: "",
      style: {
        cursor: 'unset'
      },
      children: ["and ", numberOfMoreOptions, " more..."]
    });
  }
  function renderOptionItem(opt) {
    const label = jsx(Text, {
      color: "gray800",
      fontSize: "14px",
      fontWeight: opt.value === _useAll.value && _values[0] === opt.value ? 600 : 400,
      lineHeight: "20px",
      children: opt.title
    });
    const indeterminate = opt.value === _useAll.value && _values.length > 0 && (passAllData ? _values.length !== valueSet.length : _values[0] !== _useAll.value);
    return jsx(_Select.Option, {
      value: opt.value,
      title: opt.title,
      disabled: opt.disabled,
      children: opt['hideCheckbox'] ? label : jsx(Checkbox$1, {
        label: label,
        disabled: opt.disabled,
        checked: _values.includes(opt.value) || _values.length === 1 && _values[0] === _useAll.value || passAllData && _values.length === valueSet.length,
        indeterminate: indeterminate
      })
    }, opt.value);
  }
  return jsxs(Wrapper, {
    children: [jsx(GlobalStyle, {}), jsxs(StyledBulkSelect, Object.assign({
      value: [],
      open: open,
      popupClassName: "bulk-select-antd",
      onChange: (val, options) => {
        handleChange(val, options);
      },
      filterOption: filterOption,
      placeholder: _getPlaceholder(_values, options),
      tagRender: jsx(_Tag, {
        style: {
          display: 'none'
        }
      }),
      dropdownRender: dropdownRender(loading, options, !!allowClear, onChange),
      onDropdownVisibleChange: dropdownVisible,
      mode: mode,
      showArrow: true,
      suffixIcon: open ? jsx(SmallChevronUp, {
        size: 24,
        color: theme.colors.gray600
      }) : jsx(SmallChevronDown, {
        size: 24,
        color: theme.colors.gray600
      })
    }, rest, {
      children: [_options === null || _options === void 0 ? void 0 : _options.map(opt => {
        if (opt.title && opt.options) {
          return jsx(_Select.OptGroup, {
            label: opt.title,
            children: opt.options.map(o => renderOptionItem(o))
          }, opt.value);
        }
        return renderOptionItem(opt);
      }), renderMoreOptionsTip()]
    }))]
  });
};

var CheckboxSvg = "data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%228%22%20viewBox%3D%220%200%2010%208%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20d%3D%22M2.87655%207.24918C2.98683%207.36037%203.11803%207.44863%203.26259%207.50885C3.40715%207.56908%203.56221%207.60009%203.71881%207.60009C3.87542%207.60009%204.03047%207.56908%204.17503%207.50885C4.31959%207.44863%204.45079%207.36037%204.56107%207.24918L9.40112%202.40914C9.62451%202.18575%209.75%201.88278%209.75%201.56687C9.75%201.25096%209.62451%200.947991%209.40112%200.724609C9.17774%200.501227%208.87477%200.375732%208.55886%200.375732C8.24295%200.375732%207.93998%200.501227%207.7166%200.724609L3.71881%204.73426L2.2834%203.28699C2.06002%203.06361%201.75705%202.93811%201.44114%202.93811C1.12523%202.93811%200.822259%203.06361%200.598877%203.28699C0.375495%203.51037%200.25%203.81334%200.25%204.12925C0.25%204.44516%200.375495%204.74813%200.598877%204.97151L2.87655%207.24918Z%22%20fill%3D%22white%22%20%2F%3E%3C%2Fsvg%3E%20%20";

var MiddleLineSvg = "data:image/svg+xml,%3Csvg%20width%3D%2210%22%20height%3D%224%22%20viewBox%3D%220%200%2010%204%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%3Cpath%20d%3D%22M8.9375%200.879883H1.0625C0.913316%200.879883%200.770242%200.99841%200.664753%201.20939C0.559263%201.42037%200.5%201.70651%200.5%202.00488C0.5%202.30325%200.559263%202.5894%200.664753%202.80038C0.770242%203.01136%200.913316%203.12988%201.0625%203.12988H8.9375C9.08668%203.12988%209.22976%203.01136%209.33525%202.80038C9.44074%202.5894%209.5%202.30325%209.5%202.00488C9.5%201.70651%209.44074%201.42037%209.33525%201.20939C9.22976%200.99841%209.08668%200.879883%208.9375%200.879883Z%22%20fill%3D%22white%22%20%2F%3E%3C%2Fsvg%3E%20%20";

const StyledWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styled-checkbox__StyledWrapper",
  componentId: "sc-1mr9qei-0"
})(["display:flex;align-items:center;column-gap:10px;cursor:pointer;.checkbox{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;box-sizing:border-box;background:#fff;border:1px solid #d4d4d8;border-radius:4px;cursor:pointer;flex-shrink:0;}.text{min-width:0px;overflow:hidden;text-overflow:ellipsis;}&:hover,&.checked{.checkbox{border-color:#787883;}}&.checked{.checkbox{background-color:#787883;}}.checkbox-form{width:20px;height:20px;}"]);
/**
 * Used by components in `multi-select` folder specifically.
 */
const StyledCheckbox = props => {
  const {
    checked,
    onChange,
    indeterminate,
    children,
    style,
    className,
    isForm,
    disabled
  } = props;
  return jsxs(StyledWrapper, {
    style: style,
    className: `${checked || indeterminate ? 'checked' : ''} ${className || ''}`,
    onClick: event => {
      if (!disabled) {
        event.stopPropagation();
        event.preventDefault();
        onChange === null || onChange === void 0 ? void 0 : onChange({
          target: {
            checked: !checked || indeterminate
          }
        });
      }
    },
    children: [jsxs("div", {
      className: `checkbox ${isForm ? 'checkbox-form' : ''}`,
      children: [indeterminate ? jsx("img", {
        src: MiddleLineSvg,
        alt: "checkbox"
      }) : null, checked && !indeterminate ? jsx("img", {
        src: CheckboxSvg,
        alt: "checkbox"
      }) : null]
    }), children && jsx("div", {
      className: "text",
      children: children
    })]
  });
};

const TreeSelect = props => {
  const {
      treeData = [],
      getPlaceholder,
      placeholder,
      selectedPlaceholder,
      useAll = {
        title: 'All',
        value: 'all'
      },
      passAllData = false,
      loading = false,
      value,
      onChange,
      allowClear,
      onDropdownVisibleChange
    } = props,
    rest = __rest(props, ["treeData", "getPlaceholder", "placeholder", "selectedPlaceholder", "useAll", "passAllData", "loading", "value", "onChange", "allowClear", "onDropdownVisibleChange"]);
  const _useAll = useAll && typeof useAll === 'boolean' ? {
    title: 'All',
    value: 'all'
  } : useAll;
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState('');
  const theme = /*#__PURE__*/useTheme();
  const _getPlaceholder = getPlaceholder || ((value === null || value === void 0 ? void 0 : value.length) ? getDefaultPlaceholder(open, selectedPlaceholder, _useAll) : () => jsx(Text, {
    color: "gray400",
    children: placeholder
  }));
  const getLeafValues = children => {
    const maybeChildren = children === null || children === void 0 ? void 0 : children.map(child => child.children ? getLeafValues(child.children) : [child.value]).reduce((acc, val) => [...acc, ...val], []);
    return maybeChildren || [];
  };
  const itemSelected = (itemValue, children) => {
    const _value = useAll && value && value.length && value[0] === _useAll.value ? getLeafValues(treeData) : value;
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!children) {
      const childValues = getLeafValues(children);
      const hasAll = childValues === null || childValues === void 0 ? void 0 : childValues.every(v => _value === null || _value === void 0 ? void 0 : _value.includes(v));
      if (hasAll) {
        onChange((_value === null || _value === void 0 ? void 0 : _value.filter(v => !childValues.includes(v))) || []);
      } else {
        // Add all child values.
        onChangeHandleAll([...(_value || []), ...childValues]);
      }
      return;
    }
    if (_value === null || _value === void 0 ? void 0 : _value.includes(itemValue)) {
      onChange(_value.filter(v => v !== itemValue));
    } else {
      const newValues = [...(_value || []), itemValue];
      onChangeHandleAll(newValues);
    }
  };
  const onChangeHandleAll = newValues => {
    if (!_useAll) {
      onChange(newValues);
      return;
    }
    const childValues = getLeafValues(treeData);
    // All values checked
    if (childValues.every(childValue => newValues.includes(childValue))) {
      onChange(passAllData ? newValues : [_useAll.value]);
    } else {
      onChange(newValues);
    }
  };
  const getItemTitle = item => {
    const hasChildren = !!item.children && item.children.length > 0;
    const childValues = getLeafValues(item.children);
    const checked = _useAll && (value === null || value === void 0 ? void 0 : value.includes(_useAll.value)) || hasChildren && (childValues === null || childValues === void 0 ? void 0 : childValues.every(v => value === null || value === void 0 ? void 0 : value.includes(v))) || !hasChildren && (value === null || value === void 0 ? void 0 : value.includes(item.value));
    const indeterminate = !checked && hasChildren && (childValues === null || childValues === void 0 ? void 0 : childValues.some(v => value === null || value === void 0 ? void 0 : value.includes(v)));
    return jsx(TreeSelectItem, {
      title: item.title,
      onClick: () => itemSelected(item.value, item.children),
      checked: !!checked,
      indeterminate: !!indeterminate
    });
  };
  const getAllNode = () => {
    const childValues = getLeafValues(treeData);
    const allChecked = (value === null || value === void 0 ? void 0 : value.includes(_useAll.value)) || passAllData && childValues.every(childValue => value === null || value === void 0 ? void 0 : value.includes(childValue));
    const item = jsx(TreeSelectItem, {
      title: _useAll.title,
      onClick: () => onChange(allChecked ? [] : passAllData ? [...childValues] : [_useAll.value]),
      checked: !!allChecked,
      indeterminate: !allChecked && !!value && value.length > 0
    });
    return jsx(TreeNode, {
      searchTitle: _useAll.title,
      title: item,
      value: _useAll.value
    }, _useAll.value);
  };
  /**
   * Custom rendering function to include our own checkbox.
   * @param data The tree data as passed in from props
   * @returns The TreeNode's
   */
  const mapToTreeNodes = data => {
    const providedNodes = (data === null || data === void 0 ? void 0 : data.map(treeItem => jsx(TreeNode, {
      title: getItemTitle(treeItem),
      value: treeItem.value,
      searchTitle: treeItem.title,
      children: mapToTreeNodes(treeItem.children)
    }, treeItem.value))) || [];
    return providedNodes;
  };
  const dropdownVisible = _open => {
    setOpen(_open);
    setSearch(!_open ? '' : search);
    onDropdownVisibleChange && onDropdownVisibleChange(_open);
  };
  const filterTreeNode = (searchValue, item) => {
    var _a, _b;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const title = (_b = (_a = item === null || item === void 0 ? void 0 : item.title) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.title;
    const result = title.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1;
    return result;
  };
  return jsxs(Wrapper, {
    children: [jsx(GlobalStyle, {}), jsx(StyledTreeSelect, Object.assign({
      open: open,
      popupClassName: "bulk-select-antd",
      placeholder: search ? '' : _getPlaceholder(value || [], treeData),
      maxTagCount: 0,
      tagRender: jsx(_Tag, {
        style: {
          display: 'none'
        }
      }),
      dropdownRender: dropdownRender(loading, treeData, !!allowClear, onChange),
      onDropdownVisibleChange: dropdownVisible,
      onSearch: _search => setSearch(_search),
      value: [],
      showArrow: true,
      suffixIcon: open ? jsx(SmallChevronUp, {
        size: 24,
        color: theme.colors.gray600
      }) : jsx(SmallChevronDown, {
        size: 24,
        color: theme.colors.gray600
      })
    }, rest, {
      treeCheckable: true,
      mode: "multiple",
      treeDefaultExpandAll: true,
      treeExpandedKeys: treeData.map(td => td.value),
      filterTreeNode: filterTreeNode,
      children: !useAll ? mapToTreeNodes(treeData) : [getAllNode(), ...mapToTreeNodes(treeData)]
    }))]
  });
};
const TreeSelectItem = ({
  title,
  checked,
  indeterminate,
  onClick
}) => jsxs(TreeNodeWrapper, {
  onClick: onClick,
  children: [jsx(StyledCheckbox, {
    checked: checked,
    indeterminate: indeterminate,
    onChange: onClick
  }), jsx(Text, {
    children: title
  })]
});

const ServerSideMultiSelect = withServerSideSearching(MultiSelect);

function getIcon(type, iconColor) {
  switch (type) {
    case 'info':
      return jsx(Info, {
        color: iconColor !== null && iconColor !== void 0 ? iconColor : 'statusInfo'
      });
    case 'warning':
      return jsx(Warning, {
        color: iconColor !== null && iconColor !== void 0 ? iconColor : 'statusWarning'
      });
    case 'success':
      return jsx(CheckmarkCircle, {
        color: iconColor !== null && iconColor !== void 0 ? iconColor : 'statusSuccess'
      });
    case 'error':
      return jsx(CircleCross, {
        color: iconColor !== null && iconColor !== void 0 ? iconColor : 'statusError'
      });
    default:
      return jsx(Info, {
        color: iconColor !== null && iconColor !== void 0 ? iconColor : 'statusInfo'
      });
  }
}
function openToast(type, props) {
  _notification[type](Object.assign(Object.assign({
    placement: 'topRight',
    duration: 2.5,
    closeIcon: jsx(Cross, {}),
    icon: getIcon(type, props === null || props === void 0 ? void 0 : props.iconColor)
  }, props), {
    className: `nfw-toast ${type}-nfw-toast ${props === null || props === void 0 ? void 0 : props.className}`,
    description: jsx(Text, {
      fontSize: "14px",
      children: props === null || props === void 0 ? void 0 : props.message
    }),
    message: jsx(Text, {
      fontWeight: 600,
      fontSize: "14px",
      children: props === null || props === void 0 ? void 0 : props.description
    })
  }));
}

const ProgressBar$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "progress-barstyles__ProgressBar",
  componentId: "sc-1sxz9um-0"
})(["display:flex;width:100%;"]);
const ProgressItem$1 = /*#__PURE__*/styled.div.withConfig({
  displayName: "progress-barstyles__ProgressItem",
  componentId: "sc-1sxz9um-1"
})(["", ""], ({
  theme
}) => {
  return css(["flex:1;color:", ";margin-right:10px;display:inline-block;overflow:hidden;.line{width:100%;&:after{content:'';width:100%;height:5px;border-radius:3px;display:inline-block;background-color:", ";}}.title{font-weight:400;font-size:12px;line-height:16px;.icon-container{padding-right:3px;vertical-align:text-top;}}&.item-finish{color:", ";.line{&:after{background-color:", ";}}}&.item-active{color:", ";.line{&:after{background-color:", ";}}}&.item-attention{color:", ";.line{&:after{background-color:", ";}}}&.item-wait{color:", ";.line{&:after{background-color:", ";}}}&.item-error{color:", ";.line{&:after{background-color:", ";}}}&.item-disabled{opacity:0.35;}"], theme.colors ? theme.colors.gray600 : '', theme.colors.gray200, theme.colors.green400, theme.colors.green400, theme.colors.blue400, theme.colors.blue400, theme.colors.gold500, theme.colors.gold500, theme.colors.gray600, theme.colors.gray200, theme.colors.red400, theme.colors.red400);
});
const S$2 = {
  ProgressBar: ProgressBar$1,
  ProgressItem: ProgressItem$1
};

/**
 * ProgressBar
 */
const ProgressBar = props => {
  const {
    children,
    current = 0,
    initial = 0,
    onChange
  } = props;
  const onChangeStep = changedStep => {
    if (onChange && current !== changedStep) {
      onChange(changedStep);
    }
  };
  return jsx(S$2.ProgressBar, {
    children: toArray(children).map((child, index) => {
      var _a;
      const stepNumber = initial + index;
      const childProps = Object.assign({
        active: stepNumber === current,
        key: index,
        stepNumber,
        onStepClick: onChange && onChangeStep
      }, (child === null || child === void 0 ? void 0 : child.props) || {});
      if (!((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.status)) {
        if (stepNumber === current) {
          childProps.status = 'active';
        } else if (stepNumber < current) {
          childProps.status = 'finish';
        } else {
          childProps.status = 'wait';
        }
      }
      return /*#__PURE__*/cloneElement(child, childProps);
    })
  });
};
const ProgressItem = props => {
  const {
    title,
    status,
    active,
    disabled = false,
    onStepClick,
    stepNumber = 0
  } = props;
  const classnames = classNames('progress-item', `item-${status}`, {
    'item-active': active,
    'item-disabled': disabled
  });
  return jsx(S$2.ProgressItem, {
    className: classnames,
    onClick: () => {
      if (!disabled) {
        onStepClick && onStepClick(stepNumber);
      }
    },
    children: jsxs("div", {
      children: [jsx("div", {
        className: "line"
      }), jsx("div", {
        className: "title",
        children: title
      })]
    })
  });
};

function Progress(props) {
  const {
    value,
    leftLabel,
    rightLabel,
    orientation = 'vertical',
    color = getColor('green500'),
    style = {}
  } = props;
  const theme = /*#__PURE__*/useTheme();
  const isAnyLabel = leftLabel || rightLabel;
  const isHorizontal = orientation === 'horizontal';
  const isVertical = orientation === 'vertical';
  return jsxs(FlexBox, {
    direction: isVertical ? 'column' : 'row',
    align: isVertical ? 'stretch' : 'center',
    style: style,
    children: [isAnyLabel && isVertical && jsxs(FlexBox, {
      justify: "space-between",
      style: {
        marginBottom: '4px'
      },
      children: [jsx(Typography, {
        fontSize: 12,
        fontWeight: 600,
        color: "gray800",
        children: leftLabel || ''
      }), rightLabel && jsx(Typography, {
        fontSize: 12,
        fontWeight: 600,
        color: "gray800",
        children: rightLabel
      })]
    }), jsx(FlexBox, {
      className: "progress-bar-background",
      align: "center",
      style: {
        backgroundColor: theme.colors.gray300,
        position: 'relative',
        height: '5px',
        borderRadius: 8,
        width: '100%'
      },
      children: jsx(FlexBox, {
        className: "progress-bar-percent",
        backgroundColor: color,
        style: {
          width: `${value}%`,
          height: '5px',
          position: 'absolute',
          left: 0,
          top: 0,
          borderRadius: 8,
          transition: 'width 0.5s ease-in-out'
        }
      })
    }), isHorizontal && jsx(Typography, {
      fontSize: 12,
      fontWeight: 600,
      color: "gray800",
      ml: "8px",
      children: rightLabel
    })]
  });
}

const HideChildrenWhenFlagOn = props => {
  const {
    featureFlag,
    children
  } = props;
  const isFeatureFlagOn = useFeatureIsOn(featureFlag);
  return isFeatureFlagOn ? null : children;
};

var isCheckBoxInput = (element) => element.type === 'checkbox';

var isDateObject = (value) => value instanceof Date;

var isNullOrUndefined$1 = (value) => value == null;

const isObjectType = (value) => typeof value === 'object';
var isObject = (value) => !isNullOrUndefined$1(value) &&
    !Array.isArray(value) &&
    isObjectType(value) &&
    !isDateObject(value);

var getEventValue = (event) => isObject(event) && event.target
    ? isCheckBoxInput(event.target)
        ? event.target.checked
        : event.target.value
    : event;

var getNodeParentName = (name) => name.substring(0, name.search(/\.\d+(\.|$)/)) || name;

var isNameInFieldArray = (names, name) => names.has(getNodeParentName(name));

var isPlainObject = (tempObject) => {
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return (isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf'));
};

var isWeb = typeof window !== 'undefined' &&
    typeof window.HTMLElement !== 'undefined' &&
    typeof document !== 'undefined';

function cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) {
        copy = new Date(data);
    }
    else if (data instanceof Set) {
        copy = new Set(data);
    }
    else if (!(isWeb && (data instanceof Blob || data instanceof FileList)) &&
        (isArray || isObject(data))) {
        copy = isArray ? [] : {};
        if (!Array.isArray(data) && !isPlainObject(data)) {
            copy = data;
        }
        else {
            for (const key in data) {
                copy[key] = cloneObject(data[key]);
            }
        }
    }
    else {
        return data;
    }
    return copy;
}

var compact = (value) => Array.isArray(value) ? value.filter(Boolean) : [];

var isUndefined = (val) => val === undefined;

var get = (obj, path, defaultValue) => {
    if (!path || !isObject(obj)) {
        return defaultValue;
    }
    const result = compact(path.split(/[,[\].]+?/)).reduce((result, key) => isNullOrUndefined$1(result) ? result : result[key], obj);
    return isUndefined(result) || result === obj
        ? isUndefined(obj[path])
            ? defaultValue
            : obj[path]
        : result;
};

const EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
};
const VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all',
};

const HookFormContext = React.createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */
const useFormContext = () => React.useContext(HookFormContext);

var getProxyFormState = (formState, control, localProxyFormState, isRoot = true) => {
    const result = {
        defaultValues: control._defaultValues,
    };
    for (const key in formState) {
        Object.defineProperty(result, key, {
            get: () => {
                const _key = key;
                if (control._proxyFormState[_key] !== VALIDATION_MODE.all) {
                    control._proxyFormState[_key] = !isRoot || VALIDATION_MODE.all;
                }
                localProxyFormState && (localProxyFormState[_key] = true);
                return formState[_key];
            },
        });
    }
    return result;
};

var isEmptyObject = (value) => isObject(value) && !Object.keys(value).length;

var shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot) => {
    updateFormState(formStateData);
    const { name, ...formState } = formStateData;
    return (isEmptyObject(formState) ||
        Object.keys(formState).length >= Object.keys(_proxyFormState).length ||
        Object.keys(formState).find((key) => _proxyFormState[key] ===
            (!isRoot || VALIDATION_MODE.all)));
};

var convertToArrayPayload = (value) => (Array.isArray(value) ? value : [value]);

var shouldSubscribeByName = (name, signalName, exact) => exact && signalName
    ? name === signalName
    : !name ||
        !signalName ||
        name === signalName ||
        convertToArrayPayload(name).some((currentName) => currentName &&
            (currentName.startsWith(signalName) ||
                signalName.startsWith(currentName)));

function useSubscribe(props) {
    const _props = React.useRef(props);
    _props.current = props;
    React.useEffect(() => {
        const subscription = !props.disabled &&
            _props.current.subject &&
            _props.current.subject.subscribe({
                next: _props.current.next,
            });
        return () => {
            subscription && subscription.unsubscribe();
        };
    }, [props.disabled]);
}

/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */
function useFormState(props) {
    const methods = useFormContext();
    const { control = methods.control, disabled, name, exact } = props || {};
    const [formState, updateFormState] = React.useState(control._formState);
    const _mounted = React.useRef(true);
    const _localProxyFormState = React.useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false,
    });
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        next: (value) => _mounted.current &&
            shouldSubscribeByName(_name.current, value.name, exact) &&
            shouldRenderFormState(value, _localProxyFormState.current, control._updateFormState) &&
            updateFormState({
                ...control._formState,
                ...value,
            }),
        subject: control._subjects.state,
    });
    React.useEffect(() => {
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return () => {
            _mounted.current = false;
        };
    }, [control]);
    return getProxyFormState(formState, control, _localProxyFormState.current, false);
}

var isString = (value) => typeof value === 'string';

var generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue) => {
    if (isString(names)) {
        isGlobal && _names.watch.add(names);
        return get(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) {
        return names.map((fieldName) => (isGlobal && _names.watch.add(fieldName), get(formValues, fieldName)));
    }
    isGlobal && (_names.watchAll = true);
    return formValues;
};

/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */
function useWatch(props) {
    const methods = useFormContext();
    const { control = methods.control, name, defaultValue, disabled, exact, } = props || {};
    const _name = React.useRef(name);
    _name.current = name;
    useSubscribe({
        disabled,
        subject: control._subjects.values,
        next: (formState) => {
            if (shouldSubscribeByName(_name.current, formState.name, exact)) {
                updateValue(cloneObject(generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
            }
        },
    });
    const [value, updateValue] = React.useState(control._getWatch(name, defaultValue));
    React.useEffect(() => control._removeUnmounted());
    return value;
}

var isKey = (value) => /^\w*$/.test(value);

var stringToPath = (input) => compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));

function set(object, path, value) {
    let index = -1;
    const tempPath = isKey(path) ? [path] : stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while (++index < length) {
        const key = tempPath[index];
        let newValue = value;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue =
                isObject(objValue) || Array.isArray(objValue)
                    ? objValue
                    : !isNaN(+tempPath[index + 1])
                        ? []
                        : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}

/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */
function useController(props) {
    const methods = useFormContext();
    const { name, control = methods.control, shouldUnregister } = props;
    const isArrayField = isNameInFieldArray(control._names.array, name);
    const value = useWatch({
        control,
        name,
        defaultValue: get(control._formValues, name, get(control._defaultValues, name, props.defaultValue)),
        exact: true,
    });
    const formState = useFormState({
        control,
        name,
    });
    const _registerProps = React.useRef(control.register(name, {
        ...props.rules,
        value,
    }));
    React.useEffect(() => {
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value) => {
            const field = get(control._fields, name);
            if (field) {
                field._f.mount = value;
            }
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value = cloneObject(get(control._options.defaultValues, name));
            set(control._defaultValues, name, value);
            if (isUndefined(get(control._formValues, name))) {
                set(control._formValues, name, value);
            }
        }
        return () => {
            (isArrayField
                ? _shouldUnregisterField && !control._state.action
                : _shouldUnregisterField)
                ? control.unregister(name)
                : updateMounted(name, false);
        };
    }, [name, control, isArrayField, shouldUnregister]);
    return {
        field: {
            name,
            value,
            onChange: React.useCallback((event) => _registerProps.current.onChange({
                target: {
                    value: getEventValue(event),
                    name: name,
                },
                type: EVENTS.CHANGE,
            }), [name]),
            onBlur: React.useCallback(() => _registerProps.current.onBlur({
                target: {
                    value: get(control._formValues, name),
                    name: name,
                },
                type: EVENTS.BLUR,
            }), [name, control]),
            ref: (elm) => {
                const field = get(control._fields, name);
                if (field && elm) {
                    field._f.ref = {
                        focus: () => elm.focus(),
                        select: () => elm.select(),
                        setCustomValidity: (message) => elm.setCustomValidity(message),
                        reportValidity: () => elm.reportValidity(),
                    };
                }
            },
        },
        formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: () => !!get(formState.errors, name),
            },
            isDirty: {
                enumerable: true,
                get: () => !!get(formState.dirtyFields, name),
            },
            isTouched: {
                enumerable: true,
                get: () => !!get(formState.touchedFields, name),
            },
            error: {
                enumerable: true,
                get: () => get(formState.errors, name),
            },
        }),
    };
}

const ErrorMsgMap = {
  maxLength: 'Exceeds characters maximum length',
  max: 'Exceeds maximum value',
  min: 'Exceeds minimum value',
  required: 'Required',
  pattern: 'Invalid format',
  validate: 'Invalid'
};

function FieldLabel({
  label,
  subLabel,
  showOptional = false
}) {
  if (isEmpty(label)) return null;
  return jsxs(_Space, {
    direction: "vertical",
    size: 0,
    style: {
      paddingBottom: '8px',
      whiteSpace: 'pre'
    },
    children: [jsxs(Typography, {
      fontSize: "14px",
      lineHeight: "20px",
      color: "textPrimary",
      children: [label, showOptional && jsx(Typography, {
        color: "textSecondary",
        fontSize: "14px",
        ml: "s1",
        children: "\u2802optional"
      })]
    }), jsx(Text, {
      variant: "bodySmall",
      color: "gray600",
      fontWeight: 400,
      children: subLabel
    })]
  });
}

function FooterNote({
  note
}) {
  if (!note) return null;
  return jsx(Text, {
    variant: "bodySmall",
    color: "gray600",
    fontWeight: 400,
    style: {
      marginTop: 4
    },
    children: note
  });
}

const FieldWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "field__FieldWrapper",
  componentId: "sc-wdmugw-0"
})([".ant-input-group &{border-right-width:0 !important;border-left-width:0 !important;}display:flex;flex-direction:column;"]);
const Field = props => {
  const {
    label,
    subLabel,
    showOptional,
    renderer,
    style = {},
    footerNote
  } = props;
  return jsxs(FieldWrapper, {
    style: style,
    children: [jsx(FieldLabel, {
      label: label,
      subLabel: subLabel,
      showOptional: showOptional
    }), renderer, footerNote && jsx(FooterNote, {
      note: footerNote
    })]
  });
};

function FormErrorWrapper({
  children
}) {
  return jsx(Typography, {
    variant: "caption",
    color: getColor('statusError'),
    children: children
  });
}

const Input$2 = /*#__PURE__*/styled(Input$3).withConfig({
  displayName: "form-input__Input",
  componentId: "sc-qr37vx-0"
})([".ant-input-group &:first-child{border-top-right-radius:0;border-bottom-right-radius:0;}"]);
function FormTextInput(props) {
  const {
      control,
      name: formItemName,
      defaultValue,
      rules = {},
      label,
      subLabel,
      showOptional,
      style = {}
    } = props,
    rest = __rest(props, ["control", "name", "defaultValue", "rules", "label", "subLabel", "showOptional", "style"]);
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(Input$2, Object.assign({}, rest, {
        style: {
          borderColor: error ? getColor('statusError') : ''
        },
        onChange: onChange,
        onBlur: onBlur,
        value: value,
        name: name,
        ref: ref
      })), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

const Select = /*#__PURE__*/styled(Select$1).withConfig({
  displayName: "form-select__Select",
  componentId: "sc-cvu4y3-0"
})(["&.ant-select-disabled .ant-select-arrow{display:none !important;}width:100%;.ant-input-group & .ant-select-selector{border-top-left-radius:0;border-bottom-left-radius:0;height:40px;}&.ant-select-open{& > .ant-select-selector{.ant-select-selection-item{.value{opacity:1 !important;}}}}"]);
function FormSelect(props) {
  const {
      control,
      name: formItemName,
      defaultValue,
      rules = {},
      label,
      subLabel,
      showOptional,
      style = {},
      options = [],
      footerNote,
      onChange: onChangeProp
    } = props,
    rest = __rest(props, ["control", "name", "defaultValue", "rules", "label", "subLabel", "showOptional", "style", "options", "footerNote", "onChange"]);
  const {
    field: {
      onChange,
      onBlur,
      value
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue
  });
  const onChangeHandler = (...args) => {
    // send value to hook form
    onChange(...args);
    onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(...args);
  };
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    footerNote: footerNote,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(Select, Object.assign({}, rest, {
        suffixIcon: jsx(ChevronDown, {}),
        defaultValue: defaultValue,
        style: {
          borderColor: error ? getColor('statusError') : ''
        },
        onChange: onChangeHandler,
        onBlur: onBlur,
        value: value,
        options: options,
        hasError: !!error
      })), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

function FormTelInput(props) {
  const renderDate = useRef(new Date());
  const {
    control,
    name: formItemName,
    defaultValue,
    rules = {},
    label,
    subLabel,
    showOptional,
    onValidate,
    style = {}
  } = props;
  const {
    field: {
      onChange,
      value
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  const previousValue = usePrevious$1(value);
  useEffect(() => {
    const inputEle = document.querySelector('.intl-tel-input input');
    if (value === '' && previousValue !== undefined && document.activeElement !== inputEle) {
      const _inputEle = document.querySelector('.intl-tel-input input');
      setTimeout(() => {
        if (_inputEle) {
          renderDate.current = new Date(); // force re-render
        }
      }, 0);
    }
  }, [value, previousValue]);
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(TelInput, Object.assign({
        className: "js-phone-input"
      }, props, {
        defaultValue: defaultValue,
        hasError: !!error,
        onChange: intlTelValue => {
          onChange(intlTelValue.fullNumber);
          if (isFunction(onValidate)) {
            onValidate(intlTelValue.isValid);
          }
        }
      }), renderDate.current.getTime()), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

const AntdDatePickerExtension = /*#__PURE__*/css(["", ""], () => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  return `
      .${antdCssPrefix}-picker-panel-container {
        border-radius: ${theme.borderRadius.elements};
      }
      .${antdCssPrefix}-picker-footer {
        /* hide Today button per design */
        display: none;
      }

      .${antdCssPrefix}-picker-clear {
        right: 28px;
      }

      .${antdCssPrefix}-picker-content th{
        font-size: 12px;
        font-weight: 600;
        color: ${theme.getColor('textPrimary')};
        text-transform: uppercase;
      }

      td.${antdCssPrefix}-picker-cell-in-view {
        font-size: 12px;
        color: ${theme.getColor('textPrimary')};
      }

      .${antdCssPrefix}-picker-header-view {
        font-weight: 600;
      }

      .${antdCssPrefix}-picker-header button {
        color: ${theme.getColor('iconDefault')};
      }

      .${antdCssPrefix}-picker {
        border-radius: ${theme.borderRadius.elements};
      }
      .${antdCssPrefix}-picker-input {
        height: 32px;
        font-size: 14px;
        border-radius: ${theme.borderRadius.elements};
      }

    `;
});
function FormDatePicker(props) {
  const {
      control,
      name: formItemName,
      defaultValue,
      rules = {},
      label,
      subLabel,
      showOptional,
      style = {}
    } = props,
    otherProps = __rest(props, ["control", "name", "defaultValue", "rules", "label", "subLabel", "showOptional", "style"]);
  const {
    field: {
      onChange,
      onBlur,
      name,
      value
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(DatePicker, Object.assign({
        suffixIcon: jsx(CalendarNew, {
          color: "iconDefault"
        })
      }, otherProps, {
        defaultValue: defaultValue,
        hasError: !!error,
        onChange: onChange,
        onBlur: onBlur,
        value: value,
        name: name
      })), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

function FormSSNInput(props) {
  const {
    control,
    name: formItemName,
    defaultValue,
    rules = {},
    label,
    subLabel,
    showOptional,
    style = {}
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(SSNInput, Object.assign({}, props, {
        style: {
          borderColor: error ? getColor('statusError') : ''
        },
        onChange: onChange,
        onBlur: onBlur,
        value: value,
        name: name,
        ref: ref
      })), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

function FormCurrencyInput(props) {
  const {
    control,
    name: formItemName,
    defaultValue,
    rules = {},
    label,
    subLabel,
    showOptional,
    style = {},
    options = []
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      name,
      value
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(NumberInput, Object.assign({}, props, {
        defaultValue: defaultValue.pay || 0,
        min: 0,
        hasError: !!error,
        addonBefore: jsx(_Select, {
          defaultValue: defaultValue.currency,
          options: options,
          value: value.currency,
          onChange: e => {
            onChange(Object.assign(Object.assign({}, value), {
              currency: e
            }));
          }
        }),
        onChange: e => {
          onChange(Object.assign(Object.assign({}, value), {
            pay: e
          }));
        },
        onBlur: onBlur,
        value: value.pay,
        name: name
      })), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

function FormTextarea(props) {
  const {
    control,
    name: formItemName,
    defaultValue,
    rules = {},
    label,
    subLabel,
    showOptional,
    style = {}
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(TextArea$1, Object.assign({}, props, {
        defaultValue: defaultValue,
        style: {
          color: getColor('textPrimary'),
          borderColor: error ? getColor('statusError') : '',
          borderRadius: '8px',
          height: '100px'
        },
        onChange: onChange,
        onBlur: onBlur,
        value: value,
        ref: ref,
        name: name
      })), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

function FormCountrySelector(props) {
  const {
    control,
    name: formItemName,
    defaultValue,
    rules = {},
    label,
    subLabel,
    showOptional,
    style = {}
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      value
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  /** coming in for the firrst time, has to trigger set the country value manually here
   * as the Region selector is not a controlled component
   * */
  useEffect(() => {
    onChange(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(CountrySelector, Object.assign({}, props, {
        value: value,
        onChange: onChange,
        hasError: !!error,
        onBlur: onBlur
      })), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

function FormRegionSelector(props) {
  const {
    control,
    name: formItemName,
    defaultValue,
    rules = {},
    label,
    subLabel,
    showOptional,
    binding,
    style = {}
  } = props;
  const {
    field: {
      onChange,
      onBlur,
      value
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(RegionSelector, Object.assign({}, props, {
        country: binding || '',
        value: value,
        onChange: onChange,
        hasError: !!error,
        onBlur: onBlur
      })), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

var call$1 = functionCall;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject$1 = anObject$f;
var isNullOrUndefined = isNullOrUndefined$7;
var toLength = toLength$3;
var toString = toString$9;
var requireObjectCoercible = requireObjectCoercible$8;
var getMethod = getMethod$5;
var advanceStringIndex = advanceStringIndex$2;
var regExpExec = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call$1(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject$1(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});

const Input$1 = /*#__PURE__*/styled(Input$3).withConfig({
  displayName: "form-pricing-input__Input",
  componentId: "sc-kdfoez-0"
})(["border-radius:8px;.ant-input-group &:first-child{border-top-right-radius:0;border-bottom-right-radius:0;border-top-left-radius:8px;border-bottom-left-radius:8px;}height:40px;border:1px solid ", ";&:hover,&:focus{border:1px solid ", " !important;box-shadow:none !important;}"], getColor('borderDefault'), getColor('borderActive'));
const validate = value => {
  const matches = value.match(/^(?:0\.[0-9]{0,2}|[1-9][0-9]*(?:\.[0-9]{0,2})?|\.[0-9]?|[0-9]+\.?)$/);
  return (matches || []).length > 0;
};
function FormPricingInput(props) {
  const {
      control,
      name: formItemName,
      defaultValue,
      rules = {},
      label,
      subLabel,
      showOptional,
      style = {}
    } = props,
    rest = __rest(props, ["control", "name", "defaultValue", "rules", "label", "subLabel", "showOptional", "style"]);
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  const handleInputChange = event => {
    const newValue = event.target.value;
    if (validate(newValue) || newValue === '') {
      onChange(newValue);
    }
  };
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(Input$1, Object.assign({}, rest, {
        style: {
          borderColor: error ? getColor('statusError') : ''
        },
        onChange: handleInputChange,
        onBlur: onBlur,
        value: value,
        name: name,
        ref: ref,
        prefix: "$"
      })), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

const Input = /*#__PURE__*/styled(NumberInput).withConfig({
  displayName: "form-time-input__Input",
  componentId: "sc-cft8lr-0"
})([".ant-input-group &:first-child{border-top-right-radius:0;border-bottom-right-radius:0;}input{text-align:center;}"]);
// Only for edit balance time(hours/minutes) input
function FormTimeInput(props) {
  const {
      control,
      name: formItemName,
      defaultValue,
      rules = {},
      label,
      subLabel,
      showOptional,
      style = {},
      suffix
    } = props,
    rest = __rest(props, ["control", "name", "defaultValue", "rules", "label", "subLabel", "showOptional", "style", "suffix"]);
  const {
    field: {
      onChange,
      onBlur,
      name,
      value,
      ref
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsxs(FlexBox, {
        alignItems: "center",
        children: [jsx(Input, Object.assign({}, rest, {
          style: {
            borderColor: error ? getColor('statusError') : ''
          },
          onChange: onChange,
          onBlur: onBlur,
          value: value,
          name: name,
          ref: ref,
          precision: 0,
          controls: false
        })), suffix && jsx(Typography, {
          marginLeft: "s2",
          marginRight: "s3",
          children: suffix
        })]
      }), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

const {
  Item: AntDropdownItem,
  ItemGroup
} = DropDownMenu;
const Item = /*#__PURE__*/styled(AntDropdownItem).withConfig({
  displayName: "form-select-radio-group__Item",
  componentId: "sc-1v9axnv-0"
})(["padding:12px 16px;color:", ";"], theme.colors.textPrimary);
const Trigger = /*#__PURE__*/styled.div.withConfig({
  displayName: "form-select-radio-group__Trigger",
  componentId: "sc-1v9axnv-1"
})(["position:relative;.trigger-icon{position:absolute;right:10px;top:50%;transform:translateY(-50%);}", "{color:", ";height:42px;cursor:pointer;&:hover{background-color:", ";}}"], Input$3, getColor('textPrimary'), getColor('surfaceBackground'));
const FormDropdownRadioGroup = props => {
  const {
    title,
    placeholder,
    groupedOptions = [],
    control,
    name: formItemName,
    defaultValue,
    rules = {},
    label,
    subLabel,
    footerNote,
    showOptional,
    style
  } = props;
  const {
    field: {
      onChange,
      value = []
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue
  });
  const handleClickRadio = (selectedValue, groupIdx) => {
    let newValue = [...value];
    const groupValues = groupedOptions[groupIdx].options.map(option => option.value);
    // clean up the newValue first by removing all values from the same group, then add the selected value
    newValue = newValue.filter(val => !groupValues.includes(val));
    newValue.push(selectedValue);
    onChange(newValue);
  };
  const menu = jsx(DropDownMenu, {
    style: {
      maxHeight: 500,
      overflowY: 'auto'
    },
    children: groupedOptions.map((group, groupIdx) => jsxs(Fragment, {
      children: [jsx(ItemGroup, {
        title: group.groupTitle
      }, group.groupTitle), group.options.map(option => jsx(Item, {
        onClick: ({
          domEvent
        }) => {
          domEvent.stopPropagation();
          handleClickRadio(option.value, groupIdx);
        },
        children: jsx(Radio$1, {
          checked: value.includes(option.value),
          label: jsx(Typography, {
            variant: "body",
            color: "textPrimary",
            children: option.label
          })
        })
      }, option.value))]
    }))
  });
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  useClickOutside(triggerRef, () => setIsOpen(false));
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    footerNote: footerNote,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(Fragment, {
      children: [jsx(_Dropdown, {
        overlay: menu,
        visible: isOpen,
        children: jsxs(Trigger, {
          onClick: () => setIsOpen(true),
          ref: triggerRef,
          children: [jsx(Input$3, {
            placeholder: placeholder,
            size: "large",
            // Search is not required for this dropdown radio group
            readOnly: true,
            value: title
          }), jsx("span", {
            className: "trigger-icon",
            children: jsx(ChevronDown, {})
          })]
        })
      }), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
};

function FormRadioGroup(props) {
  const {
    control,
    name: formItemName,
    defaultValue,
    rules = {},
    label,
    subLabel,
    showOptional,
    style = {},
    options
  } = props;
  const {
    field: {
      onChange,
      value
    },
    fieldState: {
      error
    }
  } = useController({
    name: formItemName,
    control,
    rules,
    defaultValue: defaultValue || ''
  });
  return jsx(Field, {
    label: label,
    subLabel: subLabel,
    showOptional: showOptional,
    style: style,
    renderer: jsxs(FlexBox, {
      flexDirection: "column",
      gap: "s2",
      children: [options.map(option => jsx(Radio$1, {
        checked: value === option.value,
        label: option.label,
        onChange: () => onChange(option.value),
        disabled: option.disabled
      }, String(option.value))), error && jsx(FormErrorWrapper, {
        children: (error === null || error === void 0 ? void 0 : error.message) || `${label}: ${ErrorMsgMap[error === null || error === void 0 ? void 0 : error.type] || 'invalid'}`
      })]
    })
  });
}

const DEFAULT_PAGE_SIZE = 10;
const isLastPage = ({
  currentPage,
  total,
  pageSize
}) => {
  return currentPage * pageSize >= total;
};
const isOnlyOnePage = ({
  total,
  pageSize
}) => {
  return total <= pageSize;
};
const PaginationIconContainer = props => {
  const {
    disabled,
    onClick,
    children,
    style = {}
  } = props;
  return jsx(FlexBox, {
    style: Object.assign({
      cursor: disabled ? 'not-allowed' : 'pointer'
    }, style),
    padding: "8px",
    justifyContent: "center",
    alignItems: "center",
    onClick: () => {
      if (disabled) {
        return;
      }
      onClick();
    },
    children: children
  });
};
const PageSizeChangeContainer = ({
  pageSize,
  pageSizeOptions,
  onPageSizeChange,
  disabled: _disabled = false
}) => {
  const pageSizeOptionsItems = pageSizeOptions.map(size => ({
    label: `${size} / page`,
    index: `${size}`,
    onClick: () => {
      onPageSizeChange === null || onPageSizeChange === void 0 ? void 0 : onPageSizeChange(size);
    }
  }));
  return jsx(FlexBox, {
    style: {
      cursor: _disabled ? 'not-allowed' : 'pointer'
    },
    children: jsx(Dropdown, {
      disabled: _disabled,
      trigger: ['click'],
      menu: {
        $width: 140,
        items: pageSizeOptionsItems
      },
      children: jsxs(FlexBox, {
        children: [jsxs(Typography, {
          fontWeight: 600,
          children: [" ", pageSize, " / page "]
        }), jsx(ChevronDown, {})]
      })
    })
  });
};
const CurrentPageInfo = ({
  currentPage,
  total,
  pageSize
}) => {
  const start = (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, total);
  return jsx(FlexBox, {
    mr: "20px",
    px: "16px",
    py: "10px",
    children: jsxs(Typography, {
      fontWeight: 600,
      children: [start, "-", end, " of ", total]
    })
  });
};
const Pagination = props => {
  const {
    current,
    total = 0,
    defaultPageSize = DEFAULT_PAGE_SIZE,
    defaultCurrent = 1,
    hideOnSinglePage = false,
    onChange,
    disabled = false,
    showSizeChanger = false,
    onShowSizeChange,
    pageSizeOptions = [10, 20, 50]
  } = props;
  const [currentPage, setCurrentPage] = useState(defaultCurrent);
  const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
  useEffect(() => {
    if (current) {
      setCurrentPage(current);
    }
  }, [current]);
  useEffect(() => {
    if (defaultPageSize) {
      setCurrentPageSize(defaultPageSize);
    }
  }, [defaultPageSize]);
  if (hideOnSinglePage && isOnlyOnePage({
    total,
    pageSize: currentPageSize
  })) {
    return null;
  }
  const isPrevButtonDisabled = currentPage === 1 || disabled;
  const isNextButtonDisabled = isLastPage({
    currentPage,
    total,
    pageSize: currentPageSize
  }) || disabled;
  return jsxs(FlexBox, {
    alignItems: 'center',
    children: [showSizeChanger && jsx(PageSizeChangeContainer, {
      disabled: disabled,
      pageSize: currentPageSize,
      pageSizeOptions: pageSizeOptions,
      onPageSizeChange: size => {
        if (isLastPage({
          currentPage,
          total,
          pageSize: size
        })) {
          setCurrentPage(Math.ceil(total / size));
          onChange === null || onChange === void 0 ? void 0 : onChange(Math.ceil(total / size));
        }
        setCurrentPageSize(size);
        onShowSizeChange === null || onShowSizeChange === void 0 ? void 0 : onShowSizeChange(currentPage, size);
      }
    }), jsx(CurrentPageInfo, {
      currentPage: currentPage,
      total: total,
      pageSize: currentPageSize
    }), jsxs(FlexBox, {
      children: [jsx(PaginationIconContainer, {
        disabled: isPrevButtonDisabled,
        style: {
          marginRight: '20px'
        },
        onClick: () => {
          setCurrentPage(currentPage - 1);
          onChange === null || onChange === void 0 ? void 0 : onChange(currentPage - 1);
        },
        children: jsx(ChevronLeft, {
          disabled: isPrevButtonDisabled
        })
      }), jsx(PaginationIconContainer, {
        disabled: isNextButtonDisabled,
        onClick: () => {
          setCurrentPage(currentPage + 1);
          onChange === null || onChange === void 0 ? void 0 : onChange(currentPage + 1);
        },
        children: jsx(ChevronRight, {
          disabled: isNextButtonDisabled
        })
      })]
    })]
  });
};

var emptyDataImage = "b3aa60199ba68d21.svg";

const EmptyContent = props => {
  const {
    title = 'No results found',
    content
  } = props;
  return jsxs(FlexBox, {
    flexDirection: 'column',
    mt: "24px",
    children: [jsx("img", {
      src: emptyDataImage,
      alt: "No results found",
      style: {
        margin: '0 auto',
        width: '200px'
      }
    }), jsxs(FlexBox, {
      flexDirection: 'column',
      alignItems: 'center',
      mt: "20px",
      children: [title && jsx(Typography, {
        color: 'gray800',
        fontWeight: 600,
        style: {
          marginTop: '20px',
          marginBottom: '4px'
        },
        children: title
      }), jsx(Typography, {
        color: 'gray800',
        children: content
      })]
    })]
  });
};

const usePagination = (total, onChange, pagination) => {
  const paginationObj = pagination && typeof pagination === 'object' ? pagination : {};
  const {
      total: paginationTotal = 0
    } = paginationObj,
    restPaginationObj = __rest(paginationObj, ["total"]);
  const [currentPage, setCurrentPage] = useState(restPaginationObj.defaultCurrent || 1);
  const [currentPageSize, setCurrentPageSize] = useState(restPaginationObj.pageSize || restPaginationObj.defaultPageSize || DEFAULT_PAGE_SIZE);
  const onPageSizeChange = (current, pageSize) => {
    var _a;
    setCurrentPageSize(pageSize);
    if (pagination) {
      (_a = pagination.onShowSizeChange) === null || _a === void 0 ? void 0 : _a.call(pagination, current, pageSize);
    }
  };
  const setPaginationCurrentPage = page => {
    setCurrentPage(page);
  };
  const onPageChange = page => {
    var _a;
    if (pagination) {
      (_a = pagination.onChange) === null || _a === void 0 ? void 0 : _a.call(pagination, page);
    }
    setCurrentPage(page);
    onChange(page);
  };
  if (restPaginationObj.current && typeof restPaginationObj.current !== 'number') {
    console.error('page current is not a number');
  }
  const paginationProps = Object.assign({
    total: paginationTotal > 0 ? paginationTotal : total,
    current: currentPage,
    onShowSizeChange: onPageSizeChange,
    pageSize: currentPageSize
  }, pagination);
  return [Object.assign(Object.assign({}, paginationProps), {
    onChange: onPageChange
  }), setPaginationCurrentPage];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const styledTable = () => styled(props => {
  return jsx(Table$1, Object.assign({}, props));
}).withConfig({
  displayName: "table__styledTable",
  componentId: "sc-5xp6sp-0"
})(props => {
  const antdCssPrefix = globalConfig().getPrefixCls();
  const {
    rowBorder = true
  } = props;
  return css(["& .", "-table-thead{& > tr:first-child{& > th:first-child{border-top-left-radius:8px;}& > th:last-child{border-top-right-radius:8px;}}& > tr > th{font-weight:600;font-size:14px;line-height:20px;color:", ";", ";&::before{display:none;}}th{padding:14px 12px 14px 8px;background:", ";", ";", ";}th:first-child{padding-left:18px;}}& tbody.", "-table-tbody{font-weight:400;font-size:14px;line-height:20px;& .", "-table-row{td{padding:14px 12px 14px 8px;", ";}td:first-child{padding-left:18px;}}}"], antdCssPrefix, theme.colors.gray800, !rowBorder && 'border-bottom: unset', theme.colors.gray200, rowBorder && `border-bottom: 1px solid ${theme.colors.gray300}`, rowBorder && `border-top: 1px solid ${theme.colors.gray300}`, antdCssPrefix, antdCssPrefix, rowBorder ? `border-bottom: 1px solid ${theme.colors.gray300}` : 'border-bottom: unset');
});
const StyledTable = styledTable();
const Table = props => {
  const {
      pagination,
      dataSource = [],
      onPaginationChange = noop$2,
      emptyContent
    } = props,
    rest = __rest(props, ["pagination", "dataSource", "onPaginationChange", "emptyContent"]);
  const showPagination = pagination !== false && dataSource.length > 0;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [paginationProps, _] = usePagination(dataSource.length, onPaginationChange, pagination);
  const pageData = useMemo(() => {
    if (pagination === false) {
      return dataSource;
    }
    const {
      current = 1,
      pageSize = DEFAULT_PAGE_SIZE,
      total
    } = paginationProps;
    if (dataSource.length < total) {
      if (dataSource.length > pageSize) {
        return dataSource.slice((current - 1) * pageSize, current * pageSize);
      }
      return dataSource;
    }
    return dataSource.slice((current - 1) * pageSize, current * pageSize);
  }, [dataSource, pagination, paginationProps]);
  return jsx(_ConfigProvider, {
    renderEmpty: () => {
      return jsx(EmptyContent, Object.assign({}, emptyContent));
    },
    children: jsxs(FlexBox, {
      flexDirection: 'column',
      width: '100%',
      children: [jsx(StyledTable, Object.assign({}, rest, {
        dataSource: pageData,
        pagination: false
      })), showPagination && jsx(FlexBox, {
        justifyContent: "flex-end",
        mt: "12px",
        children: jsx(Pagination, Object.assign({}, paginationProps))
      })]
    })
  });
};

function useCombinedRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return useMemo(() => node => {
    refs.forEach(ref => ref(node));
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  refs);
}

// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const canUseDOM = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';

function isWindow(element) {
  const elementString = Object.prototype.toString.call(element);
  return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
  elementString === '[object global]';
}

function isNode(node) {
  return 'nodeType' in node;
}

function getWindow(target) {
  var _target$ownerDocument, _target$ownerDocument2;

  if (!target) {
    return window;
  }

  if (isWindow(target)) {
    return target;
  }

  if (!isNode(target)) {
    return window;
  }

  return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}

function isDocument(node) {
  const {
    Document
  } = getWindow(node);
  return node instanceof Document;
}

function isHTMLElement(node) {
  if (isWindow(node)) {
    return false;
  }

  return node instanceof getWindow(node).HTMLElement;
}

function isSVGElement(node) {
  return node instanceof getWindow(node).SVGElement;
}

function getOwnerDocument(target) {
  if (!target) {
    return document;
  }

  if (isWindow(target)) {
    return target.document;
  }

  if (!isNode(target)) {
    return document;
  }

  if (isDocument(target)) {
    return target;
  }

  if (isHTMLElement(target) || isSVGElement(target)) {
    return target.ownerDocument;
  }

  return document;
}

/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */

const useIsomorphicLayoutEffect = canUseDOM ? useLayoutEffect : useEffect;

function useEvent(handler) {
  const handlerRef = useRef(handler);
  useIsomorphicLayoutEffect(() => {
    handlerRef.current = handler;
  });
  return useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return handlerRef.current == null ? void 0 : handlerRef.current(...args);
  }, []);
}

function useInterval() {
  const intervalRef = useRef(null);
  const set = useCallback((listener, duration) => {
    intervalRef.current = setInterval(listener, duration);
  }, []);
  const clear = useCallback(() => {
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, []);
  return [set, clear];
}

function useLatestValue(value, dependencies) {
  if (dependencies === void 0) {
    dependencies = [value];
  }

  const valueRef = useRef(value);
  useIsomorphicLayoutEffect(() => {
    if (valueRef.current !== value) {
      valueRef.current = value;
    }
  }, dependencies);
  return valueRef;
}

function useLazyMemo(callback, dependencies) {
  const valueRef = useRef();
  return useMemo(() => {
    const newValue = callback(valueRef.current);
    valueRef.current = newValue;
    return newValue;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [...dependencies]);
}

function useNodeRef(onChange) {
  const onChangeHandler = useEvent(onChange);
  const node = useRef(null);
  const setNodeRef = useCallback(element => {
    if (element !== node.current) {
      onChangeHandler == null ? void 0 : onChangeHandler(element, node.current);
    }

    node.current = element;
  }, //eslint-disable-next-line
  []);
  return [node, setNodeRef];
}

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

let ids = {};
function useUniqueId(prefix, value) {
  return useMemo(() => {
    if (value) {
      return value;
    }

    const id = ids[prefix] == null ? 0 : ids[prefix] + 1;
    ids[prefix] = id;
    return prefix + "-" + id;
  }, [prefix, value]);
}

function createAdjustmentFn(modifier) {
  return function (object) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }

    return adjustments.reduce((accumulator, adjustment) => {
      const entries = Object.entries(adjustment);

      for (const [key, valueAdjustment] of entries) {
        const value = accumulator[key];

        if (value != null) {
          accumulator[key] = value + modifier * valueAdjustment;
        }
      }

      return accumulator;
    }, { ...object
    });
  };
}

const add = /*#__PURE__*/createAdjustmentFn(1);
const subtract = /*#__PURE__*/createAdjustmentFn(-1);

function hasViewportRelativeCoordinates(event) {
  return 'clientX' in event && 'clientY' in event;
}

function isKeyboardEvent(event) {
  if (!event) {
    return false;
  }

  const {
    KeyboardEvent
  } = getWindow(event.target);
  return KeyboardEvent && event instanceof KeyboardEvent;
}

function isTouchEvent(event) {
  if (!event) {
    return false;
  }

  const {
    TouchEvent
  } = getWindow(event.target);
  return TouchEvent && event instanceof TouchEvent;
}

/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */

function getEventCoordinates(event) {
  if (isTouchEvent(event)) {
    if (event.touches && event.touches.length) {
      const {
        clientX: x,
        clientY: y
      } = event.touches[0];
      return {
        x,
        y
      };
    } else if (event.changedTouches && event.changedTouches.length) {
      const {
        clientX: x,
        clientY: y
      } = event.changedTouches[0];
      return {
        x,
        y
      };
    }
  }

  if (hasViewportRelativeCoordinates(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }

  return null;
}

const CSS = /*#__PURE__*/Object.freeze({
  Translate: {
    toString(transform) {
      if (!transform) {
        return;
      }

      const {
        x,
        y
      } = transform;
      return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
    }

  },
  Scale: {
    toString(transform) {
      if (!transform) {
        return;
      }

      const {
        scaleX,
        scaleY
      } = transform;
      return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
    }

  },
  Transform: {
    toString(transform) {
      if (!transform) {
        return;
      }

      return [CSS.Translate.toString(transform), CSS.Scale.toString(transform)].join(' ');
    }

  },
  Transition: {
    toString(_ref) {
      let {
        property,
        duration,
        easing
      } = _ref;
      return property + " " + duration + "ms " + easing;
    }

  }
});

const SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function findFirstFocusableNode(element) {
  if (element.matches(SELECTOR)) {
    return element;
  }

  return element.querySelector(SELECTOR);
}

const hiddenStyles = {
  display: 'none'
};
function HiddenText(_ref) {
  let {
    id,
    value
  } = _ref;
  return React.createElement("div", {
    id: id,
    style: hiddenStyles
  }, value);
}

function LiveRegion(_ref) {
  let {
    id,
    announcement,
    ariaLiveType = "assertive"
  } = _ref;
  // Hide element visually but keep it readable by screen readers
  const visuallyHidden = {
    position: 'fixed',
    width: 1,
    height: 1,
    margin: -1,
    border: 0,
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(100%)',
    whiteSpace: 'nowrap'
  };
  return React.createElement("div", {
    id: id,
    style: visuallyHidden,
    role: "status",
    "aria-live": ariaLiveType,
    "aria-atomic": true
  }, announcement);
}

function useAnnouncement() {
  const [announcement, setAnnouncement] = useState('');
  const announce = useCallback(value => {
    if (value != null) {
      setAnnouncement(value);
    }
  }, []);
  return {
    announce,
    announcement
  };
}

const DndMonitorContext = /*#__PURE__*/createContext(null);

function useDndMonitor(listener) {
  const registerListener = useContext(DndMonitorContext);
  useEffect(() => {
    if (!registerListener) {
      throw new Error('useDndMonitor must be used within a children of <DndContext>');
    }

    const unsubscribe = registerListener(listener);
    return unsubscribe;
  }, [listener, registerListener]);
}

function useDndMonitorProvider() {
  const [listeners] = useState(() => new Set());
  const registerListener = useCallback(listener => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, [listeners]);
  const dispatch = useCallback(_ref => {
    let {
      type,
      event
    } = _ref;
    listeners.forEach(listener => {
      var _listener$type;

      return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
    });
  }, [listeners]);
  return [dispatch, registerListener];
}

const defaultScreenReaderInstructions = {
  draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const defaultAnnouncements = {
  onDragStart(_ref) {
    let {
      active
    } = _ref;
    return "Picked up draggable item " + active.id + ".";
  },

  onDragOver(_ref2) {
    let {
      active,
      over
    } = _ref2;

    if (over) {
      return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
    }

    return "Draggable item " + active.id + " is no longer over a droppable area.";
  },

  onDragEnd(_ref3) {
    let {
      active,
      over
    } = _ref3;

    if (over) {
      return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
    }

    return "Draggable item " + active.id + " was dropped.";
  },

  onDragCancel(_ref4) {
    let {
      active
    } = _ref4;
    return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
  }

};

function Accessibility(_ref) {
  let {
    announcements = defaultAnnouncements,
    container,
    hiddenTextDescribedById,
    screenReaderInstructions = defaultScreenReaderInstructions
  } = _ref;
  const {
    announce,
    announcement
  } = useAnnouncement();
  const liveRegionId = useUniqueId("DndLiveRegion");
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  useDndMonitor(useMemo(() => ({
    onDragStart(_ref2) {
      let {
        active
      } = _ref2;
      announce(announcements.onDragStart({
        active
      }));
    },

    onDragMove(_ref3) {
      let {
        active,
        over
      } = _ref3;

      if (announcements.onDragMove) {
        announce(announcements.onDragMove({
          active,
          over
        }));
      }
    },

    onDragOver(_ref4) {
      let {
        active,
        over
      } = _ref4;
      announce(announcements.onDragOver({
        active,
        over
      }));
    },

    onDragEnd(_ref5) {
      let {
        active,
        over
      } = _ref5;
      announce(announcements.onDragEnd({
        active,
        over
      }));
    },

    onDragCancel(_ref6) {
      let {
        active,
        over
      } = _ref6;
      announce(announcements.onDragCancel({
        active,
        over
      }));
    }

  }), [announce, announcements]));

  if (!mounted) {
    return null;
  }

  const markup = React.createElement(React.Fragment, null, React.createElement(HiddenText, {
    id: hiddenTextDescribedById,
    value: screenReaderInstructions.draggable
  }), React.createElement(LiveRegion, {
    id: liveRegionId,
    announcement: announcement
  }));
  return container ? createPortal(markup, container) : markup;
}

var Action;

(function (Action) {
  Action["DragStart"] = "dragStart";
  Action["DragMove"] = "dragMove";
  Action["DragEnd"] = "dragEnd";
  Action["DragCancel"] = "dragCancel";
  Action["DragOver"] = "dragOver";
  Action["RegisterDroppable"] = "registerDroppable";
  Action["SetDroppableDisabled"] = "setDroppableDisabled";
  Action["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));

function noop() {}

function useSensor(sensor, options) {
  return useMemo(() => ({
    sensor,
    options: options != null ? options : {}
  }), // eslint-disable-next-line react-hooks/exhaustive-deps
  [sensor, options]);
}

function useSensors() {
  for (var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++) {
    sensors[_key] = arguments[_key];
  }

  return useMemo(() => [...sensors].filter(sensor => sensor != null), // eslint-disable-next-line react-hooks/exhaustive-deps
  [...sensors]);
}

const defaultCoordinates = /*#__PURE__*/Object.freeze({
  x: 0,
  y: 0
});

/**
 * Returns the distance between two points
 */
function distanceBetween(p1, p2) {
  return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}

function getRelativeTransformOrigin(event, rect) {
  const eventCoordinates = getEventCoordinates(event);

  if (!eventCoordinates) {
    return '0 0';
  }

  const transformOrigin = {
    x: (eventCoordinates.x - rect.left) / rect.width * 100,
    y: (eventCoordinates.y - rect.top) / rect.height * 100
  };
  return transformOrigin.x + "% " + transformOrigin.y + "%";
}

/**
 * Sort collisions from smallest to greatest value
 */
function sortCollisionsAsc(_ref, _ref2) {
  let {
    data: {
      value: a
    }
  } = _ref;
  let {
    data: {
      value: b
    }
  } = _ref2;
  return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */

function sortCollisionsDesc(_ref3, _ref4) {
  let {
    data: {
      value: a
    }
  } = _ref3;
  let {
    data: {
      value: b
    }
  } = _ref4;
  return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */

function cornersOfRectangle(_ref5) {
  let {
    left,
    top,
    height,
    width
  } = _ref5;
  return [{
    x: left,
    y: top
  }, {
    x: left + width,
    y: top
  }, {
    x: left,
    y: top + height
  }, {
    x: left + width,
    y: top + height
  }];
}
function getFirstCollision(collisions, property) {
  if (!collisions || collisions.length === 0) {
    return null;
  }

  const [firstCollision] = collisions;
  return property ? firstCollision[property] : firstCollision;
}

/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */

const closestCorners = _ref => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const corners = cornersOfRectangle(collisionRect);
  const collisions = [];

  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect) {
      const rectCorners = cornersOfRectangle(rect);
      const distances = corners.reduce((accumulator, corner, index) => {
        return accumulator + distanceBetween(rectCorners[index], corner);
      }, 0);
      const effectiveDistance = Number((distances / 4).toFixed(4));
      collisions.push({
        id,
        data: {
          droppableContainer,
          value: effectiveDistance
        }
      });
    }
  }

  return collisions.sort(sortCollisionsAsc);
};

/**
 * Returns the intersecting rectangle area between two rectangles
 */

function getIntersectionRatio(entry, target) {
  const top = Math.max(target.top, entry.top);
  const left = Math.max(target.left, entry.left);
  const right = Math.min(target.left + target.width, entry.left + entry.width);
  const bottom = Math.min(target.top + target.height, entry.top + entry.height);
  const width = right - left;
  const height = bottom - top;

  if (left < right && top < bottom) {
    const targetArea = target.width * target.height;
    const entryArea = entry.width * entry.height;
    const intersectionArea = width * height;
    const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
    return Number(intersectionRatio.toFixed(4));
  } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)


  return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */

const rectIntersection = _ref => {
  let {
    collisionRect,
    droppableRects,
    droppableContainers
  } = _ref;
  const collisions = [];

  for (const droppableContainer of droppableContainers) {
    const {
      id
    } = droppableContainer;
    const rect = droppableRects.get(id);

    if (rect) {
      const intersectionRatio = getIntersectionRatio(rect, collisionRect);

      if (intersectionRatio > 0) {
        collisions.push({
          id,
          data: {
            droppableContainer,
            value: intersectionRatio
          }
        });
      }
    }
  }

  return collisions.sort(sortCollisionsDesc);
};

function adjustScale(transform, rect1, rect2) {
  return { ...transform,
    scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
    scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
  };
}

function getRectDelta(rect1, rect2) {
  return rect1 && rect2 ? {
    x: rect1.left - rect2.left,
    y: rect1.top - rect2.top
  } : defaultCoordinates;
}

function createRectAdjustmentFn(modifier) {
  return function adjustClientRect(rect) {
    for (var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      adjustments[_key - 1] = arguments[_key];
    }

    return adjustments.reduce((acc, adjustment) => ({ ...acc,
      top: acc.top + modifier * adjustment.y,
      bottom: acc.bottom + modifier * adjustment.y,
      left: acc.left + modifier * adjustment.x,
      right: acc.right + modifier * adjustment.x
    }), { ...rect
    });
  };
}
const getAdjustedRect = /*#__PURE__*/createRectAdjustmentFn(1);

function parseTransform(transform) {
  if (transform.startsWith('matrix3d(')) {
    const transformArray = transform.slice(9, -1).split(/, /);
    return {
      x: +transformArray[12],
      y: +transformArray[13],
      scaleX: +transformArray[0],
      scaleY: +transformArray[5]
    };
  } else if (transform.startsWith('matrix(')) {
    const transformArray = transform.slice(7, -1).split(/, /);
    return {
      x: +transformArray[4],
      y: +transformArray[5],
      scaleX: +transformArray[0],
      scaleY: +transformArray[3]
    };
  }

  return null;
}

function inverseTransform(rect, transform, transformOrigin) {
  const parsedTransform = parseTransform(transform);

  if (!parsedTransform) {
    return rect;
  }

  const {
    scaleX,
    scaleY,
    x: translateX,
    y: translateY
  } = parsedTransform;
  const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
  const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
  const w = scaleX ? rect.width / scaleX : rect.width;
  const h = scaleY ? rect.height / scaleY : rect.height;
  return {
    width: w,
    height: h,
    top: y,
    right: x + w,
    bottom: y + h,
    left: x
  };
}

const defaultOptions = {
  ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */

function getClientRect(element, options) {
  if (options === void 0) {
    options = defaultOptions;
  }

  let rect = element.getBoundingClientRect();

  if (options.ignoreTransform) {
    const {
      transform,
      transformOrigin
    } = getWindow(element).getComputedStyle(element);

    if (transform) {
      rect = inverseTransform(rect, transform, transformOrigin);
    }
  }

  const {
    top,
    left,
    width,
    height,
    bottom,
    right
  } = rect;
  return {
    top,
    left,
    width,
    height,
    bottom,
    right
  };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */

function getTransformAgnosticClientRect(element) {
  return getClientRect(element, {
    ignoreTransform: true
  });
}

function getWindowClientRect(element) {
  const width = element.innerWidth;
  const height = element.innerHeight;
  return {
    top: 0,
    left: 0,
    right: width,
    bottom: height,
    width,
    height
  };
}

function isFixed(node, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow(node).getComputedStyle(node);
  }

  return computedStyle.position === 'fixed';
}

function isScrollable(element, computedStyle) {
  if (computedStyle === void 0) {
    computedStyle = getWindow(element).getComputedStyle(element);
  }

  const overflowRegex = /(auto|scroll|overlay)/;
  const properties = ['overflow', 'overflowX', 'overflowY'];
  return properties.some(property => {
    const value = computedStyle[property];
    return typeof value === 'string' ? overflowRegex.test(value) : false;
  });
}

function getScrollableAncestors(element, limit) {
  const scrollParents = [];

  function findScrollableAncestors(node) {
    if (limit != null && scrollParents.length >= limit) {
      return scrollParents;
    }

    if (!node) {
      return scrollParents;
    }

    if (isDocument(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
      scrollParents.push(node.scrollingElement);
      return scrollParents;
    }

    if (!isHTMLElement(node) || isSVGElement(node)) {
      return scrollParents;
    }

    if (scrollParents.includes(node)) {
      return scrollParents;
    }

    const computedStyle = getWindow(element).getComputedStyle(node);

    if (node !== element) {
      if (isScrollable(node, computedStyle)) {
        scrollParents.push(node);
      }
    }

    if (isFixed(node, computedStyle)) {
      return scrollParents;
    }

    return findScrollableAncestors(node.parentNode);
  }

  if (!element) {
    return scrollParents;
  }

  return findScrollableAncestors(element);
}
function getFirstScrollableAncestor(node) {
  const [firstScrollableAncestor] = getScrollableAncestors(node, 1);
  return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}

function getScrollableElement(element) {
  if (!canUseDOM || !element) {
    return null;
  }

  if (isWindow(element)) {
    return element;
  }

  if (!isNode(element)) {
    return null;
  }

  if (isDocument(element) || element === getOwnerDocument(element).scrollingElement) {
    return window;
  }

  if (isHTMLElement(element)) {
    return element;
  }

  return null;
}

function getScrollXCoordinate(element) {
  if (isWindow(element)) {
    return element.scrollX;
  }

  return element.scrollLeft;
}
function getScrollYCoordinate(element) {
  if (isWindow(element)) {
    return element.scrollY;
  }

  return element.scrollTop;
}
function getScrollCoordinates(element) {
  return {
    x: getScrollXCoordinate(element),
    y: getScrollYCoordinate(element)
  };
}

var Direction;

(function (Direction) {
  Direction[Direction["Forward"] = 1] = "Forward";
  Direction[Direction["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));

function isDocumentScrollingElement(element) {
  if (!canUseDOM || !element) {
    return false;
  }

  return element === document.scrollingElement;
}

function getScrollPosition(scrollingContainer) {
  const minScroll = {
    x: 0,
    y: 0
  };
  const dimensions = isDocumentScrollingElement(scrollingContainer) ? {
    height: window.innerHeight,
    width: window.innerWidth
  } : {
    height: scrollingContainer.clientHeight,
    width: scrollingContainer.clientWidth
  };
  const maxScroll = {
    x: scrollingContainer.scrollWidth - dimensions.width,
    y: scrollingContainer.scrollHeight - dimensions.height
  };
  const isTop = scrollingContainer.scrollTop <= minScroll.y;
  const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
  const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
  const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
  return {
    isTop,
    isLeft,
    isBottom,
    isRight,
    maxScroll,
    minScroll
  };
}

const defaultThreshold = {
  x: 0.2,
  y: 0.2
};
function getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
  let {
    top,
    left,
    right,
    bottom
  } = _ref;

  if (acceleration === void 0) {
    acceleration = 10;
  }

  if (thresholdPercentage === void 0) {
    thresholdPercentage = defaultThreshold;
  }

  const {
    isTop,
    isBottom,
    isLeft,
    isRight
  } = getScrollPosition(scrollContainer);
  const direction = {
    x: 0,
    y: 0
  };
  const speed = {
    x: 0,
    y: 0
  };
  const threshold = {
    height: scrollContainerRect.height * thresholdPercentage.y,
    width: scrollContainerRect.width * thresholdPercentage.x
  };

  if (!isTop && top <= scrollContainerRect.top + threshold.height) {
    // Scroll Up
    direction.y = Direction.Backward;
    speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
  } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
    // Scroll Down
    direction.y = Direction.Forward;
    speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
  }

  if (!isRight && right >= scrollContainerRect.right - threshold.width) {
    // Scroll Right
    direction.x = Direction.Forward;
    speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
  } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
    // Scroll Left
    direction.x = Direction.Backward;
    speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
  }

  return {
    direction,
    speed
  };
}

function getScrollElementRect(element) {
  if (element === document.scrollingElement) {
    const {
      innerWidth,
      innerHeight
    } = window;
    return {
      top: 0,
      left: 0,
      right: innerWidth,
      bottom: innerHeight,
      width: innerWidth,
      height: innerHeight
    };
  }

  const {
    top,
    left,
    right,
    bottom
  } = element.getBoundingClientRect();
  return {
    top,
    left,
    right,
    bottom,
    width: element.clientWidth,
    height: element.clientHeight
  };
}

function getScrollOffsets(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node) => {
    return add(acc, getScrollCoordinates(node));
  }, defaultCoordinates);
}
function getScrollXOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node) => {
    return acc + getScrollXCoordinate(node);
  }, 0);
}
function getScrollYOffset(scrollableAncestors) {
  return scrollableAncestors.reduce((acc, node) => {
    return acc + getScrollYCoordinate(node);
  }, 0);
}

function scrollIntoViewIfNeeded(element, measure) {
  if (measure === void 0) {
    measure = getClientRect;
  }

  if (!element) {
    return;
  }

  const {
    top,
    left,
    bottom,
    right
  } = measure(element);
  const firstScrollableAncestor = getFirstScrollableAncestor(element);

  if (!firstScrollableAncestor) {
    return;
  }

  if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) {
    element.scrollIntoView({
      block: 'center',
      inline: 'center'
    });
  }
}

const properties = [['x', ['left', 'right'], getScrollXOffset], ['y', ['top', 'bottom'], getScrollYOffset]];
class Rect {
  constructor(rect, element) {
    this.rect = void 0;
    this.width = void 0;
    this.height = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.right = void 0;
    this.left = void 0;
    const scrollableAncestors = getScrollableAncestors(element);
    const scrollOffsets = getScrollOffsets(scrollableAncestors);
    this.rect = { ...rect
    };
    this.width = rect.width;
    this.height = rect.height;

    for (const [axis, keys, getScrollOffset] of properties) {
      for (const key of keys) {
        Object.defineProperty(this, key, {
          get: () => {
            const currentOffsets = getScrollOffset(scrollableAncestors);
            const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
            return this.rect[key] + scrollOffsetsDeltla;
          },
          enumerable: true
        });
      }
    }

    Object.defineProperty(this, 'rect', {
      enumerable: false
    });
  }

}

class Listeners {
  constructor(target) {
    this.target = void 0;
    this.listeners = [];

    this.removeAll = () => {
      this.listeners.forEach(listener => {
        var _this$target;

        return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
      });
    };

    this.target = target;
  }

  add(eventName, handler, options) {
    var _this$target2;

    (_this$target2 = this.target) == null ? void 0 : _this$target2.addEventListener(eventName, handler, options);
    this.listeners.push([eventName, handler, options]);
  }

}

function getEventListenerTarget(target) {
  // If the `event.target` element is removed from the document events will still be targeted
  // at it, and hence won't always bubble up to the window or document anymore.
  // If there is any risk of an element being removed while it is being dragged,
  // the best practice is to attach the event listeners directly to the target.
  // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
  const {
    EventTarget
  } = getWindow(target);
  return target instanceof EventTarget ? target : getOwnerDocument(target);
}

function hasExceededDistance(delta, measurement) {
  const dx = Math.abs(delta.x);
  const dy = Math.abs(delta.y);

  if (typeof measurement === 'number') {
    return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
  }

  if ('x' in measurement && 'y' in measurement) {
    return dx > measurement.x && dy > measurement.y;
  }

  if ('x' in measurement) {
    return dx > measurement.x;
  }

  if ('y' in measurement) {
    return dy > measurement.y;
  }

  return false;
}

var EventName;

(function (EventName) {
  EventName["Click"] = "click";
  EventName["DragStart"] = "dragstart";
  EventName["Keydown"] = "keydown";
  EventName["ContextMenu"] = "contextmenu";
  EventName["Resize"] = "resize";
  EventName["SelectionChange"] = "selectionchange";
  EventName["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));

function preventDefault(event) {
  event.preventDefault();
}
function stopPropagation(event) {
  event.stopPropagation();
}

var KeyboardCode;

(function (KeyboardCode) {
  KeyboardCode["Space"] = "Space";
  KeyboardCode["Down"] = "ArrowDown";
  KeyboardCode["Right"] = "ArrowRight";
  KeyboardCode["Left"] = "ArrowLeft";
  KeyboardCode["Up"] = "ArrowUp";
  KeyboardCode["Esc"] = "Escape";
  KeyboardCode["Enter"] = "Enter";
})(KeyboardCode || (KeyboardCode = {}));

const defaultKeyboardCodes = {
  start: [KeyboardCode.Space, KeyboardCode.Enter],
  cancel: [KeyboardCode.Esc],
  end: [KeyboardCode.Space, KeyboardCode.Enter]
};
const defaultKeyboardCoordinateGetter = (event, _ref) => {
  let {
    currentCoordinates
  } = _ref;

  switch (event.code) {
    case KeyboardCode.Right:
      return { ...currentCoordinates,
        x: currentCoordinates.x + 25
      };

    case KeyboardCode.Left:
      return { ...currentCoordinates,
        x: currentCoordinates.x - 25
      };

    case KeyboardCode.Down:
      return { ...currentCoordinates,
        y: currentCoordinates.y + 25
      };

    case KeyboardCode.Up:
      return { ...currentCoordinates,
        y: currentCoordinates.y - 25
      };
  }

  return undefined;
};

class KeyboardSensor {
  constructor(props) {
    this.props = void 0;
    this.autoScrollEnabled = false;
    this.referenceCoordinates = void 0;
    this.listeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    const {
      event: {
        target
      }
    } = props;
    this.props = props;
    this.listeners = new Listeners(getOwnerDocument(target));
    this.windowListeners = new Listeners(getWindow(target));
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.attach();
  }

  attach() {
    this.handleStart();
    this.windowListeners.add(EventName.Resize, this.handleCancel);
    this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
    setTimeout(() => this.listeners.add(EventName.Keydown, this.handleKeyDown));
  }

  handleStart() {
    const {
      activeNode,
      onStart
    } = this.props;
    const node = activeNode.node.current;

    if (node) {
      scrollIntoViewIfNeeded(node);
    }

    onStart(defaultCoordinates);
  }

  handleKeyDown(event) {
    if (isKeyboardEvent(event)) {
      const {
        active,
        context,
        options
      } = this.props;
      const {
        keyboardCodes = defaultKeyboardCodes,
        coordinateGetter = defaultKeyboardCoordinateGetter,
        scrollBehavior = 'smooth'
      } = options;
      const {
        code
      } = event;

      if (keyboardCodes.end.includes(code)) {
        this.handleEnd(event);
        return;
      }

      if (keyboardCodes.cancel.includes(code)) {
        this.handleCancel(event);
        return;
      }

      const {
        collisionRect
      } = context.current;
      const currentCoordinates = collisionRect ? {
        x: collisionRect.left,
        y: collisionRect.top
      } : defaultCoordinates;

      if (!this.referenceCoordinates) {
        this.referenceCoordinates = currentCoordinates;
      }

      const newCoordinates = coordinateGetter(event, {
        active,
        context: context.current,
        currentCoordinates
      });

      if (newCoordinates) {
        const coordinatesDelta = subtract(newCoordinates, currentCoordinates);
        const scrollDelta = {
          x: 0,
          y: 0
        };
        const {
          scrollableAncestors
        } = context.current;

        for (const scrollContainer of scrollableAncestors) {
          const direction = event.code;
          const {
            isTop,
            isRight,
            isLeft,
            isBottom,
            maxScroll,
            minScroll
          } = getScrollPosition(scrollContainer);
          const scrollElementRect = getScrollElementRect(scrollContainer);
          const clampedCoordinates = {
            x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
            y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
          };
          const canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
          const canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;

          if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
            const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
            const canScrollToNewCoordinates = direction === KeyboardCode.Right && newScrollCoordinates <= maxScroll.x || direction === KeyboardCode.Left && newScrollCoordinates >= minScroll.x;

            if (canScrollToNewCoordinates && !coordinatesDelta.y) {
              // We don't need to update coordinates, the scroll adjustment alone will trigger
              // logic to auto-detect the new container we are over
              scrollContainer.scrollTo({
                left: newScrollCoordinates,
                behavior: scrollBehavior
              });
              return;
            }

            if (canScrollToNewCoordinates) {
              scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
            } else {
              scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
            }

            if (scrollDelta.x) {
              scrollContainer.scrollBy({
                left: -scrollDelta.x,
                behavior: scrollBehavior
              });
            }

            break;
          } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
            const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
            const canScrollToNewCoordinates = direction === KeyboardCode.Down && newScrollCoordinates <= maxScroll.y || direction === KeyboardCode.Up && newScrollCoordinates >= minScroll.y;

            if (canScrollToNewCoordinates && !coordinatesDelta.x) {
              // We don't need to update coordinates, the scroll adjustment alone will trigger
              // logic to auto-detect the new container we are over
              scrollContainer.scrollTo({
                top: newScrollCoordinates,
                behavior: scrollBehavior
              });
              return;
            }

            if (canScrollToNewCoordinates) {
              scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
            } else {
              scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
            }

            if (scrollDelta.y) {
              scrollContainer.scrollBy({
                top: -scrollDelta.y,
                behavior: scrollBehavior
              });
            }

            break;
          }
        }

        this.handleMove(event, add(subtract(newCoordinates, this.referenceCoordinates), scrollDelta));
      }
    }
  }

  handleMove(event, coordinates) {
    const {
      onMove
    } = this.props;
    event.preventDefault();
    onMove(coordinates);
  }

  handleEnd(event) {
    const {
      onEnd
    } = this.props;
    event.preventDefault();
    this.detach();
    onEnd();
  }

  handleCancel(event) {
    const {
      onCancel
    } = this.props;
    event.preventDefault();
    this.detach();
    onCancel();
  }

  detach() {
    this.listeners.removeAll();
    this.windowListeners.removeAll();
  }

}
KeyboardSensor.activators = [{
  eventName: 'onKeyDown',
  handler: (event, _ref, _ref2) => {
    let {
      keyboardCodes = defaultKeyboardCodes,
      onActivation
    } = _ref;
    let {
      active
    } = _ref2;
    const {
      code
    } = event.nativeEvent;

    if (keyboardCodes.start.includes(code)) {
      const activator = active.activatorNode.current;

      if (activator && event.target !== activator) {
        return false;
      }

      event.preventDefault();
      onActivation == null ? void 0 : onActivation({
        event: event.nativeEvent
      });
      return true;
    }

    return false;
  }
}];

function isDistanceConstraint(constraint) {
  return Boolean(constraint && 'distance' in constraint);
}

function isDelayConstraint(constraint) {
  return Boolean(constraint && 'delay' in constraint);
}

class AbstractPointerSensor {
  constructor(props, events, listenerTarget) {
    var _getEventCoordinates;

    if (listenerTarget === void 0) {
      listenerTarget = getEventListenerTarget(props.event.target);
    }

    this.props = void 0;
    this.events = void 0;
    this.autoScrollEnabled = true;
    this.document = void 0;
    this.activated = false;
    this.initialCoordinates = void 0;
    this.timeoutId = null;
    this.listeners = void 0;
    this.documentListeners = void 0;
    this.windowListeners = void 0;
    this.props = props;
    this.events = events;
    const {
      event
    } = props;
    const {
      target
    } = event;
    this.props = props;
    this.events = events;
    this.document = getOwnerDocument(target);
    this.documentListeners = new Listeners(this.document);
    this.listeners = new Listeners(listenerTarget);
    this.windowListeners = new Listeners(getWindow(target));
    this.initialCoordinates = (_getEventCoordinates = getEventCoordinates(event)) != null ? _getEventCoordinates : defaultCoordinates;
    this.handleStart = this.handleStart.bind(this);
    this.handleMove = this.handleMove.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.removeTextSelection = this.removeTextSelection.bind(this);
    this.attach();
  }

  attach() {
    const {
      events,
      props: {
        options: {
          activationConstraint,
          bypassActivationConstraint
        }
      }
    } = this;
    this.listeners.add(events.move.name, this.handleMove, {
      passive: false
    });
    this.listeners.add(events.end.name, this.handleEnd);
    this.windowListeners.add(EventName.Resize, this.handleCancel);
    this.windowListeners.add(EventName.DragStart, preventDefault);
    this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
    this.windowListeners.add(EventName.ContextMenu, preventDefault);
    this.documentListeners.add(EventName.Keydown, this.handleKeydown);

    if (activationConstraint) {
      if (bypassActivationConstraint != null && bypassActivationConstraint({
        event: this.props.event,
        activeNode: this.props.activeNode,
        options: this.props.options
      })) {
        return this.handleStart();
      }

      if (isDelayConstraint(activationConstraint)) {
        this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
        return;
      }

      if (isDistanceConstraint(activationConstraint)) {
        return;
      }
    }

    this.handleStart();
  }

  detach() {
    this.listeners.removeAll();
    this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
    // This is necessary because we listen for `click` and `selection` events on the document

    setTimeout(this.documentListeners.removeAll, 50);

    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  handleStart() {
    const {
      initialCoordinates
    } = this;
    const {
      onStart
    } = this.props;

    if (initialCoordinates) {
      this.activated = true; // Stop propagation of click events once activation constraints are met

      this.documentListeners.add(EventName.Click, stopPropagation, {
        capture: true
      }); // Remove any text selection from the document

      this.removeTextSelection(); // Prevent further text selection while dragging

      this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection);
      onStart(initialCoordinates);
    }
  }

  handleMove(event) {
    var _getEventCoordinates2;

    const {
      activated,
      initialCoordinates,
      props
    } = this;
    const {
      onMove,
      options: {
        activationConstraint
      }
    } = props;

    if (!initialCoordinates) {
      return;
    }

    const coordinates = (_getEventCoordinates2 = getEventCoordinates(event)) != null ? _getEventCoordinates2 : defaultCoordinates;
    const delta = subtract(initialCoordinates, coordinates); // Constraint validation

    if (!activated && activationConstraint) {
      if (isDistanceConstraint(activationConstraint)) {
        if (activationConstraint.tolerance != null && hasExceededDistance(delta, activationConstraint.tolerance)) {
          return this.handleCancel();
        }

        if (hasExceededDistance(delta, activationConstraint.distance)) {
          return this.handleStart();
        }
      }

      if (isDelayConstraint(activationConstraint)) {
        if (hasExceededDistance(delta, activationConstraint.tolerance)) {
          return this.handleCancel();
        }
      }

      return;
    }

    if (event.cancelable) {
      event.preventDefault();
    }

    onMove(coordinates);
  }

  handleEnd() {
    const {
      onEnd
    } = this.props;
    this.detach();
    onEnd();
  }

  handleCancel() {
    const {
      onCancel
    } = this.props;
    this.detach();
    onCancel();
  }

  handleKeydown(event) {
    if (event.code === KeyboardCode.Esc) {
      this.handleCancel();
    }
  }

  removeTextSelection() {
    var _this$document$getSel;

    (_this$document$getSel = this.document.getSelection()) == null ? void 0 : _this$document$getSel.removeAllRanges();
  }

}

const events = {
  move: {
    name: 'pointermove'
  },
  end: {
    name: 'pointerup'
  }
};
class PointerSensor extends AbstractPointerSensor {
  constructor(props) {
    const {
      event
    } = props; // Pointer events stop firing if the target is unmounted while dragging
    // Therefore we attach listeners to the owner document instead

    const listenerTarget = getOwnerDocument(event.target);
    super(props, events, listenerTarget);
  }

}
PointerSensor.activators = [{
  eventName: 'onPointerDown',
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;

    if (!event.isPrimary || event.button !== 0) {
      return false;
    }

    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];

const events$1 = {
  move: {
    name: 'mousemove'
  },
  end: {
    name: 'mouseup'
  }
};
var MouseButton;

(function (MouseButton) {
  MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));

class MouseSensor extends AbstractPointerSensor {
  constructor(props) {
    super(props, events$1, getOwnerDocument(props.event.target));
  }

}
MouseSensor.activators = [{
  eventName: 'onMouseDown',
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;

    if (event.button === MouseButton.RightClick) {
      return false;
    }

    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];

const events$2 = {
  move: {
    name: 'touchmove'
  },
  end: {
    name: 'touchend'
  }
};
class TouchSensor extends AbstractPointerSensor {
  constructor(props) {
    super(props, events$2);
  }

  static setup() {
    // Adding a non-capture and non-passive `touchmove` listener in order
    // to force `event.preventDefault()` calls to work in dynamically added
    // touchmove event handlers. This is required for iOS Safari.
    window.addEventListener(events$2.move.name, noop, {
      capture: false,
      passive: false
    });
    return function teardown() {
      window.removeEventListener(events$2.move.name, noop);
    }; // We create a new handler because the teardown function of another sensor
    // could remove our event listener if we use a referentially equal listener.

    function noop() {}
  }

}
TouchSensor.activators = [{
  eventName: 'onTouchStart',
  handler: (_ref, _ref2) => {
    let {
      nativeEvent: event
    } = _ref;
    let {
      onActivation
    } = _ref2;
    const {
      touches
    } = event;

    if (touches.length > 1) {
      return false;
    }

    onActivation == null ? void 0 : onActivation({
      event
    });
    return true;
  }
}];

var AutoScrollActivator;

(function (AutoScrollActivator) {
  AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
  AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));

var TraversalOrder;

(function (TraversalOrder) {
  TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
  TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));

function useAutoScroller(_ref) {
  let {
    acceleration,
    activator = AutoScrollActivator.Pointer,
    canScroll,
    draggingRect,
    enabled,
    interval = 5,
    order = TraversalOrder.TreeOrder,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects,
    delta,
    threshold
  } = _ref;
  const scrollIntent = useScrollIntent({
    delta,
    disabled: !enabled
  });
  const [setAutoScrollInterval, clearAutoScrollInterval] = useInterval();
  const scrollSpeed = useRef({
    x: 0,
    y: 0
  });
  const scrollDirection = useRef({
    x: 0,
    y: 0
  });
  const rect = useMemo(() => {
    switch (activator) {
      case AutoScrollActivator.Pointer:
        return pointerCoordinates ? {
          top: pointerCoordinates.y,
          bottom: pointerCoordinates.y,
          left: pointerCoordinates.x,
          right: pointerCoordinates.x
        } : null;

      case AutoScrollActivator.DraggableRect:
        return draggingRect;
    }
  }, [activator, draggingRect, pointerCoordinates]);
  const scrollContainerRef = useRef(null);
  const autoScroll = useCallback(() => {
    const scrollContainer = scrollContainerRef.current;

    if (!scrollContainer) {
      return;
    }

    const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
    const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
    scrollContainer.scrollBy(scrollLeft, scrollTop);
  }, []);
  const sortedScrollableAncestors = useMemo(() => order === TraversalOrder.TreeOrder ? [...scrollableAncestors].reverse() : scrollableAncestors, [order, scrollableAncestors]);
  useEffect(() => {
    if (!enabled || !scrollableAncestors.length || !rect) {
      clearAutoScrollInterval();
      return;
    }

    for (const scrollContainer of sortedScrollableAncestors) {
      if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) {
        continue;
      }

      const index = scrollableAncestors.indexOf(scrollContainer);
      const scrollContainerRect = scrollableAncestorRects[index];

      if (!scrollContainerRect) {
        continue;
      }

      const {
        direction,
        speed
      } = getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);

      for (const axis of ['x', 'y']) {
        if (!scrollIntent[axis][direction[axis]]) {
          speed[axis] = 0;
          direction[axis] = 0;
        }
      }

      if (speed.x > 0 || speed.y > 0) {
        clearAutoScrollInterval();
        scrollContainerRef.current = scrollContainer;
        setAutoScrollInterval(autoScroll, interval);
        scrollSpeed.current = speed;
        scrollDirection.current = direction;
        return;
      }
    }

    scrollSpeed.current = {
      x: 0,
      y: 0
    };
    scrollDirection.current = {
      x: 0,
      y: 0
    };
    clearAutoScrollInterval();
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [acceleration, autoScroll, canScroll, clearAutoScrollInterval, enabled, interval, // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(rect), // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(scrollIntent), setAutoScrollInterval, scrollableAncestors, sortedScrollableAncestors, scrollableAncestorRects, // eslint-disable-next-line react-hooks/exhaustive-deps
  JSON.stringify(threshold)]);
}
const defaultScrollIntent = {
  x: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  },
  y: {
    [Direction.Backward]: false,
    [Direction.Forward]: false
  }
};

function useScrollIntent(_ref2) {
  let {
    delta,
    disabled
  } = _ref2;
  const previousDelta = usePrevious(delta);
  return useLazyMemo(previousIntent => {
    if (disabled || !previousDelta || !previousIntent) {
      // Reset scroll intent tracking when auto-scrolling is disabled
      return defaultScrollIntent;
    }

    const direction = {
      x: Math.sign(delta.x - previousDelta.x),
      y: Math.sign(delta.y - previousDelta.y)
    }; // Keep track of the user intent to scroll in each direction for both axis

    return {
      x: {
        [Direction.Backward]: previousIntent.x[Direction.Backward] || direction.x === -1,
        [Direction.Forward]: previousIntent.x[Direction.Forward] || direction.x === 1
      },
      y: {
        [Direction.Backward]: previousIntent.y[Direction.Backward] || direction.y === -1,
        [Direction.Forward]: previousIntent.y[Direction.Forward] || direction.y === 1
      }
    };
  }, [disabled, delta, previousDelta]);
}

function useCachedNode(draggableNodes, id) {
  const draggableNode = id !== null ? draggableNodes.get(id) : undefined;
  const node = draggableNode ? draggableNode.node.current : null;
  return useLazyMemo(cachedNode => {
    var _ref;

    if (id === null) {
      return null;
    } // In some cases, the draggable node can unmount while dragging
    // This is the case for virtualized lists. In those situations,
    // we fall back to the last known value for that node.


    return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
  }, [node, id]);
}

function useCombineActivators(sensors, getSyntheticHandler) {
  return useMemo(() => sensors.reduce((accumulator, sensor) => {
    const {
      sensor: Sensor
    } = sensor;
    const sensorActivators = Sensor.activators.map(activator => ({
      eventName: activator.eventName,
      handler: getSyntheticHandler(activator.handler, sensor)
    }));
    return [...accumulator, ...sensorActivators];
  }, []), [sensors, getSyntheticHandler]);
}

var MeasuringStrategy;

(function (MeasuringStrategy) {
  MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
  MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
  MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));

var MeasuringFrequency;

(function (MeasuringFrequency) {
  MeasuringFrequency["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));

const defaultValue = /*#__PURE__*/new Map();
function useDroppableMeasuring(containers, _ref) {
  let {
    dragging,
    dependencies,
    config
  } = _ref;
  const [queue, setQueue] = useState(null);
  const {
    frequency,
    measure,
    strategy
  } = config;
  const containersRef = useRef(containers);
  const disabled = isDisabled();
  const disabledRef = useLatestValue(disabled);
  const measureDroppableContainers = useCallback(function (ids) {
    if (ids === void 0) {
      ids = [];
    }

    if (disabledRef.current) {
      return;
    }

    setQueue(value => {
      if (value === null) {
        return ids;
      }

      return value.concat(ids.filter(id => !value.includes(id)));
    });
  }, [disabledRef]);
  const timeoutId = useRef(null);
  const droppableRects = useLazyMemo(previousValue => {
    if (disabled && !dragging) {
      return defaultValue;
    }

    if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || queue != null) {
      const map = new Map();

      for (let container of containers) {
        if (!container) {
          continue;
        }

        if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
          // This container does not need to be re-measured
          map.set(container.id, container.rect.current);
          continue;
        }

        const node = container.node.current;
        const rect = node ? new Rect(measure(node), node) : null;
        container.rect.current = rect;

        if (rect) {
          map.set(container.id, rect);
        }
      }

      return map;
    }

    return previousValue;
  }, [containers, queue, dragging, disabled, measure]);
  useEffect(() => {
    containersRef.current = containers;
  }, [containers]);
  useEffect(() => {
    if (disabled) {
      return;
    }

    measureDroppableContainers();
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [dragging, disabled]);
  useEffect(() => {
    if (queue && queue.length > 0) {
      setQueue(null);
    }
  }, //eslint-disable-next-line react-hooks/exhaustive-deps
  [JSON.stringify(queue)]);
  useEffect(() => {
    if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) {
      return;
    }

    timeoutId.current = setTimeout(() => {
      measureDroppableContainers();
      timeoutId.current = null;
    }, frequency);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [frequency, disabled, measureDroppableContainers, ...dependencies]);
  return {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled: queue != null
  };

  function isDisabled() {
    switch (strategy) {
      case MeasuringStrategy.Always:
        return false;

      case MeasuringStrategy.BeforeDragging:
        return dragging;

      default:
        return !dragging;
    }
  }
}

function useInitialValue(value, computeFn) {
  return useLazyMemo(previousValue => {
    if (!value) {
      return null;
    }

    if (previousValue) {
      return previousValue;
    }

    return typeof computeFn === 'function' ? computeFn(value) : value;
  }, [computeFn, value]);
}

function useInitialRect(node, measure) {
  return useInitialValue(node, measure);
}

/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */

function useMutationObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleMutations = useEvent(callback);
  const mutationObserver = useMemo(() => {
    if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') {
      return undefined;
    }

    const {
      MutationObserver
    } = window;
    return new MutationObserver(handleMutations);
  }, [handleMutations, disabled]);
  useEffect(() => {
    return () => mutationObserver == null ? void 0 : mutationObserver.disconnect();
  }, [mutationObserver]);
  return mutationObserver;
}

/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */

function useResizeObserver(_ref) {
  let {
    callback,
    disabled
  } = _ref;
  const handleResize = useEvent(callback);
  const resizeObserver = useMemo(() => {
    if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') {
      return undefined;
    }

    const {
      ResizeObserver
    } = window;
    return new ResizeObserver(handleResize);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [disabled]);
  useEffect(() => {
    return () => resizeObserver == null ? void 0 : resizeObserver.disconnect();
  }, [resizeObserver]);
  return resizeObserver;
}

function defaultMeasure(element) {
  return new Rect(getClientRect(element), element);
}

function useRect(element, measure, fallbackRect) {
  if (measure === void 0) {
    measure = defaultMeasure;
  }

  const [rect, measureRect] = useReducer(reducer, null);
  const mutationObserver = useMutationObserver({
    callback(records) {
      if (!element) {
        return;
      }

      for (const record of records) {
        const {
          type,
          target
        } = record;

        if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
          measureRect();
          break;
        }
      }
    }

  });
  const resizeObserver = useResizeObserver({
    callback: measureRect
  });
  useIsomorphicLayoutEffect(() => {
    measureRect();

    if (element) {
      resizeObserver == null ? void 0 : resizeObserver.observe(element);
      mutationObserver == null ? void 0 : mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    } else {
      resizeObserver == null ? void 0 : resizeObserver.disconnect();
      mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }
  }, [element]);
  return rect;

  function reducer(currentRect) {
    if (!element) {
      return null;
    }

    if (element.isConnected === false) {
      var _ref;

      // Fall back to last rect we measured if the element is
      // no longer connected to the DOM.
      return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
    }

    const newRect = measure(element);

    if (JSON.stringify(currentRect) === JSON.stringify(newRect)) {
      return currentRect;
    }

    return newRect;
  }
}

function useRectDelta(rect) {
  const initialRect = useInitialValue(rect);
  return getRectDelta(rect, initialRect);
}

const defaultValue$1 = [];
function useScrollableAncestors(node) {
  const previousNode = useRef(node);
  const ancestors = useLazyMemo(previousValue => {
    if (!node) {
      return defaultValue$1;
    }

    if (previousValue && previousValue !== defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) {
      return previousValue;
    }

    return getScrollableAncestors(node);
  }, [node]);
  useEffect(() => {
    previousNode.current = node;
  }, [node]);
  return ancestors;
}

function useScrollOffsets(elements) {
  const [scrollCoordinates, setScrollCoordinates] = useState(null);
  const prevElements = useRef(elements); // To-do: Throttle the handleScroll callback

  const handleScroll = useCallback(event => {
    const scrollingElement = getScrollableElement(event.target);

    if (!scrollingElement) {
      return;
    }

    setScrollCoordinates(scrollCoordinates => {
      if (!scrollCoordinates) {
        return null;
      }

      scrollCoordinates.set(scrollingElement, getScrollCoordinates(scrollingElement));
      return new Map(scrollCoordinates);
    });
  }, []);
  useEffect(() => {
    const previousElements = prevElements.current;

    if (elements !== previousElements) {
      cleanup(previousElements);
      const entries = elements.map(element => {
        const scrollableElement = getScrollableElement(element);

        if (scrollableElement) {
          scrollableElement.addEventListener('scroll', handleScroll, {
            passive: true
          });
          return [scrollableElement, getScrollCoordinates(scrollableElement)];
        }

        return null;
      }).filter(entry => entry != null);
      setScrollCoordinates(entries.length ? new Map(entries) : null);
      prevElements.current = elements;
    }

    return () => {
      cleanup(elements);
      cleanup(previousElements);
    };

    function cleanup(elements) {
      elements.forEach(element => {
        const scrollableElement = getScrollableElement(element);
        scrollableElement == null ? void 0 : scrollableElement.removeEventListener('scroll', handleScroll);
      });
    }
  }, [handleScroll, elements]);
  return useMemo(() => {
    if (elements.length) {
      return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates) => add(acc, coordinates), defaultCoordinates) : getScrollOffsets(elements);
    }

    return defaultCoordinates;
  }, [elements, scrollCoordinates]);
}

function useScrollOffsetsDelta(scrollOffsets, dependencies) {
  if (dependencies === void 0) {
    dependencies = [];
  }

  const initialScrollOffsets = useRef(null);
  useEffect(() => {
    initialScrollOffsets.current = null;
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  dependencies);
  useEffect(() => {
    const hasScrollOffsets = scrollOffsets !== defaultCoordinates;

    if (hasScrollOffsets && !initialScrollOffsets.current) {
      initialScrollOffsets.current = scrollOffsets;
    }

    if (!hasScrollOffsets && initialScrollOffsets.current) {
      initialScrollOffsets.current = null;
    }
  }, [scrollOffsets]);
  return initialScrollOffsets.current ? subtract(scrollOffsets, initialScrollOffsets.current) : defaultCoordinates;
}

function useSensorSetup(sensors) {
  useEffect(() => {
    if (!canUseDOM) {
      return;
    }

    const teardownFns = sensors.map(_ref => {
      let {
        sensor
      } = _ref;
      return sensor.setup == null ? void 0 : sensor.setup();
    });
    return () => {
      for (const teardown of teardownFns) {
        teardown == null ? void 0 : teardown();
      }
    };
  }, // TO-DO: Sensors length could theoretically change which would not be a valid dependency
  // eslint-disable-next-line react-hooks/exhaustive-deps
  sensors.map(_ref2 => {
    let {
      sensor
    } = _ref2;
    return sensor;
  }));
}

function useSyntheticListeners(listeners, id) {
  return useMemo(() => {
    return listeners.reduce((acc, _ref) => {
      let {
        eventName,
        handler
      } = _ref;

      acc[eventName] = event => {
        handler(event, id);
      };

      return acc;
    }, {});
  }, [listeners, id]);
}

function useWindowRect(element) {
  return useMemo(() => element ? getWindowClientRect(element) : null, [element]);
}

const defaultValue$2 = [];
function useRects(elements, measure) {
  if (measure === void 0) {
    measure = getClientRect;
  }

  const [firstElement] = elements;
  const windowRect = useWindowRect(firstElement ? getWindow(firstElement) : null);
  const [rects, measureRects] = useReducer(reducer, defaultValue$2);
  const resizeObserver = useResizeObserver({
    callback: measureRects
  });

  if (elements.length > 0 && rects === defaultValue$2) {
    measureRects();
  }

  useIsomorphicLayoutEffect(() => {
    if (elements.length) {
      elements.forEach(element => resizeObserver == null ? void 0 : resizeObserver.observe(element));
    } else {
      resizeObserver == null ? void 0 : resizeObserver.disconnect();
      measureRects();
    }
  }, [elements]);
  return rects;

  function reducer() {
    if (!elements.length) {
      return defaultValue$2;
    }

    return elements.map(element => isDocumentScrollingElement(element) ? windowRect : new Rect(measure(element), element));
  }
}

function getMeasurableNode(node) {
  if (!node) {
    return null;
  }

  if (node.children.length > 1) {
    return node;
  }

  const firstChild = node.children[0];
  return isHTMLElement(firstChild) ? firstChild : node;
}

function useDragOverlayMeasuring(_ref) {
  let {
    measure
  } = _ref;
  const [rect, setRect] = useState(null);
  const handleResize = useCallback(entries => {
    for (const {
      target
    } of entries) {
      if (isHTMLElement(target)) {
        setRect(rect => {
          const newRect = measure(target);
          return rect ? { ...rect,
            width: newRect.width,
            height: newRect.height
          } : newRect;
        });
        break;
      }
    }
  }, [measure]);
  const resizeObserver = useResizeObserver({
    callback: handleResize
  });
  const handleNodeChange = useCallback(element => {
    const node = getMeasurableNode(element);
    resizeObserver == null ? void 0 : resizeObserver.disconnect();

    if (node) {
      resizeObserver == null ? void 0 : resizeObserver.observe(node);
    }

    setRect(node ? measure(node) : null);
  }, [measure, resizeObserver]);
  const [nodeRef, setRef] = useNodeRef(handleNodeChange);
  return useMemo(() => ({
    nodeRef,
    rect,
    setRef
  }), [rect, nodeRef, setRef]);
}

const defaultSensors = [{
  sensor: PointerSensor,
  options: {}
}, {
  sensor: KeyboardSensor,
  options: {}
}];
const defaultData = {
  current: {}
};
const defaultMeasuringConfiguration = {
  draggable: {
    measure: getTransformAgnosticClientRect
  },
  droppable: {
    measure: getTransformAgnosticClientRect,
    strategy: MeasuringStrategy.WhileDragging,
    frequency: MeasuringFrequency.Optimized
  },
  dragOverlay: {
    measure: getClientRect
  }
};

class DroppableContainersMap extends Map {
  get(id) {
    var _super$get;

    return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
  }

  toArray() {
    return Array.from(this.values());
  }

  getEnabled() {
    return this.toArray().filter(_ref => {
      let {
        disabled
      } = _ref;
      return !disabled;
    });
  }

  getNodeFor(id) {
    var _this$get$node$curren, _this$get;

    return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
  }

}

const defaultPublicContext = {
  activatorEvent: null,
  active: null,
  activeNode: null,
  activeNodeRect: null,
  collisions: null,
  containerNodeRect: null,
  draggableNodes: /*#__PURE__*/new Map(),
  droppableRects: /*#__PURE__*/new Map(),
  droppableContainers: /*#__PURE__*/new DroppableContainersMap(),
  over: null,
  dragOverlay: {
    nodeRef: {
      current: null
    },
    rect: null,
    setRef: noop
  },
  scrollableAncestors: [],
  scrollableAncestorRects: [],
  measuringConfiguration: defaultMeasuringConfiguration,
  measureDroppableContainers: noop,
  windowRect: null,
  measuringScheduled: false
};
const defaultInternalContext = {
  activatorEvent: null,
  activators: [],
  active: null,
  activeNodeRect: null,
  ariaDescribedById: {
    draggable: ''
  },
  dispatch: noop,
  draggableNodes: /*#__PURE__*/new Map(),
  over: null,
  measureDroppableContainers: noop
};
const InternalContext = /*#__PURE__*/createContext(defaultInternalContext);
const PublicContext = /*#__PURE__*/createContext(defaultPublicContext);

function getInitialState() {
  return {
    draggable: {
      active: null,
      initialCoordinates: {
        x: 0,
        y: 0
      },
      nodes: new Map(),
      translate: {
        x: 0,
        y: 0
      }
    },
    droppable: {
      containers: new DroppableContainersMap()
    }
  };
}
function reducer(state, action) {
  switch (action.type) {
    case Action.DragStart:
      return { ...state,
        draggable: { ...state.draggable,
          initialCoordinates: action.initialCoordinates,
          active: action.active
        }
      };

    case Action.DragMove:
      if (!state.draggable.active) {
        return state;
      }

      return { ...state,
        draggable: { ...state.draggable,
          translate: {
            x: action.coordinates.x - state.draggable.initialCoordinates.x,
            y: action.coordinates.y - state.draggable.initialCoordinates.y
          }
        }
      };

    case Action.DragEnd:
    case Action.DragCancel:
      return { ...state,
        draggable: { ...state.draggable,
          active: null,
          initialCoordinates: {
            x: 0,
            y: 0
          },
          translate: {
            x: 0,
            y: 0
          }
        }
      };

    case Action.RegisterDroppable:
      {
        const {
          element
        } = action;
        const {
          id
        } = element;
        const containers = new DroppableContainersMap(state.droppable.containers);
        containers.set(id, element);
        return { ...state,
          droppable: { ...state.droppable,
            containers
          }
        };
      }

    case Action.SetDroppableDisabled:
      {
        const {
          id,
          key,
          disabled
        } = action;
        const element = state.droppable.containers.get(id);

        if (!element || key !== element.key) {
          return state;
        }

        const containers = new DroppableContainersMap(state.droppable.containers);
        containers.set(id, { ...element,
          disabled
        });
        return { ...state,
          droppable: { ...state.droppable,
            containers
          }
        };
      }

    case Action.UnregisterDroppable:
      {
        const {
          id,
          key
        } = action;
        const element = state.droppable.containers.get(id);

        if (!element || key !== element.key) {
          return state;
        }

        const containers = new DroppableContainersMap(state.droppable.containers);
        containers.delete(id);
        return { ...state,
          droppable: { ...state.droppable,
            containers
          }
        };
      }

    default:
      {
        return state;
      }
  }
}

function RestoreFocus(_ref) {
  let {
    disabled
  } = _ref;
  const {
    active,
    activatorEvent,
    draggableNodes
  } = useContext(InternalContext);
  const previousActivatorEvent = usePrevious(activatorEvent);
  const previousActiveId = usePrevious(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node

  useEffect(() => {
    if (disabled) {
      return;
    }

    if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
      if (!isKeyboardEvent(previousActivatorEvent)) {
        return;
      }

      if (document.activeElement === previousActivatorEvent.target) {
        // No need to restore focus
        return;
      }

      const draggableNode = draggableNodes.get(previousActiveId);

      if (!draggableNode) {
        return;
      }

      const {
        activatorNode,
        node
      } = draggableNode;

      if (!activatorNode.current && !node.current) {
        return;
      }

      requestAnimationFrame(() => {
        for (const element of [activatorNode.current, node.current]) {
          if (!element) {
            continue;
          }

          const focusableNode = findFirstFocusableNode(element);

          if (focusableNode) {
            focusableNode.focus();
            break;
          }
        }
      });
    }
  }, [activatorEvent, disabled, draggableNodes, previousActiveId, previousActivatorEvent]);
  return null;
}

function applyModifiers(modifiers, _ref) {
  let {
    transform,
    ...args
  } = _ref;
  return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier) => {
    return modifier({
      transform: accumulator,
      ...args
    });
  }, transform) : transform;
}

function useMeasuringConfiguration(config) {
  return useMemo(() => ({
    draggable: { ...defaultMeasuringConfiguration.draggable,
      ...(config == null ? void 0 : config.draggable)
    },
    droppable: { ...defaultMeasuringConfiguration.droppable,
      ...(config == null ? void 0 : config.droppable)
    },
    dragOverlay: { ...defaultMeasuringConfiguration.dragOverlay,
      ...(config == null ? void 0 : config.dragOverlay)
    }
  }), // eslint-disable-next-line react-hooks/exhaustive-deps
  [config == null ? void 0 : config.draggable, config == null ? void 0 : config.droppable, config == null ? void 0 : config.dragOverlay]);
}

function useLayoutShiftScrollCompensation(_ref) {
  let {
    activeNode,
    measure,
    initialRect,
    config = true
  } = _ref;
  const initialized = useRef(false);
  const {
    x,
    y
  } = typeof config === 'boolean' ? {
    x: config,
    y: config
  } : config;
  useIsomorphicLayoutEffect(() => {
    const disabled = !x && !y;

    if (disabled || !activeNode) {
      initialized.current = false;
      return;
    }

    if (initialized.current || !initialRect) {
      // Return early if layout shift scroll compensation was already attempted
      // or if there is no initialRect to compare to.
      return;
    } // Get the most up to date node ref for the active draggable


    const node = activeNode == null ? void 0 : activeNode.node.current;

    if (!node || node.isConnected === false) {
      // Return early if there is no attached node ref or if the node is
      // disconnected from the document.
      return;
    }

    const rect = measure(node);
    const rectDelta = getRectDelta(rect, initialRect);

    if (!x) {
      rectDelta.x = 0;
    }

    if (!y) {
      rectDelta.y = 0;
    } // Only perform layout shift scroll compensation once


    initialized.current = true;

    if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
      const firstScrollableAncestor = getFirstScrollableAncestor(node);

      if (firstScrollableAncestor) {
        firstScrollableAncestor.scrollBy({
          top: rectDelta.y,
          left: rectDelta.x
        });
      }
    }
  }, [activeNode, x, y, initialRect, measure]);
}

const ActiveDraggableContext = /*#__PURE__*/createContext({ ...defaultCoordinates,
  scaleX: 1,
  scaleY: 1
});
var Status;

(function (Status) {
  Status[Status["Uninitialized"] = 0] = "Uninitialized";
  Status[Status["Initializing"] = 1] = "Initializing";
  Status[Status["Initialized"] = 2] = "Initialized";
})(Status || (Status = {}));

const DndContext = /*#__PURE__*/memo(function DndContext(_ref) {
  var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;

  let {
    id,
    accessibility,
    autoScroll = true,
    children,
    sensors = defaultSensors,
    collisionDetection = rectIntersection,
    measuring,
    modifiers,
    ...props
  } = _ref;
  const store = useReducer(reducer, undefined, getInitialState);
  const [state, dispatch] = store;
  const [dispatchMonitorEvent, registerMonitorListener] = useDndMonitorProvider();
  const [status, setStatus] = useState(Status.Uninitialized);
  const isInitialized = status === Status.Initialized;
  const {
    draggable: {
      active: activeId,
      nodes: draggableNodes,
      translate
    },
    droppable: {
      containers: droppableContainers
    }
  } = state;
  const node = activeId ? draggableNodes.get(activeId) : null;
  const activeRects = useRef({
    initial: null,
    translated: null
  });
  const active = useMemo(() => {
    var _node$data;

    return activeId != null ? {
      id: activeId,
      // It's possible for the active node to unmount while dragging
      data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : defaultData,
      rect: activeRects
    } : null;
  }, [activeId, node]);
  const activeRef = useRef(null);
  const [activeSensor, setActiveSensor] = useState(null);
  const [activatorEvent, setActivatorEvent] = useState(null);
  const latestProps = useLatestValue(props, Object.values(props));
  const draggableDescribedById = useUniqueId("DndDescribedBy", id);
  const enabledDroppableContainers = useMemo(() => droppableContainers.getEnabled(), [droppableContainers]);
  const measuringConfiguration = useMeasuringConfiguration(measuring);
  const {
    droppableRects,
    measureDroppableContainers,
    measuringScheduled
  } = useDroppableMeasuring(enabledDroppableContainers, {
    dragging: isInitialized,
    dependencies: [translate.x, translate.y],
    config: measuringConfiguration.droppable
  });
  const activeNode = useCachedNode(draggableNodes, activeId);
  const activationCoordinates = useMemo(() => activatorEvent ? getEventCoordinates(activatorEvent) : null, [activatorEvent]);
  const autoScrollOptions = getAutoScrollerOptions();
  const initialActiveNodeRect = useInitialRect(activeNode, measuringConfiguration.draggable.measure);
  useLayoutShiftScrollCompensation({
    activeNode: activeId ? draggableNodes.get(activeId) : null,
    config: autoScrollOptions.layoutShiftCompensation,
    initialRect: initialActiveNodeRect,
    measure: measuringConfiguration.draggable.measure
  });
  const activeNodeRect = useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
  const containerNodeRect = useRect(activeNode ? activeNode.parentElement : null);
  const sensorContext = useRef({
    activatorEvent: null,
    active: null,
    activeNode,
    collisionRect: null,
    collisions: null,
    droppableRects,
    draggableNodes,
    draggingNode: null,
    draggingNodeRect: null,
    droppableContainers,
    over: null,
    scrollableAncestors: [],
    scrollAdjustedTranslate: null
  });
  const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
  const dragOverlay = useDragOverlayMeasuring({
    measure: measuringConfiguration.dragOverlay.measure
  }); // Use the rect of the drag overlay if it is mounted

  const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
  const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
  const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
  // is only relevant when there is no drag overlay

  const nodeRectDelta = useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node

  const windowRect = useWindowRect(draggingNode ? getWindow(draggingNode) : null); // Get scrollable ancestors of the dragging node

  const scrollableAncestors = useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
  const scrollableAncestorRects = useRects(scrollableAncestors); // Apply modifiers

  const modifiedTranslate = applyModifiers(modifiers, {
    transform: {
      x: translate.x - nodeRectDelta.x,
      y: translate.y - nodeRectDelta.y,
      scaleX: 1,
      scaleY: 1
    },
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggingNodeRect,
    over: sensorContext.current.over,
    overlayNodeRect: dragOverlay.rect,
    scrollableAncestors,
    scrollableAncestorRects,
    windowRect
  });
  const pointerCoordinates = activationCoordinates ? add(activationCoordinates, translate) : null;
  const scrollOffsets = useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated

  const scrollAdjustment = useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured

  const activeNodeScrollDelta = useScrollOffsetsDelta(scrollOffsets, [activeNodeRect]);
  const scrollAdjustedTranslate = add(modifiedTranslate, scrollAdjustment);
  const collisionRect = draggingNodeRect ? getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
  const collisions = active && collisionRect ? collisionDetection({
    active,
    collisionRect,
    droppableRects,
    droppableContainers: enabledDroppableContainers,
    pointerCoordinates
  }) : null;
  const overId = getFirstCollision(collisions, 'id');
  const [over, setOver] = useState(null); // When there is no drag overlay used, we need to account for the
  // window scroll delta

  const appliedTranslate = usesDragOverlay ? modifiedTranslate : add(modifiedTranslate, activeNodeScrollDelta);
  const transform = adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
  const instantiateSensor = useCallback((event, _ref2) => {
    let {
      sensor: Sensor,
      options
    } = _ref2;

    if (activeRef.current == null) {
      return;
    }

    const activeNode = draggableNodes.get(activeRef.current);

    if (!activeNode) {
      return;
    }

    const activatorEvent = event.nativeEvent;
    const sensorInstance = new Sensor({
      active: activeRef.current,
      activeNode,
      event: activatorEvent,
      options,
      // Sensors need to be instantiated with refs for arguments that change over time
      // otherwise they are frozen in time with the stale arguments
      context: sensorContext,

      onStart(initialCoordinates) {
        const id = activeRef.current;

        if (id == null) {
          return;
        }

        const draggableNode = draggableNodes.get(id);

        if (!draggableNode) {
          return;
        }

        const {
          onDragStart
        } = latestProps.current;
        const event = {
          active: {
            id,
            data: draggableNode.data,
            rect: activeRects
          }
        };
        unstable_batchedUpdates(() => {
          onDragStart == null ? void 0 : onDragStart(event);
          setStatus(Status.Initializing);
          dispatch({
            type: Action.DragStart,
            initialCoordinates,
            active: id
          });
          dispatchMonitorEvent({
            type: 'onDragStart',
            event
          });
        });
      },

      onMove(coordinates) {
        dispatch({
          type: Action.DragMove,
          coordinates
        });
      },

      onEnd: createHandler(Action.DragEnd),
      onCancel: createHandler(Action.DragCancel)
    });
    unstable_batchedUpdates(() => {
      setActiveSensor(sensorInstance);
      setActivatorEvent(event.nativeEvent);
    });

    function createHandler(type) {
      return async function handler() {
        const {
          active,
          collisions,
          over,
          scrollAdjustedTranslate
        } = sensorContext.current;
        let event = null;

        if (active && scrollAdjustedTranslate) {
          const {
            cancelDrop
          } = latestProps.current;
          event = {
            activatorEvent,
            active: active,
            collisions,
            delta: scrollAdjustedTranslate,
            over
          };

          if (type === Action.DragEnd && typeof cancelDrop === 'function') {
            const shouldCancel = await Promise.resolve(cancelDrop(event));

            if (shouldCancel) {
              type = Action.DragCancel;
            }
          }
        }

        activeRef.current = null;
        unstable_batchedUpdates(() => {
          dispatch({
            type
          });
          setStatus(Status.Uninitialized);
          setOver(null);
          setActiveSensor(null);
          setActivatorEvent(null);
          const eventName = type === Action.DragEnd ? 'onDragEnd' : 'onDragCancel';

          if (event) {
            const handler = latestProps.current[eventName];
            handler == null ? void 0 : handler(event);
            dispatchMonitorEvent({
              type: eventName,
              event
            });
          }
        });
      };
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [draggableNodes]);
  const bindActivatorToSensorInstantiator = useCallback((handler, sensor) => {
    return (event, active) => {
      const nativeEvent = event.nativeEvent;
      const activeDraggableNode = draggableNodes.get(active);

      if ( // Another sensor is already instantiating
      activeRef.current !== null || // No active draggable
      !activeDraggableNode || // Event has already been captured
      nativeEvent.dndKit || nativeEvent.defaultPrevented) {
        return;
      }

      const activationContext = {
        active: activeDraggableNode
      };
      const shouldActivate = handler(event, sensor.options, activationContext);

      if (shouldActivate === true) {
        nativeEvent.dndKit = {
          capturedBy: sensor.sensor
        };
        activeRef.current = active;
        instantiateSensor(event, sensor);
      }
    };
  }, [draggableNodes, instantiateSensor]);
  const activators = useCombineActivators(sensors, bindActivatorToSensorInstantiator);
  useSensorSetup(sensors);
  useIsomorphicLayoutEffect(() => {
    if (activeNodeRect && status === Status.Initializing) {
      setStatus(Status.Initialized);
    }
  }, [activeNodeRect, status]);
  useEffect(() => {
    const {
      onDragMove
    } = latestProps.current;
    const {
      active,
      activatorEvent,
      collisions,
      over
    } = sensorContext.current;

    if (!active || !activatorEvent) {
      return;
    }

    const event = {
      active,
      activatorEvent,
      collisions,
      delta: {
        x: scrollAdjustedTranslate.x,
        y: scrollAdjustedTranslate.y
      },
      over
    };
    unstable_batchedUpdates(() => {
      onDragMove == null ? void 0 : onDragMove(event);
      dispatchMonitorEvent({
        type: 'onDragMove',
        event
      });
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [scrollAdjustedTranslate.x, scrollAdjustedTranslate.y]);
  useEffect(() => {
    const {
      active,
      activatorEvent,
      collisions,
      droppableContainers,
      scrollAdjustedTranslate
    } = sensorContext.current;

    if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) {
      return;
    }

    const {
      onDragOver
    } = latestProps.current;
    const overContainer = droppableContainers.get(overId);
    const over = overContainer && overContainer.rect.current ? {
      id: overContainer.id,
      rect: overContainer.rect.current,
      data: overContainer.data,
      disabled: overContainer.disabled
    } : null;
    const event = {
      active,
      activatorEvent,
      collisions,
      delta: {
        x: scrollAdjustedTranslate.x,
        y: scrollAdjustedTranslate.y
      },
      over
    };
    unstable_batchedUpdates(() => {
      setOver(over);
      onDragOver == null ? void 0 : onDragOver(event);
      dispatchMonitorEvent({
        type: 'onDragOver',
        event
      });
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [overId]);
  useIsomorphicLayoutEffect(() => {
    sensorContext.current = {
      activatorEvent,
      active,
      activeNode,
      collisionRect,
      collisions,
      droppableRects,
      draggableNodes,
      draggingNode,
      draggingNodeRect,
      droppableContainers,
      over,
      scrollableAncestors,
      scrollAdjustedTranslate
    };
    activeRects.current = {
      initial: draggingNodeRect,
      translated: collisionRect
    };
  }, [active, activeNode, collisions, collisionRect, draggableNodes, draggingNode, draggingNodeRect, droppableRects, droppableContainers, over, scrollableAncestors, scrollAdjustedTranslate]);
  useAutoScroller({ ...autoScrollOptions,
    delta: translate,
    draggingRect: collisionRect,
    pointerCoordinates,
    scrollableAncestors,
    scrollableAncestorRects
  });
  const publicContext = useMemo(() => {
    const context = {
      active,
      activeNode,
      activeNodeRect,
      activatorEvent,
      collisions,
      containerNodeRect,
      dragOverlay,
      draggableNodes,
      droppableContainers,
      droppableRects,
      over,
      measureDroppableContainers,
      scrollableAncestors,
      scrollableAncestorRects,
      measuringConfiguration,
      measuringScheduled,
      windowRect
    };
    return context;
  }, [active, activeNode, activeNodeRect, activatorEvent, collisions, containerNodeRect, dragOverlay, draggableNodes, droppableContainers, droppableRects, over, measureDroppableContainers, scrollableAncestors, scrollableAncestorRects, measuringConfiguration, measuringScheduled, windowRect]);
  const internalContext = useMemo(() => {
    const context = {
      activatorEvent,
      activators,
      active,
      activeNodeRect,
      ariaDescribedById: {
        draggable: draggableDescribedById
      },
      dispatch,
      draggableNodes,
      over,
      measureDroppableContainers
    };
    return context;
  }, [activatorEvent, activators, active, activeNodeRect, dispatch, draggableDescribedById, draggableNodes, over, measureDroppableContainers]);
  return React.createElement(DndMonitorContext.Provider, {
    value: registerMonitorListener
  }, React.createElement(InternalContext.Provider, {
    value: internalContext
  }, React.createElement(PublicContext.Provider, {
    value: publicContext
  }, React.createElement(ActiveDraggableContext.Provider, {
    value: transform
  }, children)), React.createElement(RestoreFocus, {
    disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
  })), React.createElement(Accessibility, { ...accessibility,
    hiddenTextDescribedById: draggableDescribedById
  }));

  function getAutoScrollerOptions() {
    const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
    const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
    const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;

    if (typeof autoScroll === 'object') {
      return { ...autoScroll,
        enabled
      };
    }

    return {
      enabled
    };
  }
});

const NullContext = /*#__PURE__*/createContext(null);
const defaultRole = 'button';
const ID_PREFIX$1 = 'Droppable';
function useDraggable(_ref) {
  let {
    id,
    data,
    disabled = false,
    attributes
  } = _ref;
  const key = useUniqueId(ID_PREFIX$1);
  const {
    activators,
    activatorEvent,
    active,
    activeNodeRect,
    ariaDescribedById,
    draggableNodes,
    over
  } = useContext(InternalContext);
  const {
    role = defaultRole,
    roleDescription = 'draggable',
    tabIndex = 0
  } = attributes != null ? attributes : {};
  const isDragging = (active == null ? void 0 : active.id) === id;
  const transform = useContext(isDragging ? ActiveDraggableContext : NullContext);
  const [node, setNodeRef] = useNodeRef();
  const [activatorNode, setActivatorNodeRef] = useNodeRef();
  const listeners = useSyntheticListeners(activators, id);
  const dataRef = useLatestValue(data);
  useIsomorphicLayoutEffect(() => {
    draggableNodes.set(id, {
      id,
      key,
      node,
      activatorNode,
      data: dataRef
    });
    return () => {
      const node = draggableNodes.get(id);

      if (node && node.key === key) {
        draggableNodes.delete(id);
      }
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [draggableNodes, id]);
  const memoizedAttributes = useMemo(() => ({
    role,
    tabIndex,
    'aria-disabled': disabled,
    'aria-pressed': isDragging && role === defaultRole ? true : undefined,
    'aria-roledescription': roleDescription,
    'aria-describedby': ariaDescribedById.draggable
  }), [disabled, role, tabIndex, isDragging, roleDescription, ariaDescribedById.draggable]);
  return {
    active,
    activatorEvent,
    activeNodeRect,
    attributes: memoizedAttributes,
    isDragging,
    listeners: disabled ? undefined : listeners,
    node,
    over,
    setNodeRef,
    setActivatorNodeRef,
    transform
  };
}

function useDndContext() {
  return useContext(PublicContext);
}

const ID_PREFIX$1$1 = 'Droppable';
const defaultResizeObserverConfig = {
  timeout: 25
};
function useDroppable(_ref) {
  let {
    data,
    disabled = false,
    id,
    resizeObserverConfig
  } = _ref;
  const key = useUniqueId(ID_PREFIX$1$1);
  const {
    active,
    dispatch,
    over,
    measureDroppableContainers
  } = useContext(InternalContext);
  const previous = useRef({
    disabled
  });
  const resizeObserverConnected = useRef(false);
  const rect = useRef(null);
  const callbackId = useRef(null);
  const {
    disabled: resizeObserverDisabled,
    updateMeasurementsFor,
    timeout: resizeObserverTimeout
  } = { ...defaultResizeObserverConfig,
    ...resizeObserverConfig
  };
  const ids = useLatestValue(updateMeasurementsFor != null ? updateMeasurementsFor : id);
  const handleResize = useCallback(() => {
    if (!resizeObserverConnected.current) {
      // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
      // assuming the element is rendered and displayed.
      resizeObserverConnected.current = true;
      return;
    }

    if (callbackId.current != null) {
      clearTimeout(callbackId.current);
    }

    callbackId.current = setTimeout(() => {
      measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [ids.current]);
      callbackId.current = null;
    }, resizeObserverTimeout);
  }, //eslint-disable-next-line react-hooks/exhaustive-deps
  [resizeObserverTimeout]);
  const resizeObserver = useResizeObserver({
    callback: handleResize,
    disabled: resizeObserverDisabled || !active
  });
  const handleNodeChange = useCallback((newElement, previousElement) => {
    if (!resizeObserver) {
      return;
    }

    if (previousElement) {
      resizeObserver.unobserve(previousElement);
      resizeObserverConnected.current = false;
    }

    if (newElement) {
      resizeObserver.observe(newElement);
    }
  }, [resizeObserver]);
  const [nodeRef, setNodeRef] = useNodeRef(handleNodeChange);
  const dataRef = useLatestValue(data);
  useEffect(() => {
    if (!resizeObserver || !nodeRef.current) {
      return;
    }

    resizeObserver.disconnect();
    resizeObserverConnected.current = false;
    resizeObserver.observe(nodeRef.current);
  }, [nodeRef, resizeObserver]);
  useIsomorphicLayoutEffect(() => {
    dispatch({
      type: Action.RegisterDroppable,
      element: {
        id,
        key,
        disabled,
        node: nodeRef,
        rect,
        data: dataRef
      }
    });
    return () => dispatch({
      type: Action.UnregisterDroppable,
      key,
      id
    });
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [id]);
  useEffect(() => {
    if (disabled !== previous.current.disabled) {
      dispatch({
        type: Action.SetDroppableDisabled,
        id,
        key,
        disabled
      });
      previous.current.disabled = disabled;
    }
  }, [id, key, disabled, dispatch]);
  return {
    active,
    rect,
    isOver: (over == null ? void 0 : over.id) === id,
    node: nodeRef,
    over,
    setNodeRef
  };
}

function AnimationManager(_ref) {
  let {
    animation,
    children
  } = _ref;
  const [clonedChildren, setClonedChildren] = useState(null);
  const [element, setElement] = useState(null);
  const previousChildren = usePrevious(children);

  if (!children && !clonedChildren && previousChildren) {
    setClonedChildren(previousChildren);
  }

  useIsomorphicLayoutEffect(() => {
    if (!element) {
      return;
    }

    const key = clonedChildren == null ? void 0 : clonedChildren.key;
    const id = clonedChildren == null ? void 0 : clonedChildren.props.id;

    if (key == null || id == null) {
      setClonedChildren(null);
      return;
    }

    Promise.resolve(animation(id, element)).then(() => {
      setClonedChildren(null);
    });
  }, [animation, clonedChildren, element]);
  return React.createElement(React.Fragment, null, children, clonedChildren ? cloneElement(clonedChildren, {
    ref: setElement
  }) : null);
}

const defaultTransform = {
  x: 0,
  y: 0,
  scaleX: 1,
  scaleY: 1
};
function NullifiedContextProvider(_ref) {
  let {
    children
  } = _ref;
  return React.createElement(InternalContext.Provider, {
    value: defaultInternalContext
  }, React.createElement(ActiveDraggableContext.Provider, {
    value: defaultTransform
  }, children));
}

const baseStyles = {
  position: 'fixed',
  touchAction: 'none'
};

const defaultTransition$1 = activatorEvent => {
  const isKeyboardActivator = isKeyboardEvent(activatorEvent);
  return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};

const PositionedOverlay = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    as,
    activatorEvent,
    adjustScale,
    children,
    className,
    rect,
    style,
    transform,
    transition = defaultTransition$1
  } = _ref;

  if (!rect) {
    return null;
  }

  const scaleAdjustedTransform = adjustScale ? transform : { ...transform,
    scaleX: 1,
    scaleY: 1
  };
  const styles = { ...baseStyles,
    width: rect.width,
    height: rect.height,
    top: rect.top,
    left: rect.left,
    transform: CSS.Transform.toString(scaleAdjustedTransform),
    transformOrigin: adjustScale && activatorEvent ? getRelativeTransformOrigin(activatorEvent, rect) : undefined,
    transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
    ...style
  };
  return React.createElement(as, {
    className,
    style: styles,
    ref
  }, children);
});

const defaultDropAnimationSideEffects = options => _ref => {
  let {
    active,
    dragOverlay
  } = _ref;
  const originalStyles = {};
  const {
    styles,
    className
  } = options;

  if (styles != null && styles.active) {
    for (const [key, value] of Object.entries(styles.active)) {
      if (value === undefined) {
        continue;
      }

      originalStyles[key] = active.node.style.getPropertyValue(key);
      active.node.style.setProperty(key, value);
    }
  }

  if (styles != null && styles.dragOverlay) {
    for (const [key, value] of Object.entries(styles.dragOverlay)) {
      if (value === undefined) {
        continue;
      }

      dragOverlay.node.style.setProperty(key, value);
    }
  }

  if (className != null && className.active) {
    active.node.classList.add(className.active);
  }

  if (className != null && className.dragOverlay) {
    dragOverlay.node.classList.add(className.dragOverlay);
  }

  return function cleanup() {
    for (const [key, value] of Object.entries(originalStyles)) {
      active.node.style.setProperty(key, value);
    }

    if (className != null && className.active) {
      active.node.classList.remove(className.active);
    }
  };
};

const defaultKeyframeResolver = _ref2 => {
  let {
    transform: {
      initial,
      final
    }
  } = _ref2;
  return [{
    transform: CSS.Transform.toString(initial)
  }, {
    transform: CSS.Transform.toString(final)
  }];
};

const defaultDropAnimationConfiguration = {
  duration: 250,
  easing: 'ease',
  keyframes: defaultKeyframeResolver,
  sideEffects: /*#__PURE__*/defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0'
      }
    }
  })
};
function useDropAnimation(_ref3) {
  let {
    config,
    draggableNodes,
    droppableContainers,
    measuringConfiguration
  } = _ref3;
  return useEvent((id, node) => {
    if (config === null) {
      return;
    }

    const activeDraggable = draggableNodes.get(id);

    if (!activeDraggable) {
      return;
    }

    const activeNode = activeDraggable.node.current;

    if (!activeNode) {
      return;
    }

    const measurableNode = getMeasurableNode(node);

    if (!measurableNode) {
      return;
    }

    const {
      transform
    } = getWindow(node).getComputedStyle(node);
    const parsedTransform = parseTransform(transform);

    if (!parsedTransform) {
      return;
    }

    const animation = typeof config === 'function' ? config : createDefaultDropAnimation(config);
    scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
    return animation({
      active: {
        id,
        data: activeDraggable.data,
        node: activeNode,
        rect: measuringConfiguration.draggable.measure(activeNode)
      },
      draggableNodes,
      dragOverlay: {
        node,
        rect: measuringConfiguration.dragOverlay.measure(measurableNode)
      },
      droppableContainers,
      measuringConfiguration,
      transform: parsedTransform
    });
  });
}

function createDefaultDropAnimation(options) {
  const {
    duration,
    easing,
    sideEffects,
    keyframes
  } = { ...defaultDropAnimationConfiguration,
    ...options
  };
  return _ref4 => {
    let {
      active,
      dragOverlay,
      transform,
      ...rest
    } = _ref4;

    if (!duration) {
      // Do not animate if animation duration is zero.
      return;
    }

    const delta = {
      x: dragOverlay.rect.left - active.rect.left,
      y: dragOverlay.rect.top - active.rect.top
    };
    const scale = {
      scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
      scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
    };
    const finalTransform = {
      x: transform.x - delta.x,
      y: transform.y - delta.y,
      ...scale
    };
    const animationKeyframes = keyframes({ ...rest,
      active,
      dragOverlay,
      transform: {
        initial: transform,
        final: finalTransform
      }
    });
    const [firstKeyframe] = animationKeyframes;
    const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];

    if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) {
      // The start and end keyframes are the same, infer that there is no animation needed.
      return;
    }

    const cleanup = sideEffects == null ? void 0 : sideEffects({
      active,
      dragOverlay,
      ...rest
    });
    const animation = dragOverlay.node.animate(animationKeyframes, {
      duration,
      easing,
      fill: 'forwards'
    });
    return new Promise(resolve => {
      animation.onfinish = () => {
        cleanup == null ? void 0 : cleanup();
        resolve();
      };
    });
  };
}

let key = 0;
function useKey(id) {
  return useMemo(() => {
    if (id == null) {
      return;
    }

    key++;
    return key;
  }, [id]);
}

const DragOverlay = /*#__PURE__*/React.memo(_ref => {
  let {
    adjustScale = false,
    children,
    dropAnimation: dropAnimationConfig,
    style,
    transition,
    modifiers,
    wrapperElement = 'div',
    className,
    zIndex = 999
  } = _ref;
  const {
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggableNodes,
    droppableContainers,
    dragOverlay,
    over,
    measuringConfiguration,
    scrollableAncestors,
    scrollableAncestorRects,
    windowRect
  } = useDndContext();
  const transform = useContext(ActiveDraggableContext);
  const key = useKey(active == null ? void 0 : active.id);
  const modifiedTransform = applyModifiers(modifiers, {
    activatorEvent,
    active,
    activeNodeRect,
    containerNodeRect,
    draggingNodeRect: dragOverlay.rect,
    over,
    overlayNodeRect: dragOverlay.rect,
    scrollableAncestors,
    scrollableAncestorRects,
    transform,
    windowRect
  });
  const initialRect = useInitialValue(activeNodeRect);
  const dropAnimation = useDropAnimation({
    config: dropAnimationConfig,
    draggableNodes,
    droppableContainers,
    measuringConfiguration
  }); // We need to wait for the active node to be measured before connecting the drag overlay ref
  // otherwise collisions can be computed against a mispositioned drag overlay

  const ref = initialRect ? dragOverlay.setRef : undefined;
  return React.createElement(NullifiedContextProvider, null, React.createElement(AnimationManager, {
    animation: dropAnimation
  }, active && key ? React.createElement(PositionedOverlay, {
    key: key,
    id: active.id,
    ref: ref,
    as: wrapperElement,
    activatorEvent: activatorEvent,
    adjustScale: adjustScale,
    className: className,
    transition: transition,
    rect: initialRect,
    style: {
      zIndex,
      ...style
    },
    transform: modifiedTransform
  }, children) : null));
});

/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */
function arrayMove(array, from, to) {
  const newArray = array.slice();
  newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
  return newArray;
}

function getSortedRects(items, rects) {
  return items.reduce((accumulator, id, index) => {
    const rect = rects.get(id);

    if (rect) {
      accumulator[index] = rect;
    }

    return accumulator;
  }, Array(items.length));
}

function isValidIndex(index) {
  return index !== null && index >= 0;
}

function itemsEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (a.length !== b.length) {
    return false;
  }

  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }

  return true;
}

function normalizeDisabled(disabled) {
  if (typeof disabled === 'boolean') {
    return {
      draggable: disabled,
      droppable: disabled
    };
  }

  return disabled;
}

const rectSortingStrategy = _ref => {
  let {
    rects,
    activeIndex,
    overIndex,
    index
  } = _ref;
  const newRects = arrayMove(rects, overIndex, activeIndex);
  const oldRect = rects[index];
  const newRect = newRects[index];

  if (!newRect || !oldRect) {
    return null;
  }

  return {
    x: newRect.left - oldRect.left,
    y: newRect.top - oldRect.top,
    scaleX: newRect.width / oldRect.width,
    scaleY: newRect.height / oldRect.height
  };
};

const ID_PREFIX = 'Sortable';
const Context = /*#__PURE__*/React.createContext({
  activeIndex: -1,
  containerId: ID_PREFIX,
  disableTransforms: false,
  items: [],
  overIndex: -1,
  useDragOverlay: false,
  sortedRects: [],
  strategy: rectSortingStrategy,
  disabled: {
    draggable: false,
    droppable: false
  }
});
function SortableContext(_ref) {
  let {
    children,
    id,
    items: userDefinedItems,
    strategy = rectSortingStrategy,
    disabled: disabledProp = false
  } = _ref;
  const {
    active,
    dragOverlay,
    droppableRects,
    over,
    measureDroppableContainers
  } = useDndContext();
  const containerId = useUniqueId(ID_PREFIX, id);
  const useDragOverlay = Boolean(dragOverlay.rect !== null);
  const items = useMemo(() => userDefinedItems.map(item => typeof item === 'object' && 'id' in item ? item.id : item), [userDefinedItems]);
  const isDragging = active != null;
  const activeIndex = active ? items.indexOf(active.id) : -1;
  const overIndex = over ? items.indexOf(over.id) : -1;
  const previousItemsRef = useRef(items);
  const itemsHaveChanged = !itemsEqual(items, previousItemsRef.current);
  const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
  const disabled = normalizeDisabled(disabledProp);
  useIsomorphicLayoutEffect(() => {
    if (itemsHaveChanged && isDragging) {
      measureDroppableContainers(items);
    }
  }, [itemsHaveChanged, items, isDragging, measureDroppableContainers]);
  useEffect(() => {
    previousItemsRef.current = items;
  }, [items]);
  const contextValue = useMemo(() => ({
    activeIndex,
    containerId,
    disabled,
    disableTransforms,
    items,
    overIndex,
    useDragOverlay,
    sortedRects: getSortedRects(items, droppableRects),
    strategy
  }), // eslint-disable-next-line react-hooks/exhaustive-deps
  [activeIndex, containerId, disabled.draggable, disabled.droppable, disableTransforms, items, overIndex, droppableRects, useDragOverlay, strategy]);
  return React.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

const defaultNewIndexGetter = _ref => {
  let {
    id,
    items,
    activeIndex,
    overIndex
  } = _ref;
  return arrayMove(items, activeIndex, overIndex).indexOf(id);
};
const defaultAnimateLayoutChanges = _ref2 => {
  let {
    containerId,
    isSorting,
    wasDragging,
    index,
    items,
    newIndex,
    previousItems,
    previousContainerId,
    transition
  } = _ref2;

  if (!transition || !wasDragging) {
    return false;
  }

  if (previousItems !== items && index === newIndex) {
    return false;
  }

  if (isSorting) {
    return true;
  }

  return newIndex !== index && containerId === previousContainerId;
};
const defaultTransition = {
  duration: 200,
  easing: 'ease'
};
const transitionProperty = 'transform';
const disabledTransition = /*#__PURE__*/CSS.Transition.toString({
  property: transitionProperty,
  duration: 0,
  easing: 'linear'
});
const defaultAttributes = {
  roleDescription: 'sortable'
};

/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */

function useDerivedTransform(_ref) {
  let {
    disabled,
    index,
    node,
    rect
  } = _ref;
  const [derivedTransform, setDerivedtransform] = useState(null);
  const previousIndex = useRef(index);
  useIsomorphicLayoutEffect(() => {
    if (!disabled && index !== previousIndex.current && node.current) {
      const initial = rect.current;

      if (initial) {
        const current = getClientRect(node.current, {
          ignoreTransform: true
        });
        const delta = {
          x: initial.left - current.left,
          y: initial.top - current.top,
          scaleX: initial.width / current.width,
          scaleY: initial.height / current.height
        };

        if (delta.x || delta.y) {
          setDerivedtransform(delta);
        }
      }
    }

    if (index !== previousIndex.current) {
      previousIndex.current = index;
    }
  }, [disabled, index, node, rect]);
  useEffect(() => {
    if (derivedTransform) {
      setDerivedtransform(null);
    }
  }, [derivedTransform]);
  return derivedTransform;
}

function useSortable(_ref) {
  let {
    animateLayoutChanges = defaultAnimateLayoutChanges,
    attributes: userDefinedAttributes,
    disabled: localDisabled,
    data: customData,
    getNewIndex = defaultNewIndexGetter,
    id,
    strategy: localStrategy,
    resizeObserverConfig,
    transition = defaultTransition
  } = _ref;
  const {
    items,
    containerId,
    activeIndex,
    disabled: globalDisabled,
    disableTransforms,
    sortedRects,
    overIndex,
    useDragOverlay,
    strategy: globalStrategy
  } = useContext(Context);
  const disabled = normalizeLocalDisabled(localDisabled, globalDisabled);
  const index = items.indexOf(id);
  const data = useMemo(() => ({
    sortable: {
      containerId,
      index,
      items
    },
    ...customData
  }), [containerId, customData, index, items]);
  const itemsAfterCurrentSortable = useMemo(() => items.slice(items.indexOf(id)), [items, id]);
  const {
    rect,
    node,
    isOver,
    setNodeRef: setDroppableNodeRef
  } = useDroppable({
    id,
    data,
    disabled: disabled.droppable,
    resizeObserverConfig: {
      updateMeasurementsFor: itemsAfterCurrentSortable,
      ...resizeObserverConfig
    }
  });
  const {
    active,
    activatorEvent,
    activeNodeRect,
    attributes,
    setNodeRef: setDraggableNodeRef,
    listeners,
    isDragging,
    over,
    setActivatorNodeRef,
    transform
  } = useDraggable({
    id,
    data,
    attributes: { ...defaultAttributes,
      ...userDefinedAttributes
    },
    disabled: disabled.draggable
  });
  const setNodeRef = useCombinedRefs(setDroppableNodeRef, setDraggableNodeRef);
  const isSorting = Boolean(active);
  const displaceItem = isSorting && !disableTransforms && isValidIndex(activeIndex) && isValidIndex(overIndex);
  const shouldDisplaceDragSource = !useDragOverlay && isDragging;
  const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
  const strategy = localStrategy != null ? localStrategy : globalStrategy;
  const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
    rects: sortedRects,
    activeNodeRect,
    activeIndex,
    overIndex,
    index
  }) : null;
  const newIndex = isValidIndex(activeIndex) && isValidIndex(overIndex) ? getNewIndex({
    id,
    items,
    activeIndex,
    overIndex
  }) : index;
  const activeId = active == null ? void 0 : active.id;
  const previous = useRef({
    activeId,
    items,
    newIndex,
    containerId
  });
  const itemsHaveChanged = items !== previous.current.items;
  const shouldAnimateLayoutChanges = animateLayoutChanges({
    active,
    containerId,
    isDragging,
    isSorting,
    id,
    index,
    items,
    newIndex: previous.current.newIndex,
    previousItems: previous.current.items,
    previousContainerId: previous.current.containerId,
    transition,
    wasDragging: previous.current.activeId != null
  });
  const derivedTransform = useDerivedTransform({
    disabled: !shouldAnimateLayoutChanges,
    index,
    node,
    rect
  });
  useEffect(() => {
    if (isSorting && previous.current.newIndex !== newIndex) {
      previous.current.newIndex = newIndex;
    }

    if (containerId !== previous.current.containerId) {
      previous.current.containerId = containerId;
    }

    if (items !== previous.current.items) {
      previous.current.items = items;
    }
  }, [isSorting, newIndex, containerId, items]);
  useEffect(() => {
    if (activeId === previous.current.activeId) {
      return;
    }

    if (activeId && !previous.current.activeId) {
      previous.current.activeId = activeId;
      return;
    }

    const timeoutId = setTimeout(() => {
      previous.current.activeId = activeId;
    }, 50);
    return () => clearTimeout(timeoutId);
  }, [activeId]);
  return {
    active,
    activeIndex,
    attributes,
    data,
    rect,
    index,
    newIndex,
    items,
    isOver,
    isSorting,
    isDragging,
    listeners,
    node,
    overIndex,
    over,
    setNodeRef,
    setActivatorNodeRef,
    setDroppableNodeRef,
    setDraggableNodeRef,
    transform: derivedTransform != null ? derivedTransform : finalTransform,
    transition: getTransition()
  };

  function getTransition() {
    if ( // Temporarily disable transitions for a single frame to set up derived transforms
    derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
    itemsHaveChanged && previous.current.newIndex === index) {
      return disabledTransition;
    }

    if (shouldDisplaceDragSource && !isKeyboardEvent(activatorEvent) || !transition) {
      return undefined;
    }

    if (isSorting || shouldAnimateLayoutChanges) {
      return CSS.Transition.toString({ ...transition,
        property: transitionProperty
      });
    }

    return undefined;
  }
}

function normalizeLocalDisabled(localDisabled, globalDisabled) {
  var _localDisabled$dragga, _localDisabled$droppa;

  if (typeof localDisabled === 'boolean') {
    return {
      draggable: localDisabled,
      // Backwards compatibility
      droppable: false
    };
  }

  return {
    draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
    droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
  };
}

function hasSortableData(entry) {
  if (!entry) {
    return false;
  }

  const data = entry.data.current;

  if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) {
    return true;
  }

  return false;
}

const directions = [KeyboardCode.Down, KeyboardCode.Right, KeyboardCode.Up, KeyboardCode.Left];
const sortableKeyboardCoordinates = (event, _ref) => {
  let {
    context: {
      active,
      collisionRect,
      droppableRects,
      droppableContainers,
      over,
      scrollableAncestors
    }
  } = _ref;

  if (directions.includes(event.code)) {
    event.preventDefault();

    if (!active || !collisionRect) {
      return;
    }

    const filteredContainers = [];
    droppableContainers.getEnabled().forEach(entry => {
      if (!entry || entry != null && entry.disabled) {
        return;
      }

      const rect = droppableRects.get(entry.id);

      if (!rect) {
        return;
      }

      switch (event.code) {
        case KeyboardCode.Down:
          if (collisionRect.top < rect.top) {
            filteredContainers.push(entry);
          }

          break;

        case KeyboardCode.Up:
          if (collisionRect.top > rect.top) {
            filteredContainers.push(entry);
          }

          break;

        case KeyboardCode.Left:
          if (collisionRect.left > rect.left) {
            filteredContainers.push(entry);
          }

          break;

        case KeyboardCode.Right:
          if (collisionRect.left < rect.left) {
            filteredContainers.push(entry);
          }

          break;
      }
    });
    const collisions = closestCorners({
      active,
      collisionRect: collisionRect,
      droppableRects,
      droppableContainers: filteredContainers,
      pointerCoordinates: null
    });
    let closestId = getFirstCollision(collisions, 'id');

    if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) {
      closestId = collisions[1].id;
    }

    if (closestId != null) {
      const activeDroppable = droppableContainers.get(active.id);
      const newDroppable = droppableContainers.get(closestId);
      const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
      const newNode = newDroppable == null ? void 0 : newDroppable.node.current;

      if (newNode && newRect && activeDroppable && newDroppable) {
        const newScrollAncestors = getScrollableAncestors(newNode);
        const hasDifferentScrollAncestors = newScrollAncestors.some((element, index) => scrollableAncestors[index] !== element);
        const hasSameContainer = isSameContainer(activeDroppable, newDroppable);
        const isAfterActive = isAfter(activeDroppable, newDroppable);
        const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
          x: 0,
          y: 0
        } : {
          x: isAfterActive ? collisionRect.width - newRect.width : 0,
          y: isAfterActive ? collisionRect.height - newRect.height : 0
        };
        const rectCoordinates = {
          x: newRect.left,
          y: newRect.top
        };
        const newCoordinates = offset.x && offset.y ? rectCoordinates : subtract(rectCoordinates, offset);
        return newCoordinates;
      }
    }
  }

  return undefined;
};

function isSameContainer(a, b) {
  if (!hasSortableData(a) || !hasSortableData(b)) {
    return false;
  }

  return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}

function isAfter(a, b) {
  if (!hasSortableData(a) || !hasSortableData(b)) {
    return false;
  }

  if (!isSameContainer(a, b)) {
    return false;
  }

  return a.data.current.sortable.index < b.data.current.sortable.index;
}

var call = functionCall;
var hasOwn = hasOwnProperty_1;
var isPrototypeOf = objectIsPrototypeOf;
var regExpFlags = regexpFlags$1;

var RegExpPrototype$1 = RegExp.prototype;

var regexpGetFlags = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype$1) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype$1, R)
    ? call(regExpFlags, R) : flags;
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var defineBuiltIn = defineBuiltIn$8;
var anObject = anObject$f;
var $toString = toString$9;
var fails = fails$o;
var getRegExpFlags = regexpGetFlags;

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExpPrototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}

const SortableItem$1 = /*#__PURE__*/styled.li.withConfig({
  displayName: "sortable-itemstyles__SortableItem",
  componentId: "sc-118uhkx-0"
})(["list-style:none;"]);
const DragHandle$1 = /*#__PURE__*/styled.button.withConfig({
  displayName: "sortable-itemstyles__DragHandle",
  componentId: "sc-118uhkx-1"
})(["background:transparent;cursor:pointer;width:100%;height:100%;padding:0;"]);
const S$1 = {
  SortableItem: SortableItem$1,
  DragHandle: DragHandle$1
};

const SortableItemContext = /*#__PURE__*/createContext({
  attributes: {},
  listeners: undefined,
  ref: undefined
});
function SortableItem({
  children,
  id
}) {
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition
  } = useSortable({
    id
  });
  const context = useMemo(() => ({
    attributes,
    listeners,
    ref: setActivatorNodeRef
  }), [attributes, listeners, setActivatorNodeRef]);
  const style = {
    opacity: isDragging ? 0.4 : undefined,
    transform: CSS.Translate.toString(transform),
    transition
  };
  return jsx(SortableItemContext.Provider, {
    value: context,
    children: jsx(S$1.SortableItem, {
      className: "SortableItem",
      ref: setNodeRef,
      style: style,
      children: children
    })
  });
}
function DragHandle(props) {
  const {
    children
  } = props;
  const {
    attributes,
    listeners,
    ref
  } = useContext(SortableItemContext);
  return jsx(S$1.DragHandle, Object.assign({}, attributes, listeners, {
    ref: ref,
    children: children
  }));
}

const dropAnimationConfig = {
  sideEffects: defaultDropAnimationSideEffects({
    styles: {
      active: {
        opacity: '0.4'
      }
    }
  })
};
function SortableOverlay({
  children
}) {
  return jsx(DragOverlay, {
    dropAnimation: dropAnimationConfig,
    children: children
  });
}

const SortableList$1 = /*#__PURE__*/styled.ul.withConfig({
  displayName: "sortable-liststyles__SortableList",
  componentId: "sc-io2lc9-0"
})(["display:flex;flex-direction:column;gap:10px;padding:0;list-style:none;width:100%;"]);
const S = {
  SortableList: SortableList$1
};

function SortableList({
  items,
  onChange,
  renderItem,
  style
}) {
  const [active, setActive] = useState(null);
  const activeItem = useMemo(() => items.find(item => item.id === (active === null || active === void 0 ? void 0 : active.id)), [active, items]);
  const activeItemIndex = useMemo(() => items.findIndex(item => item.id === (active === null || active === void 0 ? void 0 : active.id)), [active, items]);
  const sensors = useSensors(useSensor(PointerSensor), useSensor(KeyboardSensor, {
    coordinateGetter: sortableKeyboardCoordinates
  }));
  return jsxs(DndContext, {
    sensors: sensors,
    onDragStart: ({
      active
    }) => {
      setActive(active);
    },
    onDragEnd: ({
      active,
      over
    }) => {
      if (over && active.id !== (over === null || over === void 0 ? void 0 : over.id)) {
        const activeIndex = items.findIndex(({
          id
        }) => id === active.id);
        const overIndex = items.findIndex(({
          id
        }) => id === over.id);
        onChange(arrayMove(items, activeIndex, overIndex));
      }
      setActive(null);
    },
    onDragCancel: () => {
      setActive(null);
    },
    children: [jsx(SortableContext, {
      items: items,
      children: jsx(S.SortableList, {
        className: "SortableList",
        role: "application",
        style: style,
        children: items.map((item, index) => jsx(React.Fragment, {
          children: renderItem(item, index)
        }, item.id))
      })
    }), jsx(SortableOverlay, {
      children: activeItem ? renderItem(activeItem, activeItemIndex) : null
    })]
  });
}
SortableList.Item = SortableItem;
SortableList.DragHandle = DragHandle;

export { AntdDatePickerExtension, Avatar, UserAvatar as AvatarV2, CardV2, Checkbox, CheckboxGroup, Collapse, Container$1 as Container, CountrySelector, DEFAULT_PAGE_SIZE, DatePicker, DatePickerDayJs, DirectUpload, DropDownMenu, DropdownPicker, DropdownSelect, Elevator, ElevatorLayout, Ellipsis, EmptyContent, ErrorPlaceholder, Examples, FormCountrySelector, FormCurrencyInput, FormDatePicker, FormDropdownRadioGroup, FormPricingInput, FormRadioGroup, FormRegionSelector, FormSSNInput, FormSelect, FormTelInput, FormTextInput, FormTextarea, FormTimeInput, FullWidthTable, Heading, HideChildrenWhenFlagOn, HubspotForm, Indicator, InlineNote, Input$3 as Input, ListSearchInput, LoadingPlaceholder, ManualUpload, Menu, MultiSelect, Notification, NumberInput, OPTION_ALL_VALUE, Pagination$1 as Pagination, Pagination as PaginationNew, PaywallModal, Popover, Progress, ProgressBar, ProgressItem, Radio, RangePicker, RegionSelector, SSNInput, SearchInput, Select$1 as Select, ServerSideMultiSelect, SlidingPane, SortableList, Switch, Table$1 as Table, Table as TableNew, TelInput, TextArea$1 as TextArea, TextAreaGrow, TreeSelect, Upload, UserAvatar, WarnButton, createFullWidthTable, createTable, maxWidthMixin, openToast };
